/*
 * @license
 * Broadcast Theme (c) Invisible Themes
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */
!(function (t, e, s, i, o, n, r) {
  "use strict";
  function a(t) {
    t.querySelectorAll(".form-field").forEach((t) => {
      const e = t.querySelector("label"),
        s = t.querySelector("input, textarea");
      e &&
        s &&
        (s.addEventListener("keyup", (t) => {
          "" !== t.target.value
            ? e.classList.add("label--float")
            : e.classList.remove("label--float");
        }),
        s.value && s.value.length && e.classList.add("label--float"));
    });
  }
  !(function () {
    const t = { NODE_ENV: "production" };
    try {
      if (process)
        return (
          (process.env = Object.assign({}, process.env)),
          void Object.assign(process.env, t)
        );
    } catch (t) {}
    globalThis.process = { env: t };
  })(),
    (window.theme = window.theme || {}),
    (window.theme.sizes = {
      mobile: 480,
      small: 750,
      large: 990,
      widescreen: 1400,
    }),
    (window.theme.focusable =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  let l = p();
  function c() {
    const t = {};
    return (
      (t.windowHeight = Math.min(window.screen.height, window.innerHeight)),
      (t.footerHeight = m('[data-section-type*="footer"]')),
      (t.headerHeight = m("[data-header-height]")),
      (t.stickyHeaderHeight = document.querySelector("[data-header-sticky]")
        ? t.headerHeight
        : 0),
      (t.collectionNavHeight = m("[data-collection-nav]")),
      (t.logoHeight = (function () {
        const t = m("[data-footer-logo]");
        return t > 0 ? t + 20 : 0;
      })()),
      t
    );
  }
  function h() {
    document.addEventListener("theme:resize", u), d();
  }
  function d() {
    const {
      windowHeight: t,
      headerHeight: e,
      logoHeight: s,
      footerHeight: i,
      collectionNavHeight: o,
    } = c();
    document.documentElement.style.setProperty("--full-height", `${t}px`),
      document.documentElement.style.setProperty(
        "--three-quarters",
        t * (3 / 4) + "px"
      ),
      document.documentElement.style.setProperty(
        "--two-thirds",
        t * (2 / 3) + "px"
      ),
      document.documentElement.style.setProperty("--one-half", t / 2 + "px"),
      document.documentElement.style.setProperty("--one-third", t / 3 + "px"),
      document.documentElement.style.setProperty(
        "--collection-nav-height",
        `${o}px`
      ),
      document.documentElement.style.setProperty("--header-height", `${e}px`),
      document.documentElement.style.setProperty("--footer-height", `${i}px`),
      document.documentElement.style.setProperty(
        "--content-full",
        t - e - s / 2 + "px"
      ),
      document.documentElement.style.setProperty(
        "--content-min",
        t - e - i + "px"
      ),
      document.querySelector("[data-tracking-consent].popup-cookies--bottom") &&
        document.documentElement.style.setProperty(
          "--cookie-bar-height",
          `${
            document.querySelector(
              "[data-tracking-consent].popup-cookies--bottom"
            ).offsetHeight
          }px`
        );
  }
  function u() {
    const {
        windowHeight: t,
        headerHeight: e,
        logoHeight: s,
        footerHeight: i,
        collectionNavHeight: o,
      } = c(),
      n = p();
    (n !== l || window.innerWidth > window.theme.sizes.mobile) &&
      (document.documentElement.style.setProperty("--full-height", `${t}px`),
      document.documentElement.style.setProperty(
        "--three-quarters",
        t * (3 / 4) + "px"
      ),
      document.documentElement.style.setProperty(
        "--two-thirds",
        t * (2 / 3) + "px"
      ),
      document.documentElement.style.setProperty("--one-half", t / 2 + "px"),
      document.documentElement.style.setProperty("--one-third", t / 3 + "px"),
      (l = n)),
      document.documentElement.style.setProperty(
        "--collection-nav-height",
        `${o}px`
      ),
      document.documentElement.style.setProperty("--header-height", `${e}px`),
      document.documentElement.style.setProperty("--footer-height", `${i}px`),
      document.documentElement.style.setProperty(
        "--content-full",
        t - e - s / 2 + "px"
      ),
      document.documentElement.style.setProperty(
        "--content-min",
        t - e - i + "px"
      ),
      document.querySelector("[data-tracking-consent].popup-cookies--bottom") &&
        document.documentElement.style.setProperty(
          "--cookie-bar-height",
          `${
            document.querySelector(
              "[data-tracking-consent].popup-cookies--bottom"
            ).offsetHeight
          }px`
        );
  }
  function p() {
    return window.matchMedia("(orientation: portrait)").matches
      ? "portrait"
      : window.matchMedia("(orientation: landscape)").matches
      ? "landscape"
      : void 0;
  }
  function m(t) {
    const e = document.querySelector(t);
    return e ? e.offsetHeight : 0;
  }
  function v(t, e) {
    let s;
    return function () {
      if (t) {
        const i = () => t.apply(this, arguments);
        clearTimeout(s), (s = setTimeout(i, e));
      }
    };
  }
  function g() {
    return (
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth
    );
  }
  function f() {
    return (
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight
    );
  }
  function y() {
    return g() >= window.theme.sizes.small;
  }
  function b() {
    return g() < window.theme.sizes.small;
  }
  window.initialWindowHeight = Math.min(
    window.screen.height,
    window.innerHeight
  );
  let w = g(),
    E = f();
  let S = window.scrollY,
    L = null,
    k = null,
    A = null,
    T = null,
    C = 0;
  function q(e) {
    setTimeout(() => {
      C && clearTimeout(C),
        t.disablePageScroll(e.detail, {
          allowTouchMove: (t) => "TEXTAREA" === t.tagName,
        }),
        document.documentElement.setAttribute("data-scroll-locked", "");
    });
  }
  function x(t) {
    const e = t.detail;
    e ? (C = setTimeout(M, e)) : M();
  }
  function M() {
    t.clearQueueScrollLocks(),
      t.enablePageScroll(),
      document.documentElement.removeAttribute("data-scroll-locked");
  }
  const P = (t, e = "", s) => {
    const i = s || document.createElement("div");
    return (
      i.classList.add(e), t.parentNode.insertBefore(i, t), i.appendChild(t)
    );
  };
  function H(t) {
    t.querySelectorAll(".rte table").forEach((t) => {
      P(t, "rte__table-wrapper"),
        t.setAttribute("data-scroll-lock-scrollable", "");
    });
    t.querySelectorAll(
      '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe'
    ).forEach((t) => {
      P(t, "rte__video-wrapper");
    });
  }
  function I(t) {
    const e = t.querySelectorAll("[data-aria-toggle]");
    e.length &&
      e.forEach((t) => {
        t.addEventListener("click", function (t) {
          t.preventDefault();
          const e = t.currentTarget;
          e.setAttribute(
            "aria-expanded",
            "false" == e.getAttribute("aria-expanded") ? "true" : "false"
          );
          const s = e.getAttribute("aria-controls"),
            i = document.querySelector(`#${s}`),
            o = () => {
              i.classList.remove("expanding"),
                i.removeEventListener("transitionend", o);
            },
            n = () => {
              i.classList.add("expanding"),
                i.removeEventListener("transitionstart", n);
            };
          i.addEventListener("transitionstart", n),
            i.addEventListener("transitionend", o),
            i.classList.toggle("expanded");
        });
      });
  }
  const B = "is-loading",
    O = "img.is-loading";
  function F(t, e) {
    e = e || {};
    var s = t.tabIndex;
    (t.tabIndex = -1),
      (t.dataset.tabIndex = s),
      t.focus(),
      void 0 !== e.className && t.classList.add(e.className),
      t.addEventListener("blur", function i(o) {
        o.target.removeEventListener(o.type, i),
          (t.tabIndex = s),
          delete t.dataset.tabIndex,
          void 0 !== e.className && t.classList.remove(e.className);
      });
  }
  function D(t) {
    return Array.prototype.slice
      .call(
        t.querySelectorAll(
          "[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled"
        )
      )
      .filter(function (t) {
        return !(
          !(t.offsetWidth || t.offsetHeight || t.getClientRects().length) ||
          ((e = t),
          (s = window.getComputedStyle(e)),
          "none" === s.display || "hidden" === s.visibility)
        );
        var e, s;
      });
  }
  var $ = {};
  function _() {
    document.removeEventListener("focusin", $.focusin),
      document.removeEventListener("focusout", $.focusout),
      document.removeEventListener("keydown", $.keydown);
  }
  var N = Object.freeze({
    __proto__: null,
    forceFocus: F,
    focusHash: function (t) {
      t = t || {};
      var e = window.location.hash,
        s = document.getElementById(e.slice(1));
      if (s && t.ignore && s.matches(t.ignore)) return !1;
      e && s && F(s, t);
    },
    bindInPageLinks: function (t) {
      return (
        (t = t || {}),
        Array.prototype.slice
          .call(document.querySelectorAll('a[href^="#"]'))
          .filter(function (e) {
            if ("#" === e.hash || "" === e.hash) return !1;
            if (t.ignore && e.matches(t.ignore)) return !1;
            if (((s = e.hash.substr(1)), null === document.getElementById(s)))
              return !1;
            var s,
              i = document.querySelector(e.hash);
            return (
              !!i &&
              (e.addEventListener("click", function () {
                F(i, t);
              }),
              !0)
            );
          })
      );
    },
    focusable: D,
    trapFocus: function (t, e) {
      e = e || {};
      var s = D(t),
        i = e.elementToFocus || t,
        o = s[0],
        n = s[s.length - 1];
      _(),
        ($.focusin = function (e) {
          t !== e.target &&
            !t.contains(e.target) &&
            o &&
            o === e.target &&
            o.focus(),
            (e.target !== t && e.target !== n && e.target !== o) ||
              document.addEventListener("keydown", $.keydown);
        }),
        ($.focusout = function () {
          document.removeEventListener("keydown", $.keydown);
        }),
        ($.keydown = function (e) {
          "Tab" === e.code &&
            (e.target !== n || e.shiftKey || (e.preventDefault(), o.focus()),
            (e.target !== t && e.target !== o) ||
              !e.shiftKey ||
              (e.preventDefault(), n.focus()));
        }),
        document.addEventListener("focusout", $.focusout),
        document.addEventListener("focusin", $.focusin),
        F(i, e);
    },
    removeTrapFocus: _,
    autoFocusLastElement: function () {
      window.accessibility.lastElement &&
        document.body.classList.contains("is-focused") &&
        setTimeout(() => {
          var t;
          null === (t = window.accessibility.lastElement) ||
            void 0 === t ||
            t.focus();
        });
    },
    accessibleLinks: function (t, e) {
      if ("string" != typeof t) throw new TypeError(t + " is not a String.");
      if (0 !== (t = document.querySelectorAll(t)).length) {
        (e = e || {}).messages = e.messages || {};
        var s,
          i,
          o,
          n = {
            newWindow: e.messages.newWindow || "Opens in a new window.",
            external: e.messages.external || "Opens external website.",
            newWindowExternal:
              e.messages.newWindowExternal ||
              "Opens external website in a new window.",
          },
          r = e.prefix || "a11y",
          a = {
            newWindow: r + "-new-window-message",
            external: r + "-external-message",
            newWindowExternal: r + "-new-window-external-message",
          };
        t.forEach(function (t) {
          var e = t.getAttribute("target"),
            s = t.getAttribute("rel"),
            i = (function (t) {
              return t.hostname !== window.location.hostname;
            })(t),
            o = "_blank" === e,
            n = null === s || -1 === s.indexOf("noopener");
          if (o && n) {
            var r = null === s ? "noopener" : s + " noopener";
            t.setAttribute("rel", r);
          }
          i && o
            ? t.setAttribute("aria-describedby", a.newWindowExternal)
            : i
            ? t.setAttribute("aria-describedby", a.external)
            : o && t.setAttribute("aria-describedby", a.newWindow);
        }),
          (s = n),
          (i = document.createElement("ul")),
          (o = Object.keys(s).reduce(function (t, e) {
            return t + "<li id=" + a[e] + ">" + s[e] + "</li>";
          }, "")),
          i.setAttribute("hidden", !0),
          (i.innerHTML = o),
          document.body.appendChild(i);
      }
    },
  });
  const R = 'input[type="search"]',
    U = '[aria-selected="true"] a',
    z = 'button[type="reset"]',
    W = "hidden";
  let V = class extends HTMLElement {
    toggleResetButton() {
      const t = this.resetButton.classList.contains(W);
      this.input.value.length > 0 && t
        ? this.resetButton.classList.remove(W)
        : 0 !== this.input.value.length ||
          t ||
          this.resetButton.classList.add(W);
    }
    onChange() {
      this.toggleResetButton();
    }
    shouldResetForm() {
      return !document.querySelector(U);
    }
    onFormReset(t) {
      t.preventDefault(),
        this.shouldResetForm() &&
          ((this.input.value = ""),
          this.toggleResetButton(),
          t.target.querySelector(R).focus());
    }
    constructor() {
      super(),
        (this.input = this.querySelector(R)),
        (this.resetButton = this.querySelector(z)),
        this.input &&
          (this.input.form.addEventListener(
            "reset",
            this.onFormReset.bind(this)
          ),
          this.input.addEventListener(
            "input",
            v((t) => {
              this.onChange(t);
            }, 300).bind(this)
          ));
    }
  };
  customElements.define("header-search-form", V);
  const j = '[role="option"]',
    X = '[aria-selected="true"]',
    J = "[data-popular-searches]",
    Y = "predictive-search",
    Q = "[data-predictive-search-results]",
    G = "[data-predictive-search-status]",
    K = 'input[type="search"]',
    Z = "[data-popdown]",
    tt = "[data-predictive-search-live-region-count-value]",
    et = "[data-search-results-groups-wrapper]",
    st = "[data-predictive-search-search-for-text]",
    it = "#shopify-section-predictive-search",
    ot = '[aria-selected="true"] a',
    nt = '[aria-selected="true"] a, button[aria-selected="true"]';
  let rt = class extends V {
    connectedCallback() {
      this.input.addEventListener("focus", this.onFocus.bind(this)),
        this.input.form.addEventListener(
          "submit",
          this.onFormSubmit.bind(this)
        ),
        this.addEventListener("focusout", this.onFocusOut.bind(this)),
        this.addEventListener("keyup", this.onKeyup.bind(this)),
        this.addEventListener("keydown", this.onKeydown.bind(this));
    }
    getQuery() {
      return this.input.value.trim();
    }
    onChange() {
      super.onChange();
      const t = this.getQuery();
      var e;
      (this.searchTerm && t.startsWith(this.searchTerm)) ||
        null === (e = this.querySelector(et)) ||
        void 0 === e ||
        e.remove();
      this.updateSearchForTerm(this.searchTerm, t),
        (this.searchTerm = t),
        this.searchTerm.length
          ? this.getSearchResults(this.searchTerm)
          : this.reset();
    }
    onFormSubmit(t) {
      (this.getQuery().length && !this.querySelector(ot)) || t.preventDefault();
    }
    onFormReset(t) {
      super.onFormReset(t),
        super.shouldResetForm() &&
          ((this.searchTerm = ""),
          this.abortController.abort(),
          (this.abortController = new AbortController()),
          this.closeResults(!0));
    }
    shouldResetForm() {
      return !document.querySelector(ot);
    }
    onFocus() {
      const t = this.getQuery();
      t.length &&
        (this.searchTerm !== t
          ? this.onChange()
          : "true" === this.getAttribute("results")
          ? this.open()
          : this.getSearchResults(this.searchTerm));
    }
    onFocusOut() {
      setTimeout(() => {
        this.contains(document.activeElement) || this.close();
      });
    }
    onKeyup(t) {
      switch (
        (this.getQuery().length || this.close(!0), t.preventDefault(), t.code)
      ) {
        case "ArrowUp":
          this.switchOption("up");
          break;
        case "ArrowDown":
          this.switchOption("down");
          break;
        case "Enter":
          this.selectOption();
      }
    }
    onKeydown(t) {
      ("ArrowUp" !== t.code && "ArrowDown" !== t.code) || t.preventDefault();
    }
    updateSearchForTerm(t, e) {
      const s = this.querySelector(st),
        i = null == s ? void 0 : s.innerText;
      if (i) {
        var o;
        if (
          (null === (o = i.match(new RegExp(t, "g"))) || void 0 === o
            ? void 0
            : o.length) > 1
        )
          return;
        const n = i.replace(t, e);
        s.innerText = n;
      }
    }
    switchOption(t) {
      if (!this.getAttribute("open")) return;
      const e = "up" === t,
        s = this.querySelector(X),
        i = Array.from(this.querySelectorAll(j)).filter(
          (t) => null !== t.offsetParent
        );
      let o = 0;
      if (e && !s) return;
      let n = -1,
        r = 0;
      for (; -1 === n && r <= i.length; ) i[r] === s && (n = r), r++;
      if (
        ((this.statusElement.textContent = ""),
        !e && s
          ? (o = n === i.length - 1 ? 0 : n + 1)
          : e && (o = 0 === n ? i.length - 1 : n - 1),
        o === n)
      )
        return;
      const a = i[o];
      a.setAttribute("aria-selected", !0),
        s && s.setAttribute("aria-selected", !1),
        this.input.setAttribute("aria-activedescendant", a.id);
    }
    selectOption() {
      const t = this.querySelector(nt);
      t && t.click();
    }
    getSearchResults(t) {
      const e = t.replace(" ", "-").toLowerCase();
      this.setLiveRegionLoadingState(),
        this.cachedResults[e]
          ? this.renderSearchResults(this.cachedResults[e])
          : fetch(
              `${theme.routes.predictive_search_url}?q=${encodeURIComponent(
                t
              )}&section_id=predictive-search`,
              { signal: this.abortController.signal }
            )
              .then((t) => {
                if (!t.ok) {
                  var e = new Error(t.status);
                  throw (this.close(), e);
                }
                return t.text();
              })
              .then((t) => {
                const s = new DOMParser()
                  .parseFromString(t, "text/html")
                  .querySelector(it).innerHTML;
                this.allPredictiveSearchInstances.forEach((t) => {
                  t.cachedResults[e] = s;
                }),
                  this.renderSearchResults(s);
              })
              .catch((t) => {
                if (20 !== (null == t ? void 0 : t.code))
                  throw (this.close(), t);
              });
    }
    setLiveRegionLoadingState() {
      (this.statusElement = this.statusElement || this.querySelector(G)),
        (this.loadingText =
          this.loadingText || this.getAttribute("data-loading-text")),
        this.setLiveRegionText(this.loadingText),
        this.setAttribute("loading", !0);
    }
    setLiveRegionText(t) {
      this.statusElement.setAttribute("aria-hidden", "false"),
        (this.statusElement.textContent = t),
        setTimeout(() => {
          this.statusElement.setAttribute("aria-hidden", "true");
        }, 1e3);
    }
    renderSearchResults(t) {
      (this.predictiveSearchResults.innerHTML = t),
        this.setAttribute("results", !0),
        this.setLiveRegionResults(),
        this.open();
    }
    setLiveRegionResults() {
      this.removeAttribute("loading"),
        this.setLiveRegionText(this.querySelector(tt).textContent);
    }
    open() {
      this.setAttribute("open", !0),
        this.input.setAttribute("aria-expanded", !0),
        (this.isOpen = !0);
    }
    close(t = !1) {
      this.closeResults(t), (this.isOpen = !1);
    }
    closeResults(t = !1) {
      var e;
      t && ((this.input.value = ""), this.removeAttribute("results"));
      const s = this.querySelector(X);
      s && s.setAttribute("aria-selected", !1),
        this.input.setAttribute("aria-activedescendant", ""),
        this.removeAttribute("loading"),
        this.removeAttribute("open"),
        this.input.setAttribute("aria-expanded", !1),
        null === (e = this.predictiveSearchResults) ||
          void 0 === e ||
          e.removeAttribute("style");
    }
    reset() {
      (this.predictiveSearchResults.innerHTML = ""),
        (this.input.val = ""),
        this.a11y.removeTrapFocus(),
        this.popularSearches &&
          (this.input.dispatchEvent(new Event("blur", { bubbles: !1 })),
          this.a11y.trapFocus(this.searchPopdown, {
            elementToFocus: this.input,
          }));
    }
    constructor() {
      var t;
      super(),
        (this.a11y = N),
        (this.abortController = new AbortController()),
        (this.allPredictiveSearchInstances = document.querySelectorAll(Y)),
        (this.cachedResults = {}),
        (this.input = this.querySelector(K)),
        (this.isOpen = !1),
        (this.predictiveSearchResults = this.querySelector(Q)),
        (this.searchPopdown = this.closest(Z)),
        (this.popularSearches =
          null === (t = this.searchPopdown) || void 0 === t
            ? void 0
            : t.querySelector(J)),
        (this.searchTerm = "");
    }
  };
  const at = "[data-popout-list]",
    lt = "[data-popout-toggle]",
    ct = "[data-popout-toggle-text]",
    ht = "[data-popout-input]",
    dt = "[data-popout-option]",
    ut = "[data-product-image]",
    pt = "[data-grid-item]",
    mt = "popout-list--visible",
    vt = "is-visible",
    gt = "is-active",
    ft = "select-popout--top",
    yt = "aria-expanded",
    bt = "aria-current",
    wt = "data-value",
    Et = "data-popout-toggle-text",
    St = "submit";
  let Lt = class extends HTMLElement {
      connectedCallback() {
        (this.popoutList = this.querySelector(at)),
          (this.popoutToggle = this.querySelector(lt)),
          (this.popoutToggleText = this.querySelector(ct)),
          (this.popoutInput = this.querySelector(ht)),
          (this.popoutOptions = this.querySelectorAll(dt)),
          (this.productGridItem = this.popoutList.closest(pt)),
          (this.fireSubmitEvent = this.hasAttribute(St)),
          (this.popupToggleFocusoutEvent = (t) =>
            this.onPopupToggleFocusout(t)),
          (this.popupListFocusoutEvent = (t) => this.onPopupListFocusout(t)),
          (this.popupToggleClickEvent = (t) => this.onPopupToggleClick(t)),
          (this.keyUpEvent = (t) => this.onKeyUp(t)),
          (this.bodyClickEvent = (t) => this.onBodyClick(t)),
          this._connectOptions(),
          this._connectToggle(),
          this._onFocusOut(),
          this.popupListMaxWidth();
      }
      onPopupToggleClick(t) {
        const e = "true" === t.currentTarget.getAttribute(yt);
        if (this.productGridItem) {
          const t = this.productGridItem.querySelector(ut);
          t && t.classList.toggle(vt, !e),
            (this.popoutList.style.maxHeight = `${Math.abs(
              this.popoutToggle.getBoundingClientRect().bottom -
                this.productGridItem.getBoundingClientRect().bottom
            )}px`);
        }
        t.currentTarget.setAttribute(yt, !e),
          this.popoutList.classList.toggle(mt),
          this.popupListMaxWidth(),
          this.toggleListPosition(),
          document.body.addEventListener("click", this.bodyClickEvent);
      }
      onPopupToggleFocusout(t) {
        this.contains(t.relatedTarget) || this._hideList();
      }
      onPopupListFocusout(t) {
        const e = t.currentTarget.contains(t.relatedTarget);
        this.popoutList.classList.contains(mt) && !e && this._hideList();
      }
      toggleListPosition() {
        const t = "true" === this.querySelector(lt).getAttribute(yt),
          e = window.innerHeight,
          s = this.popoutList.getBoundingClientRect().bottom,
          i = () => {
            this.classList.remove(ft),
              this.popoutList.removeEventListener("transitionend", i);
          };
        t
          ? e < s && this.classList.add(ft)
          : this.popoutList.addEventListener("transitionend", i);
      }
      popupListMaxWidth() {
        this.popoutList.style.setProperty("--max-width", "100vw"),
          requestAnimationFrame(() => {
            this.popoutList.style.setProperty(
              "--max-width",
              `${parseInt(
                document.body.clientWidth -
                  this.popoutList.getBoundingClientRect().left
              )}px`
            );
          });
      }
      popupOptionsClick(t) {
        if ("#" === t.target.closest(dt).attributes.href.value) {
          t.preventDefault();
          const e = t.currentTarget.hasAttribute(wt)
            ? t.currentTarget.getAttribute(wt)
            : "";
          if (
            ((this.popoutInput.value = e),
            this.popoutInput.disabled &&
              this.popoutInput.removeAttribute("disabled"),
            this.fireSubmitEvent)
          )
            this._submitForm(e);
          else {
            const s = t.currentTarget.parentElement,
              i = this.popoutList.querySelector(`.${gt}`),
              o = this.popoutList.querySelector(`[${bt}]`);
            this.popoutInput.dispatchEvent(new Event("change")),
              i && (i.classList.remove(gt), s.classList.add(gt)),
              "quantity" != this.popoutInput.name ||
                s.nextSibling ||
                this.classList.add(gt),
              o &&
                o.hasAttribute(`${bt}`) &&
                (o.removeAttribute(`${bt}`),
                t.currentTarget.setAttribute(`${bt}`, "true")),
              "" !== e &&
                ((this.popoutToggleText.innerHTML = e),
                this.popoutToggleText.hasAttribute(Et) &&
                  "" !== this.popoutToggleText.getAttribute(Et) &&
                  this.popoutToggleText.setAttribute(Et, e)),
              this.onPopupToggleFocusout(t),
              this.onPopupListFocusout(t);
          }
        }
      }
      onKeyUp(t) {
        "Escape" === t.code && (this._hideList(), this.popoutToggle.focus());
      }
      onBodyClick(t) {
        const e = this.contains(t.target);
        this.popoutList.classList.contains(mt) && !e && this._hideList();
      }
      _connectToggle() {
        this.popoutToggle.addEventListener("click", this.popupToggleClickEvent);
      }
      _connectOptions() {
        this.popoutOptions.length &&
          this.popoutOptions.forEach((t) => {
            t.addEventListener("click", (t) => this.popupOptionsClick(t));
          });
      }
      _onFocusOut() {
        this.addEventListener("keyup", this.keyUpEvent),
          this.popoutToggle.addEventListener(
            "focusout",
            this.popupToggleFocusoutEvent
          ),
          this.popoutList.addEventListener(
            "focusout",
            this.popupListFocusoutEvent
          );
      }
      _submitForm() {
        const t = this.closest("form");
        t && t.submit();
      }
      _hideList() {
        this.popoutList.classList.remove(mt),
          this.popoutToggle.setAttribute(yt, !1),
          this.toggleListPosition(),
          document.body.removeEventListener("click", this.bodyClickEvent);
      }
      constructor() {
        super();
      }
    },
    kt = class extends HTMLElement {
      connectedCallback() {
        (this.input = this.querySelector("input")),
          (this.changeEvent = new Event("change", { bubbles: !0 })),
          (this.buttonClickEvent = this.onButtonClick.bind(this)),
          (this.onQuantityChangeEvent = this.onQuantityChange.bind(this)),
          this.input.addEventListener("change", this.onQuantityChangeEvent),
          this.querySelectorAll("button").forEach((t) =>
            t.addEventListener("click", this.buttonClickEvent)
          );
      }
      onButtonClick(t) {
        t.preventDefault();
        const e = this.input.value,
          s =
            "BUTTON" == t.target.nodeName
              ? t.target
              : t.target.closest("button");
        "increase" === s.name && this.input.stepUp(),
          "decrease" === s.name && this.input.stepDown(),
          e !== this.input.value && this.input.dispatchEvent(this.changeEvent);
      }
      onQuantityChange() {
        "updates[]" == this.input.name && this.updateCart();
      }
      updateCart() {
        "" !== this.quantityValue &&
          this.dispatchEvent(
            new CustomEvent("theme:cart:update", {
              bubbles: !0,
              detail: { id: this.input.dataset.id, quantity: this.input.value },
            })
          );
      }
      constructor() {
        super();
      }
    };
  const At = "[data-aos]:not(.aos-animate)",
    Tt = "[data-aos-anchor]",
    Ct = "aos-animate",
    qt = { attributes: !1, childList: !0, subtree: !0 };
  let xt = [];
  const Mt = (t) => {
      for (const e of t)
        if ("childList" === e.type) {
          const t = e.target,
            s = t.querySelectorAll(At),
            i = t.querySelectorAll(Tt);
          s.length &&
            s.forEach((t) => {
              Pt.observe(t);
            }),
            i.length && It(i);
        }
    },
    Pt = new IntersectionObserver(
      (t, e) => {
        t.forEach((t) => {
          t.isIntersecting &&
            (t.target.classList.add(Ct), e.unobserve(t.target));
        });
      },
      { root: null, rootMargin: "0px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
    ),
    Ht = new IntersectionObserver(
      (t, e) => {
        t.forEach((t) => {
          if (t.intersectionRatio) {
            const s = t.target.querySelectorAll(At);
            s.length &&
              s.forEach((t) => {
                t.classList.add(Ct);
              }),
              e.unobserve(t.target);
          }
        });
      },
      { root: null, rootMargin: "0px", threshold: [0.1, 0.25, 0.5, 0.75, 1] }
    );
  function It(t) {
    t.length &&
      t.forEach((t) => {
        const e = t.dataset.aosAnchor;
        if (e && -1 === xt.indexOf(e)) {
          const t = document.querySelector(e);
          t && (Ht.observe(t), xt.push(e));
        }
      });
  }
  const Bt = "img",
    Ot = "template",
    Ft = "srcset";
  let Dt = class extends HTMLElement {
    connectedCallback() {
      if (this.isRendered) return;
      const t = new IntersectionObserver(
        (e) => {
          e.forEach((e) => {
            if (e.intersectionRatio > 0) {
              const e = this.querySelector(Ot),
                s =
                  null == e
                    ? void 0
                    : e.content.firstElementChild.cloneNode(!0);
              this.appendChild(s), this.reloadSrcset(this), t.disconnect();
            }
          });
        },
        { threshold: [0.01, 0.25, 0.5, 0.75, 1] }
      );
      t.observe(this), (this.isRendered = !0);
    }
    reloadSrcset(t) {
      t &&
        t.querySelectorAll(Bt).forEach((t) => {
          const e = t.getAttribute(Ft);
          t.setAttribute(Ft, ""), t.setAttribute(Ft, e);
        });
    }
    constructor() {
      super(), (this.isRendered = !1);
    }
  };
  const $t = "[data-deferred-media-button]",
    _t = "video, model-viewer, iframe",
    Nt = '[data-host="youtube"]',
    Rt = '[data-host="vimeo"]',
    Ut = "[data-grid-item]",
    zt = ".shopify-section",
    Wt = "template",
    Vt = "video",
    jt = "product-model",
    Xt = "loaded",
    Jt = "autoplay";
  let Yt = class extends HTMLElement {
    connectedCallback() {
      this.productGridItem &&
        (this.section.addEventListener("mouseover", this.mouseOverEvent, {
          once: !0,
        }),
        this.addEventListener("mouseenter", this.mouseEnterEvent),
        this.addEventListener("mouseleave", this.mouseLeaveEvent));
    }
    disconnectedCallback() {
      this.productGridItem &&
        (this.section.removeEventListener("mouseover", this.mouseOverEvent, {
          once: !0,
        }),
        this.removeEventListener("mouseenter", this.mouseEnterEvent),
        this.removeEventListener("mouseleave", this.mouseLeaveEvent));
    }
    mouseEnterActions() {
      (this.hovered = !0),
        this.videoActions(),
        this.getAttribute(Xt) || this.loadContent();
    }
    mouseLeaveActions() {
      (this.hovered = !1), this.videoActions();
    }
    videoActions() {
      if (this.getAttribute(Xt)) {
        const t = this.querySelector(Nt),
          e = this.querySelector(Rt),
          s = t || e,
          i = this.querySelector(Vt);
        if (s) {
          let t = this.hovered ? "playVideo" : "pauseVideo",
            i = `{"event":"command","func":"${t}","args":""}`;
          e &&
            ((t = this.hovered ? "play" : "pause"), (i = `{"method":"${t}"}`)),
            s.contentWindow.postMessage(i, "*"),
            s.addEventListener("load", (t) => {
              this.videoActions();
            });
        } else i && (this.hovered ? i.play() : i.pause());
      }
    }
    loadContent(t = !0) {
      if ((this.pauseAllMedia(), !this.getAttribute(Xt))) {
        const e = document.createElement("div"),
          s = this.querySelector(Wt).content.firstElementChild.cloneNode(!0);
        e.appendChild(s), this.setAttribute(Xt, !0);
        const i = this.appendChild(e.querySelector(_t));
        t && i.focus(),
          "VIDEO" == i.nodeName && i.getAttribute(Jt) && i.play(),
          this.productGridItem && this.videoActions();
      }
    }
    pauseAllMedia() {
      document.querySelectorAll(Nt).forEach((t) => {
        t.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          "*"
        );
      }),
        document.querySelectorAll(Rt).forEach((t) => {
          t.contentWindow.postMessage('{"method":"pause"}', "*");
        }),
        document.querySelectorAll(Vt).forEach((t) => t.pause()),
        document.querySelectorAll(jt).forEach((t) => {
          t.modelViewerUI && t.modelViewerUI.pause();
        });
    }
    constructor() {
      super();
      const t = this.querySelector($t);
      null == t || t.addEventListener("click", this.loadContent.bind(this)),
        (this.section = this.closest(zt)),
        (this.productGridItem = this.closest(Ut)),
        (this.hovered = !1),
        (this.mouseEnterEvent = () => this.mouseEnterActions()),
        (this.mouseLeaveEvent = () => this.mouseLeaveActions());
    }
  };
  const Qt = "is-visible";
  class Gt {
    init() {
      var t;
      const e = { root: this.container, threshold: [0, 0.5, 0.75, 1] };
      (this.observer = new IntersectionObserver((t) => {
        t.forEach((t) => {
          t.intersectionRatio > 0.5
            ? t.target.classList.add(Qt)
            : t.target.classList.remove(Qt);
        });
      }, e)),
        null === (t = this.container.querySelectorAll(this.itemSelector)) ||
          void 0 === t ||
          t.forEach((t) => {
            this.observer.observe(t);
          });
    }
    destroy() {
      this.observer.disconnect();
    }
    constructor(t, e) {
      t &&
        e &&
        ((this.observer = null),
        (this.container = t),
        (this.itemSelector = e),
        this.init());
    }
  }
  const Kt = "is-dragging",
    Zt = "is-enabled",
    te = "is-scrolling",
    ee = "is-visible",
    se = "[data-grid-item]";
  class ie {
    handleMouseDown(t) {
      t.preventDefault(),
        (this.isDown = !0),
        (this.startX = t.pageX - this.slider.offsetLeft),
        (this.scrollLeft = this.slider.scrollLeft),
        this.cancelMomentumTracking();
    }
    handleMouseLeave() {
      this.isDown && ((this.isDown = !1), this.beginMomentumTracking());
    }
    handleMouseUp() {
      (this.isDown = !1), this.beginMomentumTracking();
    }
    handleMouseMove(t) {
      if (!this.isDown) return;
      t.preventDefault();
      const e = 1 * (t.pageX - this.slider.offsetLeft - this.startX),
        s = this.slider.scrollLeft,
        i = e > 0 ? 1 : -1;
      this.slider.classList.add(Kt, te),
        (this.slider.scrollLeft = this.scrollLeft - e),
        this.slider.scrollLeft !== s &&
          (this.velX = this.slider.scrollLeft - s || i);
    }
    handleMouseWheel() {
      this.cancelMomentumTracking(), this.slider.classList.remove(te);
    }
    beginMomentumTracking() {
      (this.isScrolling = !1),
        this.slider.classList.remove(Kt),
        this.cancelMomentumTracking(),
        this.scrollToSlide();
    }
    cancelMomentumTracking() {
      cancelAnimationFrame(this.scrollAnimation);
    }
    scrollToSlide() {
      if (!this.velX && !this.isScrolling) return;
      const t = this.slider.querySelector(`${se}.${ee}`);
      if (!t) return;
      const e = parseInt(window.getComputedStyle(t).marginRight) || 0,
        s = t.offsetWidth + e,
        i = t.offsetLeft,
        o = this.velX > 0 ? 1 : -1,
        n = Math.floor(Math.abs(this.velX) / 100) || 1;
      (this.startPosition = this.slider.scrollLeft),
        (this.distance = i - this.startPosition),
        (this.startTime = performance.now()),
        (this.isScrolling = !0),
        o < 0 && this.velX < s && (this.distance -= s * n),
        o > 0 && this.velX < s && (this.distance += s * n),
        (this.scrollAnimation = requestAnimationFrame(this.scrollStep));
    }
    scrollStep() {
      const t = performance.now() - this.startTime,
        e = parseFloat(this.easeOutCubic(Math.min(t, this.duration))).toFixed(
          1
        );
      (this.slider.scrollLeft = e),
        t < this.duration
          ? (this.scrollAnimation = requestAnimationFrame(this.scrollStep))
          : (this.slider.classList.remove(te),
            (this.velX = 0),
            (this.isScrolling = !1));
    }
    easeOutCubic(t) {
      return (
        (t /= this.duration),
        t--,
        this.distance * (t * t * t + 1) + this.startPosition
      );
    }
    destroy() {
      this.slider.classList.remove(Zt),
        this.slider.removeEventListener("mousedown", this.handleMouseDown),
        this.slider.removeEventListener("mouseleave", this.handleMouseLeave),
        this.slider.removeEventListener("mouseup", this.handleMouseUp),
        this.slider.removeEventListener("mousemove", this.handleMouseMove),
        this.slider.removeEventListener("wheel", this.handleMouseWheel);
    }
    constructor(t) {
      (this.slider = t),
        (this.isDown = !1),
        (this.startX = 0),
        (this.scrollLeft = 0),
        (this.velX = 0),
        (this.scrollAnimation = null),
        (this.isScrolling = !1),
        (this.duration = 800),
        (this.scrollStep = this.scrollStep.bind(this)),
        (this.scrollToSlide = this.scrollToSlide.bind(this)),
        (this.handleMouseDown = this.handleMouseDown.bind(this)),
        (this.handleMouseLeave = this.handleMouseLeave.bind(this)),
        (this.handleMouseUp = this.handleMouseUp.bind(this)),
        (this.handleMouseMove = this.handleMouseMove.bind(this)),
        (this.handleMouseWheel = this.handleMouseWheel.bind(this)),
        this.slider.addEventListener("mousedown", this.handleMouseDown),
        this.slider.addEventListener("mouseleave", this.handleMouseLeave),
        this.slider.addEventListener("mouseup", this.handleMouseUp),
        this.slider.addEventListener("mousemove", this.handleMouseMove),
        this.slider.addEventListener("wheel", this.handleMouseWheel, {
          passive: !0,
        }),
        this.slider.classList.add(Zt);
    }
  }
  const oe = "[data-button-arrow]",
    ne = "[data-collection-image]",
    re = "[data-column-image]",
    ae = "[data-product-image-default]",
    le = "[data-grid-item]",
    ce = "[data-grid-slider]",
    he = "data-button-prev",
    de = "data-button-next",
    ue = "align-arrows",
    pe = "slider__arrows",
    me = "is-visible";
  class ve extends HTMLElement {
    connectedCallback() {
      this.init(), this.addEventListener("theme:grid-slider:init", this.init);
    }
    init() {
      (this.slider = this.querySelector(ce)),
        (this.slides = this.querySelectorAll(le)),
        (this.buttons = this.querySelectorAll(oe)),
        this.toggleSlider(),
        document.addEventListener("theme:resize:width", this.toggleSlider);
    }
    toggleSlider() {
      if (
        !(this.slider.clientWidth < this.getSlidesWidth()) ||
        (!y() && window.theme.touch)
      )
        this.destroy();
      else {
        if (this.isInitialized) return;
        (this.slidesObserver = new Gt(this.slider, le)),
          this.initArrows(),
          (this.isInitialized = !0),
          (this.draggableSlider = new ie(this.slider));
      }
    }
    initArrows() {
      if (!this.buttons.length) {
        const t = document.createElement("div");
        t.classList.add(pe),
          (t.innerHTML = theme.sliderArrows.prev + theme.sliderArrows.next),
          this.append(t),
          (this.buttons = this.querySelectorAll(oe)),
          (this.buttonPrev = this.querySelector(`[${he}]`)),
          (this.buttonNext = this.querySelector(`[${de}]`));
      }
      this.toggleArrowsObserver(),
        this.hasAttribute(ue) &&
          (this.positionArrows(), this.arrowsResizeObserver()),
        this.buttons.forEach((t) => {
          t.addEventListener("click", this.onButtonArrowClick);
        });
    }
    buttonArrowClickEvent(t) {
      t.preventDefault();
      const e = this.slider.querySelector(`${le}.${me}`);
      let s = null;
      t.target.hasAttribute(he) &&
        (s = null == e ? void 0 : e.previousElementSibling),
        t.target.hasAttribute(de) &&
          (s = null == e ? void 0 : e.nextElementSibling),
        this.goToSlide(s);
    }
    removeArrows() {
      var t;
      null === (t = this.querySelector(`.${pe}`)) || void 0 === t || t.remove();
    }
    goToSlide(t) {
      t &&
        this.slider.scrollTo({
          top: 0,
          left: t.offsetLeft,
          behavior: "smooth",
        });
    }
    getSlidesWidth() {
      var t;
      return (
        (null === (t = this.slider.querySelector(le)) || void 0 === t
          ? void 0
          : t.clientWidth) * this.slider.querySelectorAll(le).length
      );
    }
    toggleArrowsObserver() {
      if (this.buttonPrev && this.buttonNext) {
        const t = this.slides.length,
          e = this.slides[0],
          s = this.slides[t - 1],
          i = { attributes: !0, childList: !1, subtree: !1 },
          o = (t) => {
            for (const i of t)
              if ("attributes" === i.type) {
                const t = i.target,
                  o = Boolean(t.classList.contains(me));
                t == e && (this.buttonPrev.disabled = o),
                  t == s && (this.buttonNext.disabled = o);
              }
          };
        e &&
          s &&
          ((this.firstLastSlidesObserver = new MutationObserver(o)),
          this.firstLastSlidesObserver.observe(e, i),
          this.firstLastSlidesObserver.observe(s, i));
      }
    }
    positionArrows() {
      var t;
      const e =
        (null === (t = this.slider.querySelector(ae)) || void 0 === t
          ? void 0
          : t.parentNode) ||
        this.slider.querySelector(ne) ||
        this.slider.querySelector(re) ||
        this.slider;
      e &&
        this.style.setProperty("--button-position", e.clientHeight / 2 + "px");
    }
    arrowsResizeObserver() {
      document.addEventListener("theme:resize:width", this.positionArrows);
    }
    disconnectedCallback() {
      this.destroy(),
        document.removeEventListener("theme:resize:width", this.toggleSlider);
    }
    destroy() {
      var t, e;
      (this.isInitialized = !1),
        null === (t = this.draggableSlider) || void 0 === t || t.destroy(),
        (this.draggableSlider = null),
        null === (e = this.slidesObserver) || void 0 === e || e.destroy(),
        (this.slidesObserver = null),
        this.removeArrows(),
        document.removeEventListener("theme:resize:width", this.positionArrows);
    }
    constructor() {
      super(),
        (this.isInitialized = !1),
        (this.draggableSlider = null),
        (this.positionArrows = this.positionArrows.bind(this)),
        (this.onButtonArrowClick = (t) => this.buttonArrowClickEvent(t)),
        (this.slidesObserver = null),
        (this.firstLastSlidesObserver = null),
        (this.isDragging = !1),
        (this.toggleSlider = this.toggleSlider.bind(this));
    }
  }
  const ge = "time",
    fe = "[data-days]",
    ye = "[data-hours]",
    be = "[data-minutes]",
    we = "[data-seconds]",
    Ee = ".shopify-section",
    Se = "data-expiration-behavior",
    Le = "show-message",
    ke = "hidden",
    Ae = "hide-section",
    Te = "show-message";
  let Ce = class extends HTMLElement {
    connectedCallback() {
      isNaN(this.endDate) || this.endDate <= Date.now()
        ? this.onComplete()
        : (this.interval = setInterval(this.update, 1e3));
    }
    disconnectedCallback() {
      this.stopTimer();
    }
    convertTime(t) {
      const e = this.formatDigits(parseInt(t / this.daysInMs, 10));
      t -= e * this.daysInMs;
      const s = this.formatDigits(parseInt(t / this.hoursInMs, 10));
      t -= s * this.hoursInMs;
      const i = this.formatDigits(parseInt(t / this.minutesInMs, 10));
      t -= i * this.minutesInMs;
      return {
        days: e,
        hours: s,
        minutes: i,
        seconds: this.formatDigits(parseInt(t / this.secondsInMs, 10)),
      };
    }
    formatDigits(t) {
      return t < 10 && (t = "0" + t), t;
    }
    render(t) {
      (this.days.textContent = t.days),
        (this.hours.textContent = t.hours),
        (this.minutes.textContent = t.minutes),
        (this.seconds.textContent = t.seconds);
    }
    stopTimer() {
      clearInterval(this.interval);
    }
    onComplete() {
      this.render({ days: 0, hours: 0, minutes: 0, seconds: 0 }),
        this.shouldHideOnComplete && this.shopifySection.classList.add(ke),
        this.shouldShowMessage && this.classList.add(Le);
    }
    update() {
      const t = new Date().getTime(),
        e = this.endDate - t;
      e <= 0 && (this.stopTimer(), this.onComplete());
      const s = this.convertTime(e);
      this.render(s);
    }
    constructor() {
      super(),
        (this.shopifySection = this.closest(Ee)),
        (this.expirationBehavior = this.getAttribute(Se)),
        (this.time = this.querySelector(ge)),
        (this.days = this.querySelector(fe)),
        (this.hours = this.querySelector(ye)),
        (this.minutes = this.querySelector(be)),
        (this.seconds = this.querySelector(we)),
        (this.endDate = Date.parse(this.time.dateTime)),
        (this.daysInMs = 864e5),
        (this.hoursInMs = this.daysInMs / 24),
        (this.minutesInMs = this.hoursInMs / 60),
        (this.secondsInMs = this.minutesInMs / 60),
        (this.shouldHideOnComplete = this.expirationBehavior === Ae),
        (this.shouldShowMessage = this.expirationBehavior === Te),
        (this.update = this.update.bind(this));
    }
  };
  (window.requestIdleCallback =
    window.requestIdleCallback ||
    function (t) {
      var e = Date.now();
      return setTimeout(function () {
        t({
          didTimeout: !1,
          timeRemaining: function () {
            return Math.max(0, 50 - (Date.now() - e));
          },
        });
      }, 1);
    }),
    (window.cancelIdleCallback =
      window.cancelIdleCallback ||
      function (t) {
        clearTimeout(t);
      }),
    window.theme.settings.enableAnimations &&
      (!(function () {
        const t = document.querySelectorAll(At);
        t.length &&
          t.forEach((t) => {
            Pt.observe(t);
          });
      })(),
      (function () {
        const t = document.querySelectorAll(Tt);
        t.length && It(t);
      })(),
      new MutationObserver(Mt).observe(document.body, qt)),
    window.addEventListener(
      "resize",
      v(function () {
        document.dispatchEvent(
          new CustomEvent("theme:resize", { bubbles: !0 })
        ),
          w !== g() &&
            (document.dispatchEvent(
              new CustomEvent("theme:resize:width", { bubbles: !0 })
            ),
            (w = g())),
          E !== f() &&
            (document.dispatchEvent(
              new CustomEvent("theme:resize:height", { bubbles: !0 })
            ),
            (E = f()));
      }, 50)
    ),
    (function () {
      let t;
      window.addEventListener(
        "scroll",
        function () {
          t && window.cancelAnimationFrame(t),
            (t = window.requestAnimationFrame(function () {
              !(function () {
                const t = window.scrollY;
                t > S
                  ? ((k = !0), (L = !1))
                  : t < S
                  ? ((k = !1), (L = !0))
                  : ((L = null), (k = null)),
                  (S = t),
                  document.dispatchEvent(
                    new CustomEvent("theme:scroll", {
                      detail: { up: L, down: k, position: t },
                      bubbles: !1,
                    })
                  ),
                  L &&
                    !A &&
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:up", {
                        detail: { position: t },
                        bubbles: !1,
                      })
                    ),
                  k &&
                    !T &&
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:down", {
                        detail: { position: t },
                        bubbles: !1,
                      })
                    ),
                  (T = k),
                  (A = L);
              })();
            }));
        },
        { passive: !0 }
      ),
        window.addEventListener("theme:scroll:lock", q),
        window.addEventListener("theme:scroll:unlock", x);
    })(),
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
      ? ((document.documentElement.className =
          document.documentElement.className.replace(
            "no-touch",
            "supports-touch"
          )),
        (window.theme.touch = !0))
      : (window.theme.touch = !1),
    d(),
    document.addEventListener(
      "load",
      (t) => {
        "img" == t.target.tagName.toLowerCase() &&
          t.target.classList.contains(B) &&
          (t.target.classList.remove(B),
          t.target.parentNode.classList.remove(B),
          t.target.parentNode.parentNode.classList.contains(B) &&
            t.target.parentNode.parentNode.classList.remove(B));
      },
      !0
    ),
    window.addEventListener("DOMContentLoaded", () => {
      h(),
        I(document),
        a(document),
        H(document),
        document.querySelectorAll(O).forEach((t) => {
          t.complete &&
            (t.classList.remove(B),
            t.parentNode.classList.remove(B),
            t.parentNode.parentNode.classList.contains(B) &&
              t.parentNode.parentNode.classList.remove(B));
        }),
        document.body.classList.add("is-loaded"),
        requestIdleCallback(() => {
          Shopify.visualPreviewMode &&
            document.documentElement.classList.add("preview-mode");
        });
    }),
    document.addEventListener("shopify:section:load", (t) => {
      const e = t.target;
      a(e), H(e), I(document), h();
    }),
    customElements.get("popout-select") ||
      customElements.define("popout-select", Lt),
    customElements.get("quantity-counter") ||
      customElements.define("quantity-counter", kt),
    customElements.get("predictive-search") ||
      customElements.define("predictive-search", rt),
    customElements.get("deferred-image") ||
      customElements.define("deferred-image", Dt),
    customElements.get("deferred-media") ||
      customElements.define("deferred-media", Yt),
    customElements.get("grid-slider") ||
      customElements.define("grid-slider", ve),
    customElements.get("countdown-timer") ||
      customElements.define("countdown-timer", Ce);
  const qe = (t, e = !1, s = "block") => {
    t && (e ? t.style.removeProperty("display") : (t.style.display = s));
  };
  Shopify.Products = (function () {
    const t = {
      howManyToShow: 4,
      howManyToStoreInMemory: 10,
      wrapperId: "recently-viewed-products",
      section: null,
      onComplete: null,
    };
    let e = [],
      s = null,
      i = null;
    const o = new Date(),
      n = new Date();
    n.setTime(o.getTime() + 7776e6);
    const r = {
        configuration: {
          expires: n.toGMTString(),
          path: "/",
          domain: window.location.hostname,
          sameSite: "none",
          secure: !0,
        },
        name: "shopify_recently_viewed",
        write: function (t) {
          const e = t.join(" ");
          document.cookie = `${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`;
        },
        read: function () {
          let t = [],
            e = null;
          return (
            -1 !== document.cookie.indexOf("; ") &&
              document.cookie
                .split("; ")
                .find((t) => t.startsWith(this.name)) &&
              (e = document.cookie
                .split("; ")
                .find((t) => t.startsWith(this.name))
                .split("=")[1]),
            null !== e && (t = e.split(" ")),
            t
          );
        },
        destroy: function () {
          document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
        },
        remove: function (t) {
          const e = this.read(),
            s = e.indexOf(t);
          -1 !== s && (e.splice(s, 1), this.write(e));
        },
      },
      a = (e, s, o, n) => {
        s.length && e < t.howManyToShow
          ? fetch(
              `${window.theme.routes.root}products/${s[0]}?section_id=api-product-grid-item`
            )
              .then((t) => t.text())
              .then((t) => {
                const i = 100 * e,
                  r = o.id ? `#${o.id}` : "",
                  l = document.createElement("div");
                let c = t;
                (c = c.includes("||itemAnimationDelay||")
                  ? c.replaceAll("||itemAnimationDelay||", i)
                  : c),
                  (c = c.includes("||itemAnimationAnchor||")
                    ? c.replaceAll("||itemAnimationAnchor||", r)
                    : c),
                  (l.innerHTML = c),
                  (o.innerHTML +=
                    l.querySelector("[data-api-content]").innerHTML),
                  s.shift(),
                  e++,
                  a(e, s, o, n);
              })
              .catch(() => {
                r.remove(s[0]), s.shift(), a(e, s, o, n);
              })
          : ((e, s) => {
              qe(e, !0);
              const o = r.read().length;
              if (
                Shopify.recentlyViewed &&
                i &&
                o &&
                o < i &&
                e.children.length
              ) {
                let t = [],
                  s = [],
                  i = 0;
                for (const e in Shopify.recentlyViewed) {
                  i += 1;
                  const o = Shopify.recentlyViewed[e].split(" "),
                    n = parseInt(e.split("_")[1]);
                  (t = [...t, ...o]),
                    (r.read().length === n ||
                      (i === Object.keys(Shopify.recentlyViewed).length &&
                        !s.length)) &&
                      (s = [...s, ...o]);
                }
                for (let i = 0; i < e.children.length; i++) {
                  const o = e.children[i];
                  t.length && o.classList.remove(...t),
                    s.length && o.classList.add(...s);
                }
              }
              if (t.onComplete)
                try {
                  t.onComplete(e, s);
                } catch (t) {
                  console.log(t);
                }
            })(o, n);
      };
    return {
      showRecentlyViewed: function (o) {
        const n = o || {};
        Object.assign(t, n),
          (e = r.read()),
          (s = document.querySelector(`#${t.wrapperId}`)),
          (i = t.howManyToShow),
          (t.howManyToShow = Math.min(e.length, t.howManyToShow)),
          t.howManyToShow && s && a(0, e, s, t.section);
      },
      getConfig: function () {
        return t;
      },
      clearList: function () {
        r.destroy();
      },
      recordRecentlyViewed: function (e) {
        const s = e || {};
        Object.assign(t, s);
        let i = r.read();
        if (-1 !== window.location.pathname.indexOf("/products/")) {
          let e = decodeURIComponent(window.location.pathname)
            .match(
              /\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/
            )[0]
            .split("/products/")[1];
          t.handle && (e = t.handle);
          const s = i.indexOf(e);
          -1 === s
            ? (i.unshift(e), (i = i.splice(0, t.howManyToStoreInMemory)))
            : (i.splice(s, 1), i.unshift(e)),
            r.write(i);
        }
      },
      hasProducts: r.read().length > 0,
    };
  })();
  const xe = (t, e = [], s = !1) => {
    const i = Object.keys(t)
      .map((i) => {
        let o = t[i];
        if (
          "[object Object]" === Object.prototype.toString.call(o) ||
          Array.isArray(o)
        )
          return (
            Array.isArray(t) ? e.push("") : e.push(i),
            xe(o, e, Array.isArray(o))
          );
        {
          let t = i;
          if (e.length > 0) {
            t = (s ? e : [...e, i]).reduce(
              (t, e) => ("" === t ? e : `${t}[${e}]`),
              ""
            );
          }
          return s ? `${t}[]=${o}` : `${t}=${o}`;
        }
      })
      .join("&");
    return e.pop(), i;
  };
  function Me(t) {
    (this.status = t.status || null),
      (this.headers = t.headers || null),
      (this.json = t.json || null),
      (this.body = t.body || null);
  }
  Me.prototype = Error.prototype;
  const Pe = "[data-template-no-shipping]",
    He = ".get-rates",
    Ie = "#address_container",
    Be = "#address_country",
    Oe = "#address_province",
    Fe = "#address_zip",
    De = "#wrapper-response",
    $e = "#shipping-calculator-response-template",
    _e = "data-template-no-shipping",
    Ne = "data-default",
    Re = "is-hidden",
    Ue = "error",
    ze = "center",
    We = "success",
    Ve = "disabled",
    je = "get-rates--trigger",
    Xe = "Error : country is not supported.",
    Je = "We do not ship to this destination.",
    Ye = "Error : ";
  let Qe = class extends HTMLElement {
    connectedCallback() {
      const t = document.querySelector("html");
      let s = "en";
      if (
        (t.hasAttribute("lang") &&
          "" !== t.getAttribute("lang") &&
          (s = t.getAttribute("lang")),
        this.fieldsContainer &&
          e.AddressForm(this.fieldsContainer, s, { shippingCountriesOnly: !0 }),
        this.selectCountry &&
          this.selectCountry.hasAttribute(Ne) &&
          this.selectProvince &&
          this.selectProvince.hasAttribute(Ne) &&
          this.selectCountry.addEventListener(
            "change",
            this.onCountryChangeEvent
          ),
        this.getRatesButton &&
          (this.getRatesButton.addEventListener(
            "click",
            this.onButtonClickEvent
          ),
          theme.settings.customerLoggedIn &&
            this.getRatesButton.classList.contains(je)))
      ) {
        const t = document.querySelector(Fe);
        t && t.value && this.getRatesButton.dispatchEvent(new Event("click"));
      }
    }
    disconnectedCallback() {
      this.selectCountry &&
        this.selectCountry.hasAttribute(Ne) &&
        this.selectProvince &&
        this.selectProvince.hasAttribute(Ne) &&
        this.selectCountry.removeEventListener(
          "change",
          this.onCountryChangeEvent
        ),
        this.getRatesButton &&
          this.getRatesButton.removeEventListener(
            "click",
            this.onButtonClickEvent
          );
    }
    onCountryChange() {
      this.selectCountry.removeAttribute(Ne),
        this.selectProvince.removeAttribute(Ne);
    }
    onButtonClick() {
      for (this.disableButtons(); this.wrapper.firstChild; )
        this.wrapper.removeChild(this.wrapper.firstChild);
      this.wrapper.classList.add(Re);
      const t = {};
      let e = this.selectCountry.value,
        s = this.selectProvince.value;
      const i = this.selectCountry.getAttribute(Ne);
      "" === e && i && "" !== i && (e = i);
      const o = this.selectProvince.getAttribute(Ne);
      "" === s && o && "" !== o && (s = o),
        (t.zip = document.querySelector(Fe).value || ""),
        (t.country = e || ""),
        (t.province = s || ""),
        this.getCartShippingRatesForDestination(t);
    }
    formatRate(t) {
      return "0.00" === t
        ? window.theme.strings.free
        : s.formatMoney(t, theme.moneyFormat);
    }
    render(t) {
      if (this.template && this.wrapper) {
        this.wrapper.innerHTML = "";
        let e = "",
          s = "",
          i = `${Ue} ${ze}`,
          o = this.template.innerHTML;
        const n = /[^[\]]+(?=])/g;
        if (t.rates && t.rates.length) {
          let s = n.exec(o)[0];
          t.rates.forEach((t) => {
            let i = s;
            (i = i.replace(/\|\|rateName\|\|/, t.name)),
              (i = i.replace(/\|\|ratePrice\|\|/, this.formatRate(t.price))),
              (e += i);
          });
        }
        if (t.success) {
          i = `${We} ${ze}`;
          const e = document.createElement("div");
          e.innerHTML = this.template.innerHTML;
          const o = e.querySelector(Pe);
          t.rates.length < 1 && o && (s = o.getAttribute(_e));
        } else s = t.errorFeedback;
        (o = o.replace(n, "").replace("[]", "")),
          (o = o.replace(/\|\|ratesList\|\|/g, e)),
          (o = o.replace(/\|\|successClass\|\|/g, i)),
          (o = o.replace(/\|\|ratesText\|\|/g, s)),
          (this.wrapper.innerHTML += o),
          this.wrapper.classList.remove(Re);
      }
    }
    enableButtons() {
      this.getRatesButton.removeAttribute("disabled"),
        this.getRatesButton.classList.remove(Ve),
        (this.getRatesButton.textContent =
          theme.strings.shippingCalcSubmitButton);
    }
    disableButtons() {
      this.getRatesButton.setAttribute("disabled", "disabled"),
        this.getRatesButton.classList.add(Ve),
        (this.getRatesButton.textContent =
          theme.strings.shippingCalcSubmitButtonDisabled);
    }
    getCartShippingRatesForDestination(t) {
      const e = encodeURI(xe({ shipping_address: t })),
        s = `${theme.routes.cart_url}/shipping_rates.json?${e}`;
      fetch(s)
        .then(this.handleErrors)
        .then((t) => t.text())
        .then((e) => {
          const s = JSON.parse(e).shipping_rates;
          this.onCartShippingRatesUpdate(s, t);
        })
        .catch((t) => {
          this.onError(t.json);
        });
    }
    fullMessagesFromErrors(t) {
      const e = [];
      for (const s in t) for (const i of t[s]) e.push(i);
      return e;
    }
    handleErrors(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new Me({ status: t.statusText, headers: t.headers, json: e });
          });
    }
    onError(t) {
      this.enableButtons();
      let e = "";
      (e = t.message
        ? t.message + "(" + t.status + "): " + t.description
        : Ye + this.fullMessagesFromErrors(t).join("; ")),
        e === Xe && (e = Je),
        this.render({ rates: [], errorFeedback: e, success: !1 });
    }
    onCartShippingRatesUpdate(t, e) {
      this.enableButtons();
      let s = "";
      e.zip && (s += e.zip + ", "),
        e.province && (s += e.province + ", "),
        (s += e.country),
        this.render({ rates: t, address: s, success: !0 });
    }
    constructor() {
      super(),
        (this.getRatesButton = this.querySelector(He)),
        (this.fieldsContainer = this.querySelector(Ie)),
        (this.selectCountry = this.querySelector(Be)),
        (this.selectProvince = this.querySelector(Oe)),
        (this.template = this.querySelector($e)),
        (this.wrapper = this.querySelector(De)),
        (this.onCountryChangeEvent = () => this.onCountryChange()),
        (this.onButtonClickEvent = () => this.onButtonClick());
    }
  };
  const Ge = (t, e) => {
      let s, i;
      return function o(...n) {
        const r = Date.now();
        (i = clearTimeout(i)),
          !s || r - s >= e
            ? (t.apply(null, n), (s = r))
            : (i = setTimeout(o.bind(null, ...n), e - (r - s)));
      };
    },
    Ke = "is-animated",
    Ze = "is-added",
    ts = "is-disabled",
    es = "is-hidden",
    ss = "is-hiding",
    is = "is-loading",
    os = "is-open",
    ns = "is-removed",
    rs = "is-success",
    as = "is-visible",
    ls = "is-expanded",
    cs = "is-updated",
    hs = "variant--soldout",
    ds = "variant--unavailable",
    us = "[data-api-content]",
    ps = "[data-api-line-items]",
    ms = "[data-api-upsell-items]",
    vs = "[data-api-cart-price]",
    gs = "[data-animation]",
    fs = ".additional-checkout-buttons",
    ys = "[data-foot-holder]",
    bs = "[data-skip-upsell-product]",
    ws = "[data-add-to-cart-bar]",
    Es = "[data-cart-error-close]",
    Ss = "[data-cart-drawer]",
    Ls = "[data-cart-drawer-close]",
    ks = "[data-cart-empty]",
    As = "[data-cart-errors]",
    Ts = "[data-item-remove]",
    Cs = "[data-cart-page]",
    qs = "[data-cart-form]",
    xs = "[data-cart-acceptance-checkbox]",
    Ms = "[data-cart-checkout-buttons]",
    Ps = "[data-cart-checkout-button]",
    Hs = "[data-cart-total]",
    Is = "[data-error-message]",
    Bs = "[data-close-error]",
    Os = "[data-cart-errors-container]",
    Fs = "[data-form-wrapper]",
    Ds = "[data-free-shipping]",
    $s = "[data-progress-graph]",
    _s = "[data-progress-bar]",
    Ns = "[data-header-wrapper]",
    Rs = "[data-item]",
    Us = "[data-items-holder]",
    zs = "[data-left-to-spend]",
    Ws = "[data-drawer]",
    Vs = "[data-section-id]",
    js = "[data-cart-price-holder]",
    Xs = "[data-quick-add-holder]",
    Js = "[data-quick-add-modal]",
    Ys = 'input[name="updates[]"]',
    Qs = "[data-upsell-products]",
    Gs = "[data-upsell-widget]",
    Ks = "[data-terms-error-message]",
    Zs = "[data-collapsible-body]",
    ti = "data-cart-total",
    ei = "disabled",
    si = "data-drawer-underlay",
    ii = "data-free-shipping",
    oi = "data-free-shipping-limit",
    ni = "data-item",
    ri = "data-item-index",
    ai = "data-item-title",
    li = "data-quick-add-holder",
    ci = "open";
  (window.cart = new (class {
    init() {
      (this.cartPage = document.querySelector(Cs)),
        (this.cartForm = document.querySelector(qs)),
        (this.cartDrawer = document.querySelector(Ss)),
        (this.cartDrawerClose = document.querySelector(Ls)),
        (this.cartEmpty = document.querySelector(ks)),
        (this.cartTermsCheckbox = document.querySelector(xs)),
        (this.cartCheckoutButtonWrapper = document.querySelector(Ms)),
        (this.cartCheckoutButton = document.querySelector(Ps)),
        (this.buttonHolder = document.querySelector(ys)),
        (this.itemsHolder = document.querySelector(Us)),
        (this.priceHolder = document.querySelector(js)),
        (this.items = document.querySelectorAll(Rs)),
        (this.cartTotal = document.querySelector(Hs)),
        (this.freeShipping = document.querySelectorAll(Ds)),
        (this.cartErrorHolder = document.querySelector(As)),
        (this.cartCloseErrorMessage = document.querySelector(Es)),
        (this.headerWrapper = document.querySelector(Ns)),
        (this.accessibility = N),
        (this.navDrawer = document.querySelector(Ws)),
        (this.upsellProductsHolder = document.querySelector(Qs)),
        (this.subtotal = window.theme.subtotal),
        (this.cart = this.cartDrawer || this.cartPage),
        (this.cartAddEvent = this.cartAddEvent.bind(this)),
        (this.addToCart = this.addToCart.bind(this)),
        (this.updateProgress = this.updateProgress.bind(this)),
        document.addEventListener("theme:cart:add", this.cartAddEvent),
        document.addEventListener(
          "theme:announcement:init",
          this.updateProgress
        ),
        (this.skipUpsellProductsArray = []),
        this.skipUpsellProductEvent(),
        this.checkSkippedUpsellProductsFromStorage(),
        this.toggleCartUpsellWidgetVisibility(),
        (this.circumference = 28 * Math.PI),
        (this.freeShippingLimit = this.freeShipping.length
          ? 100 *
            Number(this.freeShipping[0].getAttribute(oi)) *
            window.Shopify.currency.rate
          : 0),
        this.freeShippingMessageHandle(this.subtotal),
        this.updateProgress(),
        this.cart &&
          ((this.build = this.build.bind(this)),
          (this.updateCart = this.updateCart.bind(this)),
          (this.productAddCallback = this.productAddCallback.bind(this)),
          (this.openCartDrawer = this.openCartDrawer.bind(this)),
          (this.closeCartDrawer = this.closeCartDrawer.bind(this)),
          (this.toggleCartDrawer = this.toggleCartDrawer.bind(this)),
          (this.openCartDrawerOnProductAdded =
            this.openCartDrawerOnProductAdded.bind(this)),
          (this.animateItems = this.animateItems.bind(this)),
          (this.showAnimatedItems = this.showAnimatedItems.bind(this)),
          (this.formSubmitHandler = Ge(this.formSubmitHandler.bind(this), 50)),
          this.cartPage && this.showAnimatedItems(),
          (this.hasItemsInCart = this.hasItemsInCart.bind(this)),
          (this.cartCount = this.getCartItemCount()),
          (this.toggleClassesOnContainers =
            this.toggleClassesOnContainers.bind(this)),
          (this.totalItems = this.items.length),
          (this.cartDrawerIsOpen = !1),
          (this.cartDrawerEnabled = theme.settings.cartDrawerEnabled),
          (this.cartUpdateFailed = !1),
          this.cartEvents(),
          this.cartToggleEvents(),
          this.cartRemoveEvents(),
          this.cartUpdateEvents(),
          document.addEventListener("theme:cart:toggle", this.toggleCartDrawer),
          document.addEventListener(
            "theme:quick-add:open",
            this.closeCartDrawer
          ),
          document.addEventListener(
            "theme:product:add",
            this.productAddCallback
          ),
          document.addEventListener(
            "theme:product:add-error",
            this.productAddCallback
          ),
          document.addEventListener(
            "theme:product:added",
            this.openCartDrawerOnProductAdded
          ));
    }
    cartUpdateEvents() {
      (this.items = document.querySelectorAll(Rs)),
        this.items.forEach((t) => {
          t.addEventListener("theme:cart:update", (e) => {
            this.updateCart(
              { id: e.detail.id, quantity: e.detail.quantity },
              t
            );
          });
        });
    }
    cartRemoveEvents() {
      document.querySelectorAll(Ts).forEach((t) => {
        const e = t.closest(Rs);
        t.addEventListener("click", (s) => {
          s.preventDefault(),
            t.classList.contains(ts) ||
              this.updateCart({ id: t.dataset.id, quantity: 0 }, e);
        });
      }),
        this.cartCloseErrorMessage &&
          this.cartCloseErrorMessage.addEventListener("click", (t) => {
            t.preventDefault(), this.cartErrorHolder.classList.remove(ls);
          });
    }
    cartAddEvent(t) {
      let e = "",
        s = t.detail.button;
      if (s.hasAttribute("disabled")) return;
      const i = s.closest("form");
      i.checkValidity()
        ? ((e = new FormData(i)),
          (null !== i && i.querySelector('[type="file"]')) ||
            (t.preventDefault(), this.addToCart(e, s)))
        : i.reportValidity();
    }
    cartEvents() {
      this.cartTermsCheckbox &&
        (this.cartTermsCheckbox.removeEventListener(
          "change",
          this.formSubmitHandler
        ),
        this.cartCheckoutButtonWrapper.removeEventListener(
          "click",
          this.formSubmitHandler
        ),
        this.cartForm.removeEventListener("submit", this.formSubmitHandler),
        this.cartTermsCheckbox.addEventListener(
          "change",
          this.formSubmitHandler
        ),
        this.cartCheckoutButtonWrapper.addEventListener(
          "click",
          this.formSubmitHandler
        ),
        this.cartForm.addEventListener("submit", this.formSubmitHandler));
    }
    formSubmitHandler() {
      const t = document.querySelector(xs).checked,
        e = document.querySelector(Ks);
      if (t)
        e.classList.remove(ls), this.cartCheckoutButton.removeAttribute(ei);
      else {
        if (document.querySelector(Ks).length > 0) return;
        (e.innerText = theme.strings.cartAcceptanceError),
          this.cartCheckoutButton.setAttribute(ei, !0),
          e.classList.add(ls);
      }
    }
    formErrorsEvents(t) {
      const e = t.querySelector(Bs);
      null == e ||
        e.addEventListener("click", (e) => {
          e.preventDefault(), t && t.classList.remove(as);
        });
    }
    getCart() {
      fetch(theme.routes.cart_url + "?section_id=api-cart-items")
        .then(this.cartErrorsHandler)
        .then((t) => t.text())
        .then((t) => {
          const e = document.createElement("div");
          e.innerHTML = t;
          const s = e.querySelector(us);
          this.build(s);
        })
        .catch((t) => console.log(t));
    }
    addToCart(t, e) {
      const monster_active = !!document.querySelector('script[src*="/cart_renderer."]');
      if(monster_active && ShopifyAnalytics.meta.page.pageType == "product") return;
      this.cart && this.cart.classList.add(is);
      const s = null == e ? void 0 : e.closest(Xs);
      this.cartDrawerEnabled &&
        (e && (e.classList.add(is), (e.disabled = !0)),
        s && s.classList.add(as)),
        fetch(theme.routes.cart_add_url, {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/javascript",
          },
          body: t,
        })
          .then((t) => t.json())
          .then((t) => {
            if (t.status)
              return (
                this.addToCartError(t, e),
                void (e && (e.classList.remove(is), (e.disabled = !1)))
              );
            if(monster_active) {
              if(window.openCart) {
                return monster_refresh(true, () => {
                  if(e) {
                    e.classList.remove(is);
                    e.disabled = !1;
                  }
                });
              } else {
                return setTimeout(() => {
                  monster_refresh(true, () => {
                    if(e) {
                      e.classList.remove(is);
                      e.disabled = !1;
                    }
                  });
                }, 2000);
              }
            }
            this.cartDrawerEnabled
              ? (e &&
                  (e.classList.remove(is),
                  e.classList.add(Ze),
                  e.dispatchEvent(
                    new CustomEvent("theme:product:add", {
                      detail: { response: t, button: e },
                      bubbles: !0,
                    })
                  )),
                this.getCart())
              : (window.location = theme.routes.cart_url);
          })
          .catch((t) => {
            this.addToCartError(t, e), this.enableCartButtons();
          });
    }
    updateCart(t = {}, e = null) {
      this.cart.classList.add(is);
      let s = t.quantity;
      null !== e && (s ? e.classList.add(is) : e.classList.add(ns)),
        this.disableCartButtons();
      const i = this.cart.querySelector(`[${ni}="${t.id}"]`) || e,
        o = (null == i ? void 0 : i.hasAttribute(ri))
          ? parseInt(i.getAttribute(ri))
          : 0,
        n = (null == i ? void 0 : i.hasAttribute(ai))
          ? i.getAttribute(ai)
          : null;
      if (0 === o) return;
      const r = { line: o, quantity: s };
      fetch(theme.routes.cart_change_url, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(r),
      })
        .then((t) => t.text())
        .then((t) => {
          if (JSON.parse(t).errors)
            return (
              (this.cartUpdateFailed = !0),
              this.updateErrorText(n),
              this.toggleErrorMessage(),
              this.resetLineItem(e),
              void this.enableCartButtons()
            );
          this.getCart();
        })
        .catch((t) => {
          console.log(t), this.enableCartButtons();
        });
    }
    resetLineItem(t) {
      const e = t.querySelector(Ys),
        s = e.getAttribute("value");
      (e.value = s), t.classList.remove(is);
    }
    disableCartButtons() {
      const t = this.cart.querySelectorAll("input"),
        e = this.cart.querySelectorAll(`button, ${Ts}`);
      t.length &&
        t.forEach((t) => {
          t.classList.add(ts), t.blur(), (t.disabled = !0);
        }),
        e.length &&
          e.forEach((t) => {
            t.setAttribute(ei, !0);
          });
    }
    enableCartButtons() {
      const t = this.cart.querySelectorAll("input"),
        e = this.cart.querySelectorAll(`button, ${Ts}`);
      t.length &&
        t.forEach((t) => {
          t.classList.remove(ts), (t.disabled = !1);
        }),
        e.length &&
          e.forEach((t) => {
            t.removeAttribute(ei);
          }),
        this.cart.classList.remove(is);
    }
    updateErrorText(t) {
      this.cartErrorHolder.querySelector(Is).innerText = t;
    }
    toggleErrorMessage() {
      this.cartErrorHolder &&
        (this.cartErrorHolder.classList.toggle(ls, this.cartUpdateFailed),
        (this.cartUpdateFailed = !1));
    }
    cartErrorsHandler(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new Me({ status: t.statusText, headers: t.headers, json: e });
          });
    }
    addToCartError(t, e) {
      var s;
      if ((this.cartDrawerEnabled && this.closeCartDrawer(), null !== e)) {
        const s = e.closest(Vs) || e.closest(Xs) || e.closest(Js);
        let i = null == s ? void 0 : s.querySelector(Os);
        const o = e.closest(Xs);
        o && o.querySelector(Os) && (i = o.querySelector(Os)),
          i &&
            ((i.innerHTML = `<div class="errors">${t.message}: ${t.description}<button type="button" class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button></div>`),
            i.classList.add(as),
            this.formErrorsEvents(i)),
          e.dispatchEvent(
            new CustomEvent("theme:product:add-error", {
              detail: { response: t, button: e },
              bubbles: !0,
            })
          );
      }
      const i = null == e ? void 0 : e.closest(Xs);
      i &&
        i.dispatchEvent(
          new CustomEvent("theme:cart:error", {
            bubbles: !0,
            detail: {
              message: t.message,
              description: t.description,
              holder: i,
            },
          })
        ),
        null === (s = this.cart) || void 0 === s || s.classList.remove(is);
    }
    productAddCallback(t) {
      let e = [],
        s = null;
      const i = "theme:product:add-error" == t.type,
        o = t.detail.button,
        n = document.querySelector(ws);
      e.push(o),
        (s = o.closest(Xs)),
        n && e.push(n),
        e.forEach((t) => {
          t.classList.remove(is), i || t.classList.add(Ze);
        }),
        setTimeout(() => {
          e.forEach((t) => {
            var e, s;
            t.classList.remove(Ze);
            (null === (e = t.closest(Fs)) || void 0 === e
              ? void 0
              : e.classList.contains(hs)) ||
              (null === (s = t.closest(Fs)) || void 0 === s
                ? void 0
                : s.classList.contains(ds)) ||
              (t.disabled = !1);
          }),
            null == s || s.classList.remove(as);
        }, 1e3);
    }
    openCartDrawerOnProductAdded() {
      this.cartDrawerIsOpen ? this.showAnimatedItems() : this.openCartDrawer();
    }
    openCartDrawer() {
      this.cartDrawer &&
        ((this.cartDrawerIsOpen = !0),
        (this.onBodyClickEvent =
          this.onBodyClickEvent || this.onBodyClick.bind(this)),
        document.body.addEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(
          new CustomEvent("theme:cart:open", { bubbles: !0 })
        ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", { bubbles: !0 })
        ),
        this.cartDrawer.classList.add(os),
        this.observeAdditionalCheckoutButtons(),
        setTimeout(this.showAnimatedItems),
        this.accessibility.trapFocus(this.cartDrawer, {
          elementToFocus: this.cartDrawer.querySelector(Ls),
        }));
    }
    closeCartDrawer() {
      this.cartDrawer &&
        this.cartDrawer.classList.contains(os) &&
        ((this.cartDrawerIsOpen = !1),
        document.dispatchEvent(
          new CustomEvent("theme:cart:close", { bubbles: !0 })
        ),
        this.resetAnimatedItems(),
        this.itemsHolder.classList.remove(cs),
        this.cartEmpty.classList.remove(cs),
        this.cartErrorHolder.classList.remove(ls),
        this.cartDrawer.querySelectorAll(gs).forEach((t) => {
          const e = () => {
            t.classList.remove(ss), t.removeEventListener("animationend", e);
          };
          t.classList.add(ss), t.addEventListener("animationend", e);
        }),
        this.cartDrawer.classList.remove(os),
        this.accessibility.removeTrapFocus(),
        this.accessibility.autoFocusLastElement(),
        document.body.removeEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        ));
    }
    toggleCartDrawer() {
      this.cartDrawerIsOpen ? this.closeCartDrawer() : this.openCartDrawer();
    }
    cartToggleEvents() {
      this.cartDrawer &&
        (this.cartDrawerClose.addEventListener("click", (t) => {
          t.preventDefault(), this.closeCartDrawer();
        }),
        this.cartDrawer.addEventListener("keyup", (t) => {
          "Escape" === t.code && this.closeCartDrawer();
        }));
    }
    onBodyClick(t) {
      t.target.hasAttribute(si) && this.closeCartDrawer();
    }
    toggleClassesOnContainers() {
      const t = this.hasItemsInCart();
      this.cartEmpty.classList.toggle(es, t),
        this.buttonHolder.classList.toggle(es, !t),
        this.itemsHolder.classList.toggle(es, !t);
    }
    build(t) {
      const e = t.querySelector(ps),
        i = t.querySelector(ms),
        o = Boolean(null === e && null === i),
        n = t.querySelector(vs),
        r = t.querySelector(Hs);
      this.priceHolder && n && (this.priceHolder.innerHTML = n.innerHTML),
        o
          ? ((this.itemsHolder.innerHTML = t),
            (this.upsellProductsHolder.innerHTML = ""))
          : ((this.itemsHolder.innerHTML = e.innerHTML),
            (this.upsellProductsHolder.innerHTML = i.innerHTML),
            this.skipUpsellProductEvent(),
            this.checkSkippedUpsellProductsFromStorage(),
            this.toggleCartUpsellWidgetVisibility()),
        (this.newTotalItems =
          e && e.querySelectorAll(Rs).length
            ? e.querySelectorAll(Rs).length
            : 0),
        (this.subtotal =
          r && r.hasAttribute(ti) ? parseInt(r.getAttribute(ti)) : 0),
        (this.cartCount = this.getCartItemCount()),
        document.dispatchEvent(
          new CustomEvent("theme:cart:change", {
            bubbles: !0,
            detail: { cartCount: this.cartCount },
          })
        ),
        (this.cartTotal.innerHTML =
          0 === this.subtotal
            ? window.theme.strings.free
            : s.formatMoney(this.subtotal, theme.moneyWithCurrencyFormat)),
        this.cart.classList.remove(is),
        this.totalItems !== this.newTotalItems &&
          ((this.totalItems = this.newTotalItems),
          this.toggleClassesOnContainers()),
        this.cartDrawerIsOpen && this.itemsHolder.classList.add(cs),
        this.hasItemsInCart() ||
          this.cartEmpty.querySelectorAll(gs).forEach((t) => {
            t.classList.remove(Ke);
          }),
        this.freeShippingMessageHandle(this.subtotal),
        this.cartRemoveEvents(),
        this.cartUpdateEvents(),
        this.toggleErrorMessage(),
        this.enableCartButtons(),
        this.updateProgress(),
        document.dispatchEvent(
          new CustomEvent("theme:product:added", { bubbles: !0 })
        ),
        this.cartDrawer || this.showAnimatedItems();
    }
    getCartItemCount() {
      return Array.from(this.cart.querySelectorAll(Ys)).reduce(
        (t, e) => t + parseInt(e.value),
        0
      );
    }
    hasItemsInCart() {
      return this.totalItems > 0;
    }
    freeShippingMessageHandle(t) {
      this.freeShipping.length &&
        this.freeShipping.forEach((e) => {
          const s =
            e.hasAttribute(ii) && "true" === e.getAttribute(ii) && t >= 0;
          e.classList.toggle(rs, s && t >= this.freeShippingLimit);
        });
    }
    updateProgress() {
      if (
        ((this.freeShipping = document.querySelectorAll(Ds)),
        !this.freeShipping.length)
      )
        return;
      const t = isNaN(this.subtotal / this.freeShippingLimit)
          ? 100
          : this.subtotal / this.freeShippingLimit,
        e = Math.min(100 * t, 100),
        i = this.circumference - ((e / 100) * this.circumference) / 2,
        o = s.formatMoney(
          this.freeShippingLimit - this.subtotal,
          theme.moneyFormat
        );
      this.freeShipping.forEach((t) => {
        const s = t.querySelector(_s),
          n = t.querySelector($s),
          r = t.querySelector(zs);
        r && (r.innerHTML = o.replace(".00", "")),
          s && (s.value = e),
          n && n.style.setProperty("--stroke-dashoffset", `${i}`);
      });
    }
    skipUpsellProductEvent() {
      if (null === this.upsellProductsHolder) return;
      const t = this.upsellProductsHolder.querySelectorAll(bs);
      t.length &&
        t.forEach((t) => {
          t.addEventListener("click", (e) => {
            e.preventDefault();
            const s = t.closest(Xs).getAttribute(li);
            this.skipUpsellProductsArray.includes(s) ||
              this.skipUpsellProductsArray.push(s),
              window.sessionStorage.setItem(
                "skip_upsell_products",
                this.skipUpsellProductsArray
              ),
              this.removeUpsellProduct(s),
              this.toggleCartUpsellWidgetVisibility();
          });
        });
    }
    checkSkippedUpsellProductsFromStorage() {
      const t = window.sessionStorage.getItem("skip_upsell_products");
      if (!t) return;
      t.split(",").forEach((t) => {
        this.skipUpsellProductsArray.includes(t) ||
          this.skipUpsellProductsArray.push(t),
          this.removeUpsellProduct(t);
      });
    }
    removeUpsellProduct(t) {
      if (!this.upsellProductsHolder) return;
      const e = this.upsellProductsHolder.querySelector(`[${li}="${t}"]`);
      e && e.parentNode.remove();
    }
    toggleCartUpsellWidgetVisibility() {
      if (!this.upsellProductsHolder) return;
      const t = this.upsellProductsHolder.querySelectorAll(Xs),
        e = this.upsellProductsHolder.closest(Gs);
      if (
        e &&
        (e.classList.toggle(es, !t.length), t.length && !e.hasAttribute(ci))
      ) {
        e.setAttribute(ci, !0);
        const t = e.querySelector(Zs);
        t && (t.style.height = "auto");
      }
    }
    observeAdditionalCheckoutButtons() {
      const t = this.cartDrawer.querySelector(fs);
      if (t) {
        const e = new MutationObserver(() => {
          this.accessibility.trapFocus(this.cartDrawer, {
            elementToFocus: this.cartDrawer.querySelector(Ls),
          }),
            e.disconnect();
        });
        e.observe(t, { subtree: !0, childList: !0 });
      }
    }
    resetAnimatedItems() {
      this.cart.querySelectorAll(gs).forEach((t) => {
        t.classList.remove(Ke), t.classList.remove(ss);
      });
    }
    showAnimatedItems() {
      requestAnimationFrame(this.animateItems);
    }
    animateItems() {
      this.cart.querySelectorAll(gs).forEach((t) => {
        t.classList.add(Ke);
      });
    }
    constructor() {
      window.location.pathname.endsWith("/password") || this.init();
    }
  })()),
    customElements.get("shipping-calculator") ||
      customElements.define("shipping-calculator", Qe);
  const hi = "is-focused",
    di = "[data-skip-content]",
    ui = 'a[href="#"]';
  window.accessibility = new (class {
    init() {
      (this.a11y = N),
        (this.html = document.documentElement),
        (this.body = document.body),
        (this.inPageLink = document.querySelector(di)),
        (this.linkesWithOnlyHash = document.querySelectorAll(ui)),
        this.a11y.focusHash(),
        this.a11y.bindInPageLinks(),
        this.clickEvents(),
        this.focusEvents();
    }
    clickEvents() {
      this.inPageLink &&
        this.inPageLink.addEventListener("click", (t) => {
          t.preventDefault();
        }),
        this.linkesWithOnlyHash &&
          this.linkesWithOnlyHash.forEach((t) => {
            t.addEventListener("click", (t) => {
              t.preventDefault();
            });
          });
    }
    focusEvents() {
      document.addEventListener("mousedown", () => {
        this.body.classList.remove(hi);
      }),
        document.addEventListener("keyup", (t) => {
          "Tab" === t.code && this.body.classList.add(hi);
        });
    }
    constructor() {
      this.init();
    }
  })();
  const pi = 'input[type="search"]';
  customElements.define(
    "main-search",
    class extends V {
      setupEventListeners() {
        let t = [];
        this.allSearchInputs.forEach((e) => t.push(e.form)),
          this.input.addEventListener("focus", this.onInputFocus.bind(this)),
          t.length < 2 ||
            (t.forEach((t) =>
              t.addEventListener("reset", this.onFormReset.bind(this))
            ),
            this.allSearchInputs.forEach((t) =>
              t.addEventListener("input", this.onInput.bind(this))
            ));
      }
      onFormReset(t) {
        super.onFormReset(t),
          super.shouldResetForm() && this.keepInSync("", this.input);
      }
      onInput(t) {
        const e = t.target;
        this.keepInSync(e.value, e);
      }
      onInputFocus() {
        y() || this.scrollIntoView({ behavior: "smooth" });
      }
      keepInSync(t, e) {
        this.allSearchInputs.forEach((s) => {
          s !== e && (s.value = t);
        });
      }
      constructor() {
        super(),
          (this.allSearchInputs = document.querySelectorAll(pi)),
          this.setupEventListeners();
      }
    }
  );
  const mi = "details",
    vi = "[data-popdown]",
    gi = "[data-popdown-close]",
    fi = "[data-popdown-toggle]",
    yi = 'input:not([type="hidden"])',
    bi = "data-popdown-underlay";
  let wi = class extends HTMLElement {
    connectedCallback() {
      this.popdownContainer.addEventListener(
        "keyup",
        (t) => "ESCAPE" === t.code.toUpperCase() && this.close()
      ),
        this.popdownClose.addEventListener("click", this.close.bind(this)),
        this.popdownToggle.addEventListener(
          "click",
          this.onPopdownToggleClick.bind(this)
        ),
        this.popdownToggle.setAttribute("role", "button"),
        this.popdown.addEventListener("transitionend", (t) => {
          "visibility" == t.propertyName &&
            this.popdownContainer.hasAttribute("open") &&
            "false" == this.popdownContainer.getAttribute("open") &&
            this.popdownContainer.removeAttribute("open");
        });
    }
    onPopdownToggleClick(t) {
      t.preventDefault(),
        t.target.closest(mi).hasAttribute("open") ? this.close() : this.open(t);
    }
    onBodyClick(t) {
      (this.contains(t.target) && !t.target.hasAttribute(bi)) || this.close();
    }
    open(t) {
      (this.onBodyClickEvent =
        this.onBodyClickEvent || this.onBodyClick.bind(this)),
        t.target.closest(mi).setAttribute("open", ""),
        document.body.addEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", { bubbles: !0 })
        ),
        requestAnimationFrame(() => {
          t.target.closest(mi).setAttribute("open", "true"),
            this.a11y.trapFocus(this.popdown, {
              elementToFocus: this.popdown.querySelector(yi),
            });
        });
    }
    close() {
      this.a11y.removeTrapFocus(),
        this.popdownContainer.setAttribute("open", "false"),
        document.body.removeEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        );
    }
    constructor() {
      super(),
        (this.popdown = this.querySelector(vi)),
        (this.popdownContainer = this.querySelector(mi)),
        (this.popdownToggle = this.querySelector(fi)),
        (this.popdownClose = this.querySelector(gi)),
        (this.a11y = N);
    }
  };
  customElements.define("header-search-popdown", wi);
  const Ei = "[data-collapsible]",
    Si = "[data-collapsible-trigger]",
    Li = "[data-collapsible-body]",
    ki = "[data-collapsible-content]",
    Ai = "open",
    Ti = "single";
  let Ci = class extends HTMLElement {
    connectedCallback() {
      this.collapsibles.forEach((t) => {
        const e = t.querySelector(Si),
          s = t.querySelector(Li);
        e.addEventListener("click", (t) => this.onCollapsibleClick(t)),
          s.addEventListener("transitionend", (e) => {
            e.target === s &&
              ("true" == t.getAttribute(Ai) && this.setBodyHeight(s, "auto"),
              "false" == t.getAttribute(Ai) &&
                (t.removeAttribute(Ai), this.setBodyHeight(s, "")));
          });
      });
    }
    open(t) {
      if ("true" == t.getAttribute("open")) return;
      const e = t.querySelector(Li),
        s = t.querySelector(ki);
      t.setAttribute("open", !0), this.setBodyHeight(e, s.offsetHeight);
    }
    close(t) {
      if (!t.hasAttribute("open")) return;
      const e = t.querySelector(Li),
        s = t.querySelector(ki);
      this.setBodyHeight(e, s.offsetHeight),
        t.setAttribute("open", !1),
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.setBodyHeight(e, 0);
          });
        });
    }
    setBodyHeight(t, e) {
      t.style.height = "auto" !== e && "" !== e ? `${e}px` : e;
    }
    onCollapsibleClick(t) {
      t.preventDefault();
      const e = (
        t.target.matches(Si) ? t.target : t.target.closest(Si)
      ).closest(Ei);
      this.single &&
        this.collapsibles.forEach((t) => {
          t.hasAttribute(Ai) &&
            t != e &&
            requestAnimationFrame(() => {
              this.close(t);
            });
        }),
        e.hasAttribute(Ai) ? this.close(e) : this.open(e),
        e.dispatchEvent(
          new CustomEvent("theme:form:sticky", {
            bubbles: !0,
            detail: { element: "accordion" },
          })
        );
    }
    constructor() {
      super(),
        (this.collapsibles = this.querySelectorAll(Ei)),
        (this.single = this.hasAttribute(Ti));
    }
  };
  customElements.get("collapsible-elements") ||
    customElements.define("collapsible-elements", Ci);
  const qi = "[data-actions]",
    xi = "[data-content]",
    Mi = "[data-button]",
    Pi = "data-height",
    Hi = "is-open",
    Ii = "is-enabled";
  let Bi = class extends HTMLElement {
    connectedCallback() {
      this.setHeight(this.initialHeight),
        this.trigger.addEventListener("click", () => {
          this.setHeight(this.content.offsetHeight), this.classList.add(Hi);
        }),
        this.setHeight(this.initialHeight),
        this.toggleActions(),
        document.addEventListener("theme:resize", this.toggleActions);
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize", this.toggleActions);
    }
    setHeight(t) {
      this.style.setProperty("--height", `${t}px`);
    }
    toggleActions() {
      this.classList.toggle(
        Ii,
        this.content.offsetHeight + this.actions.offsetHeight >
          this.initialHeight
      );
    }
    constructor() {
      super(),
        (this.initialHeight = this.getAttribute(Pi)),
        (this.content = this.querySelector(xi)),
        (this.trigger = this.querySelector(Mi)),
        (this.actions = this.querySelector(qi)),
        (this.toggleActions = this.toggleActions.bind(this));
    }
  };
  customElements.get("toggle-ellipsis") ||
    customElements.define("toggle-ellipsis", Bi);
  const Oi = ".template-addresses",
    Fi = "#AddressNewForm",
    Di = ".address-new-toggle",
    $i = ".address-edit-toggle",
    _i = ".address-delete",
    Ni = "data-form-id",
    Ri = "data-confirm-message",
    Ui = "#EditAddress",
    zi = "AddressCountryNew",
    Wi = "AddressProvinceNew",
    Vi = "AddressProvinceContainerNew",
    ji = ".address-country-option",
    Xi = "AddressCountry",
    Ji = "AddressProvince",
    Yi = "AddressProvinceContainer",
    Qi = "hidden";
  const Gi = document.querySelector(Oi);
  Gi &&
    new (class {
      init() {
        if (this.addressNewForm) {
          const t = this.section,
            e = this.addressNewForm;
          this.customerAddresses();
          const s = t.querySelectorAll(Di);
          s.length &&
            s.forEach((t) => {
              t.addEventListener("click", function () {
                e.classList.toggle(Qi);
              });
            });
          const i = t.querySelectorAll($i);
          i.length &&
            i.forEach((e) => {
              e.addEventListener("click", function () {
                const e = this.getAttribute(Ni);
                t.querySelector(`${Ui}_${e}`).classList.toggle(Qi);
              });
            });
          const o = t.querySelectorAll(_i);
          o.length &&
            o.forEach((t) => {
              t.addEventListener("click", function () {
                const t = this.getAttribute(Ni),
                  e = this.getAttribute(Ri);
                confirm(e) &&
                  Shopify.postLink(
                    window.theme.routes.addresses_url + "/" + t,
                    { parameters: { _method: "delete" } }
                  );
              });
            });
        }
      }
      customerAddresses() {
        Shopify.CountryProvinceSelector &&
          new Shopify.CountryProvinceSelector(zi, Wi, { hideElement: Vi }),
          this.section.querySelectorAll(ji).forEach((t) => {
            const e = t.getAttribute(Ni),
              s = `${Xi}_${e}`,
              i = `${Ji}_${e}`,
              o = `${Yi}_${e}`;
            new Shopify.CountryProvinceSelector(s, i, { hideElement: o });
          });
      }
      constructor(t) {
        (this.section = t),
          (this.addressNewForm = this.section.querySelector(Fi)),
          this.init();
      }
    })(Gi);
  const Ki = ".customer-logged-in",
    Zi = ".account",
    to = ".account-sidebar--mobile";
  const eo = document.querySelector(Ki);
  eo &&
    new (class {
      init() {
        this.section.querySelector(Zi) && this.accountMobileSidebar();
      }
      accountMobileSidebar() {
        this.section.querySelector(to) &&
          this.section.querySelector(to).addEventListener("click", function () {
            const t = this.nextElementSibling;
            t && "UL" === t.tagName && t.classList.toggle("visible");
          });
      }
      constructor(t) {
        (this.section = t), this.init();
      }
    })(eo);
  const so = "[data-account-form]",
    io = "[data-show-reset]",
    oo = "[data-hide-reset]",
    no = "[data-recover-password]",
    ro = "[data-recover-success]",
    ao = "[data-login-form]",
    lo = "#recover",
    co = "is-hidden";
  const ho = document.querySelector(so);
  ho &&
    new (class {
      init() {
        window.location.hash == lo || this.recoverSuccess
          ? this.showRecoverPasswordForm()
          : this.hideRecoverPasswordForm(),
          this.showButton.addEventListener(
            "click",
            function (t) {
              t.preventDefault(), this.showRecoverPasswordForm();
            }.bind(this),
            !1
          ),
          this.hideButton.addEventListener(
            "click",
            function (t) {
              t.preventDefault(), this.hideRecoverPasswordForm();
            }.bind(this),
            !1
          );
      }
      showRecoverPasswordForm() {
        return (
          this.login.classList.add(co),
          this.recover.classList.remove(co),
          (window.location.hash = lo),
          !1
        );
      }
      hideRecoverPasswordForm() {
        return (
          this.recover.classList.add(co),
          this.login.classList.remove(co),
          (window.location.hash = ""),
          !1
        );
      }
      constructor(t) {
        (this.form = t),
          (this.showButton = t.querySelector(io)),
          (this.hideButton = t.querySelector(oo)),
          (this.recover = t.querySelector(no)),
          (this.recoverSuccess = t.querySelector(ro)),
          (this.login = t.querySelector(ao)),
          this.init();
      }
    })(ho),
    (window.Shopify = window.Shopify || {}),
    (window.Shopify.theme = window.Shopify.theme || {}),
    (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
    (window.Shopify.theme.sections.registered =
      window.Shopify.theme.sections.registered || {}),
    (window.Shopify.theme.sections.instances =
      window.Shopify.theme.sections.instances || []);
  const uo = window.Shopify.theme.sections.registered,
    po = window.Shopify.theme.sections.instances,
    mo = "data-section-id",
    vo = "data-section-type";
  let go = class {
    callFunctions(t, e = null) {
      this.callStack[t].forEach((t) => {
        const s = { id: this.id, type: this.type, container: this.container };
        e ? t.call(s, e) : t.call(s);
      });
    }
    onLoad() {
      this.callFunctions("onLoad");
    }
    onUnload() {
      this.callFunctions("onUnload");
    }
    onSelect(t) {
      this.callFunctions("onSelect", t);
    }
    onDeselect(t) {
      this.callFunctions("onDeselect", t);
    }
    onBlockSelect(t) {
      this.callFunctions("onBlockSelect", t);
    }
    onBlockDeselect(t) {
      this.callFunctions("onBlockDeselect", t);
    }
    onReorder(t) {
      this.callFunctions("onReorder", t);
    }
    constructor(t, e) {
      (this.container = (function (t) {
        if (!(t instanceof Element))
          throw new TypeError(
            "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
          );
        if (null === t.getAttribute(mo))
          throw new Error(
            "Theme Sections: The section container provided does not have an id assigned to the " +
              mo +
              " attribute."
          );
        return t;
      })(t)),
        (this.id = t.getAttribute(mo)),
        (this.type = e.type),
        (this.callStack = e.getStack());
      try {
        this.onLoad();
      } catch (t) {
        console.warn(`Error in section: ${this.id}`),
          console.warn(this),
          console.warn(t);
      }
    }
  };
  function fo(t, e) {
    if ("string" != typeof t)
      throw new TypeError(
        "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
      );
    if (void 0 !== uo[t])
      throw new Error(
        'Theme Sections: A section of type "' +
          t +
          '" has already been registered. You cannot register the same section type twice'
      );
    Array.isArray(e) || (e = [e]);
    const s = new (class {
      getStack() {
        return this.callStack;
      }
      constructor(t = null, e = []) {
        (this.type = t),
          (this.components = (function (t) {
            if ((void 0 !== t && "object" != typeof t) || null === t)
              throw new TypeError(
                "Theme Sections: The components object provided is not a valid"
              );
            return t;
          })(e)),
          (this.callStack = {
            onLoad: [],
            onUnload: [],
            onSelect: [],
            onDeselect: [],
            onBlockSelect: [],
            onBlockDeselect: [],
            onReorder: [],
          }),
          e.forEach((t) => {
            for (const [e, s] of Object.entries(t)) {
              const t = this.callStack[e];
              Array.isArray(t) && "function" == typeof s
                ? t.push(s)
                : (console.warn(
                    `Unregisted function: '${e}' in component: '${this.type}'`
                  ),
                  console.warn(s));
            }
          });
      }
    })(t, e);
    return (uo[t] = s), uo;
  }
  function yo(t, e) {
    (t = Eo(t)),
      void 0 === e && (e = document.querySelectorAll("[" + vo + "]")),
      (e = So(e)),
      t.forEach(function (t) {
        const s = uo[t];
        void 0 !== s &&
          (e = e.filter(function (e) {
            return (
              !(bo(e).length > 0) &&
              null !== e.getAttribute(vo) &&
              (e.getAttribute(vo) !== t || (po.push(new go(e, s)), !1))
            );
          }));
      });
  }
  function bo(t) {
    var e = [];
    if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var s = t[0];
    if (t instanceof Element || s instanceof Element)
      So(t).forEach(function (t) {
        e = e.concat(
          po.filter(function (e) {
            return e.container === t;
          })
        );
      });
    else if ("string" == typeof t || "string" == typeof s) {
      Eo(t).forEach(function (t) {
        e = e.concat(
          po.filter(function (e) {
            return e.type === t;
          })
        );
      });
    }
    return e;
  }
  function wo(t) {
    for (var e, s = 0; s < po.length; s++)
      if (po[s].id === t) {
        e = po[s];
        break;
      }
    return e;
  }
  function Eo(t) {
    return (
      "*" === t
        ? (t = Object.keys(uo))
        : "string" == typeof t
        ? (t = [t])
        : t.constructor === go
        ? (t = [t.prototype.type])
        : Array.isArray(t) &&
          t[0].constructor === go &&
          (t = t.map(function (t) {
            return t.type;
          })),
      (t = t.map(function (t) {
        return t.toLowerCase();
      }))
    );
  }
  function So(t) {
    return (
      NodeList.prototype.isPrototypeOf(t) && t.length > 0
        ? (t = Array.prototype.slice.call(t))
        : (NodeList.prototype.isPrototypeOf(t) && 0 === t.length) || null === t
        ? (t = [])
        : !Array.isArray(t) && t instanceof Element && (t = [t]),
      t
    );
  }
  window.Shopify.designMode &&
    (document.addEventListener("shopify:section:load", function (t) {
      var e = t.detail.sectionId,
        s = t.target.querySelector("[" + mo + '="' + e + '"]');
      null !== s && yo(s.getAttribute(vo), s);
    }),
    document.addEventListener("shopify:section:reorder", function (t) {
      var e = t.detail.sectionId,
        s = t.target.querySelector("[" + mo + '="' + e + '"]');
      "object" == typeof bo(s)[0] &&
        bo(s).forEach(function (t) {
          t.onReorder();
        });
    }),
    document.addEventListener("shopify:section:unload", function (t) {
      var e = t.detail.sectionId,
        s = t.target.querySelector("[" + mo + '="' + e + '"]');
      "object" == typeof bo(s)[0] &&
        bo(s).forEach(function (t) {
          var e = po
            .map(function (t) {
              return t.id;
            })
            .indexOf(t.id);
          po.splice(e, 1), t.onUnload();
        });
    }),
    document.addEventListener("shopify:section:select", function (t) {
      var e = wo(t.detail.sectionId);
      "object" == typeof e && e.onSelect(t);
    }),
    document.addEventListener("shopify:section:deselect", function (t) {
      var e = wo(t.detail.sectionId);
      "object" == typeof e && e.onDeselect(t);
    }),
    document.addEventListener("shopify:block:select", function (t) {
      var e = wo(t.detail.sectionId);
      "object" == typeof e && e.onBlockSelect(t);
    }),
    document.addEventListener("shopify:block:deselect", function (t) {
      var e = wo(t.detail.sectionId);
      "object" == typeof e && e.onBlockDeselect(t);
    }));
  const Lo = "data-tooltip",
    ko = "data-tooltip-stop-mouseenter",
    Ao = "tooltip-default",
    To = "is-visible",
    Co = "is-hiding";
  let qo = {},
    xo = class {
      init() {
        if (!document.querySelector(`.${this.class}`)) {
          const t = `<div class="${this.class}__arrow"></div><div class="${this.class}__inner"><div class="${this.class}__text"></div></div>`,
            e = document.createElement("div");
          (e.className = this.class),
            (e.innerHTML = t),
            document.body.appendChild(e);
        }
        this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent),
          this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent),
          this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent),
          document.addEventListener("theme:tooltip:close", this.removePinEvent);
      }
      addPin(t = !1) {
        const e = document.querySelector(`.${this.class}`);
        if (e && ((t && !this.tooltip.hasAttribute(ko)) || !t)) {
          const t = e.querySelector(`.${this.class}__arrow`),
            s = e.querySelector(`.${this.class}__inner`);
          e.querySelector(`.${this.class}__text`).textContent = this.label;
          const i = s.offsetWidth,
            o = this.tooltip.getBoundingClientRect(),
            n = o.top,
            r = o.width,
            a = n + o.height + window.scrollY;
          let l = o.left - i / 2 + r / 2;
          const c = l + i - g();
          c > 0 && (l -= c),
            l < 0 && (l = 0),
            (t.style.left = `${o.left + r / 2}px`),
            e.style.setProperty("--tooltip-top", `${a}px`),
            (s.style.transform = `translateX(${l}px)`),
            e.classList.remove(Co),
            e.classList.add(To),
            document.addEventListener("theme:scroll", this.removePinEvent);
        }
      }
      removePin(t, e = !1, s = !1) {
        const i = document.querySelector(`.${this.class}`),
          o = i.classList.contains(To);
        i &&
          ((e && !this.tooltip.hasAttribute(ko)) || !e) &&
          (o &&
            (s || t.detail.hideTransition) &&
            (i.classList.add(Co),
            this.hideTransitionTimeout &&
              clearTimeout(this.hideTransitionTimeout),
            (this.hideTransitionTimeout = setTimeout(() => {
              i.classList.remove(Co);
            }, this.transitionSpeed))),
          i.classList.remove(To),
          document.removeEventListener("theme:scroll", this.removePinEvent));
      }
      unload() {
        this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent),
          this.tooltip.removeEventListener(
            "mouseleave",
            this.removePinMouseEvent
          ),
          this.tooltip.removeEventListener(
            "theme:tooltip:init",
            this.addPinEvent
          ),
          document.removeEventListener(
            "theme:tooltip:close",
            this.removePinEvent
          ),
          document.removeEventListener("theme:scroll", this.removePinEvent);
      }
      constructor(t, e = {}) {
        (this.tooltip = t),
          this.tooltip.hasAttribute(Lo) &&
            ((this.label = this.tooltip.getAttribute(Lo)),
            (this.class = e.class || Ao),
            (this.transitionSpeed = e.transitionSpeed || 200),
            (this.hideTransitionTimeout = 0),
            (this.addPinEvent = () => this.addPin()),
            (this.addPinMouseEvent = () => this.addPin(!0)),
            (this.removePinEvent = (t) => Ge(this.removePin(t), 50)),
            (this.removePinMouseEvent = (t) => this.removePin(t, !0, !0)),
            this.init());
      }
    };
  const Mo = {
    onLoad() {
      qo[this.id] = [];
      this.container.querySelectorAll(`[${Lo}]`).forEach((t) => {
        qo[this.id].push(new xo(t));
      });
    },
    onUnload: function () {
      qo[this.id].forEach((t) => {
        "function" == typeof t.unload && t.unload();
      });
    },
  };
  var Po = {};
  const Ho = {
    onLoad() {
      Po[this.id] = [];
      this.container
        .querySelectorAll("[data-parallax-wrapper]")
        .forEach((t) => {
          const e = t.querySelector("[data-parallax-img]");
          Po[this.id].push(new i(e, { center: !0, round: !0, frame: t }));
        }),
        window.addEventListener("load", () => {
          Po[this.id].forEach((t) => {
            "function" == typeof t.refresh && t.refresh();
          });
        });
    },
    onUnload: function () {
      Po[this.id].forEach((t) => {
        "function" == typeof t.destroy && t.destroy();
      });
    },
  };
  fo("article", [Mo, Ho]);
  const Io = "[data-aos]",
    Bo = ".collection-item__image",
    Oo = "[data-column-image]",
    Fo = ".flickity-button.next",
    Do = ".flickity-button.previous",
    $o = "a:not(.btn)",
    _o = ".product-item__image",
    No = "[data-slide]",
    Ro = "data-slide",
    Uo = "[data-slider]",
    zo = "[data-slider-thumb]",
    Wo = {
      arrowPositionMiddle: "data-arrow-position-middle",
      slideIndex: "data-slide-index",
      sliderOptions: "data-options",
      slideTextColor: "data-slide-text-color",
    },
    Vo = "aos-animate",
    jo = "desktop",
    Xo = "is-focused",
    Jo = "flickity-enabled",
    Yo = "is-initialized",
    Qo = "is-loading",
    Go = "is-selected",
    Ko = "mobile",
    Zo = "single-slide",
    tn = "js-slider--initialized",
    en = {};
  let sn = class {
    init() {
      this.slideshow.classList.add(Qo);
      let t = No;
      const e = y(),
        s = `${No}:not(.${Ko})`,
        i = `${No}:not(.${jo})`;
      (this.slideshow.querySelectorAll(i).length ||
        this.slideshow.querySelectorAll(s).length) &&
        (t = e ? s : i),
        this.slideshow.querySelectorAll(t).length <= 1 &&
          (this.slideshow.classList.add(Zo),
          this.slideshow.classList.remove(Qo)),
        (this.sliderOptions = {
          cellSelector: t,
          contain: !0,
          wrapAround: !0,
          adaptiveHeight: !0,
          ...this.customOptions,
          on: {
            ready: () => {
              requestAnimationFrame(() => {
                this.slideshow.classList.add(Yo),
                  this.slideshow.classList.remove(Qo),
                  this.slideshow.parentNode.dispatchEvent(
                    new CustomEvent("theme:slider:loaded", {
                      bubbles: !0,
                      detail: { slider: this },
                    })
                  );
              }),
                this.slideActions(),
                this.sliderOptions.prevNextButtons && this.positionArrows();
            },
            change: (t) => {
              const e = this.slideshowSlides[t];
              if (!e || this.sliderOptions.groupCells) return;
              const s = e.querySelectorAll(Io);
              s.length &&
                s.forEach((t) => {
                  t.classList.remove(Vo),
                    requestAnimationFrame(() => {
                      setTimeout(() => {
                        t.classList.add(Vo);
                      }, 0);
                    });
                });
            },
            resize: () => {
              this.sliderOptions.prevNextButtons && this.positionArrows();
            },
          },
        }),
        this.sliderOptions.fade &&
          (this.flkty = new n(this.slideshow, this.sliderOptions)),
        this.sliderOptions.fade ||
          (this.flkty = new o(this.slideshow, this.sliderOptions)),
        this.flkty.on("change", () => this.slideActions(!0)),
        this.sliderThumbs.length &&
          this.sliderThumbs.forEach((t) => {
            t.addEventListener("click", (e) => {
              e.preventDefault();
              const s = [...t.parentElement.children].indexOf(t);
              this.flkty.select(s);
            });
          }),
        (this.flkty && this.flkty.isActive) ||
          this.slideshow.classList.remove(Qo);
    }
    slideActions(t = !1) {
      const e = this.slideshow.querySelector(`.${Go}`),
        s = e.getAttribute(Wo.slideTextColor),
        i = e.querySelector($o),
        o = this.slideshow.querySelectorAll(`${No} a, ${No} button`);
      if (
        (document.body.classList.contains(Xo) &&
          i &&
          this.sliderOptions.groupCells &&
          t &&
          i.focus(),
        o.length &&
          o.forEach((t) => {
            const e = t.closest(No);
            if (e) {
              const s = e.classList.contains(Go) ? 0 : -1;
              t.setAttribute("tabindex", s);
            }
          }),
        "rgba(0,0,0,0)" !== s &&
          "" !== s &&
          this.slideshow.style.setProperty("--text", s),
        this.sliderThumbs.length &&
          this.sliderThumbs.length === this.slideshowSlides.length &&
          e.hasAttribute(Wo.slideIndex))
      ) {
        const t = parseInt(e.getAttribute(Wo.slideIndex)),
          s = this.container.querySelector(`${zo}.${Go}`);
        s && s.classList.remove(Go), this.sliderThumbs[t].classList.add(Go);
      }
    }
    positionArrows() {
      if (
        this.slideshow.hasAttribute(Wo.arrowPositionMiddle) &&
        this.sliderOptions.prevNextButtons
      ) {
        const t =
          this.slideshow.querySelector(Bo) ||
          this.slideshow.querySelector(_o) ||
          this.slideshow.querySelector(Oo);
        if (!t) return;
        (this.slideshow.querySelector(Do).style.top =
          t.clientHeight / 2 + "px"),
          (this.slideshow.querySelector(Fo).style.top =
            t.clientHeight / 2 + "px");
      }
    }
    onUnload() {
      this.slideshow &&
        this.flkty &&
        ((this.flkty.options.watchCSS = !1), this.flkty.destroy());
    }
    onBlockSelect(t) {
      if (!this.slideshow) return;
      const e = this.slideshow.querySelector(`[${Ro}="${t.detail.blockId}"]`);
      if (!e) return;
      let s = parseInt(e.getAttribute(Wo.slideIndex));
      this.multipleSlides && !this.slideshow.classList.contains(tn) && (s = 0),
        this.slideshow.classList.add(Go),
        this.flkty &&
          this.slideshow.classList.contains(Jo) &&
          (this.flkty.selectCell(s), this.flkty.stopPlayer());
    }
    onBlockDeselect() {
      this.slideshow &&
        (this.slideshow.classList.remove(Go),
        this.flkty &&
          this.sliderOptions.hasOwnProperty("autoPlay") &&
          this.sliderOptions.autoPlay &&
          this.flkty.playPlayer());
    }
    constructor(t, e = null) {
      (this.container = t),
        (this.slideshow = e || this.container.querySelector(Uo)),
        this.slideshow &&
          ((this.slideshowSlides = this.slideshow.querySelectorAll(No)),
          this.slideshowSlides.length <= 1 ||
            ((this.sliderThumbs = this.container.querySelectorAll(zo)),
            (this.multipleSlides = this.slideshow.hasAttribute(
              Wo.slidesLargeDesktop
            )),
            this.slideshow.hasAttribute(Wo.sliderOptions) &&
              (this.customOptions = JSON.parse(
                decodeURIComponent(
                  this.slideshow.getAttribute(Wo.sliderOptions)
                )
              )),
            (this.flkty = null),
            this.init()));
    }
  };
  const on = {
    onLoad() {
      en[this.id] = [];
      this.container.querySelectorAll(Uo).forEach((t) => {
        en[this.id].push(new sn(this.container, t));
      });
    },
    onUnload() {
      en[this.id].forEach((t) => {
        "function" == typeof t.onUnload && t.onUnload();
      });
    },
    onBlockSelect(t) {
      en[this.id].forEach((e) => {
        "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
      });
    },
    onBlockDeselect(t) {
      en[this.id].forEach((e) => {
        "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
      });
    },
  };
  fo("blog-section", [on]), fo("hero", Ho), fo("double", on);
  const nn = (t) => {
    let { stickyHeaderHeight: e } = c();
    window.scrollTo({
      top: t + window.scrollY - e,
      left: 0,
      behavior: "smooth",
    });
  };
  let rn = class {
    write() {
      ((-1 !== document.cookie.indexOf("; ") &&
        !document.cookie.split("; ").find((t) => t.startsWith(this.name))) ||
        -1 === document.cookie.indexOf("; ")) &&
        (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
    }
    read() {
      if (
        -1 !== document.cookie.indexOf("; ") &&
        document.cookie.split("; ").find((t) => t.startsWith(this.name))
      ) {
        return document.cookie
          .split("; ")
          .find((t) => t.startsWith(this.name))
          .split("=")[1];
      }
      return !1;
    }
    destroy() {
      document.cookie.split("; ").find((t) => t.startsWith(this.name)) &&
        (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
    }
    constructor(t, e, s = 7) {
      const i = new Date(),
        o = new Date();
      o.setTime(i.getTime() + 864e5 * s),
        (this.configuration = {
          expires: o.toGMTString(),
          path: "/",
          domain: window.location.hostname,
          sameSite: "none",
          secure: !0,
        }),
        (this.name = t),
        (this.value = e);
    }
  };
  const an = "[data-newsletter-form]",
    ln = "[data-newsletter-heading]",
    cn = "[data-newsletter]",
    hn = "has-success",
    dn = "has-error",
    un = "hidden",
    pn = "data-cookie-name",
    mn = {};
  const vn = {
    onLoad() {
      mn[this.id] = [];
      this.container.querySelectorAll(an).forEach((t) => {
        mn[this.id].push(
          new (class {
            init() {
              this.newsletter.addEventListener("submit", this.newsletterSubmit),
                this.showMessage();
            }
            newsletterSubmitEvent(t) {
              this.stopSubmit &&
                (t.preventDefault(),
                t.stopImmediatePropagation(),
                this.removeStorage(),
                this.writeStorage(),
                (this.stopSubmit = !1),
                this.newsletter.submit());
            }
            checkForChallengePage() {
              this.isChallengePage = "/challenge" === window.location.pathname;
            }
            writeStorage() {
              void 0 !== this.sessionStorage &&
                this.sessionStorage.setItem(
                  "newsletter_form_id",
                  this.newsletter.id
                );
            }
            readStorage() {
              this.formID = this.sessionStorage.getItem("newsletter_form_id");
            }
            removeStorage() {
              this.sessionStorage.removeItem("newsletter_form_id");
            }
            showMessage() {
              if ((this.readStorage(), this.newsletter.id === this.formID)) {
                const t = document.getElementById(this.formID),
                  e = t.parentElement.querySelector(ln),
                  s =
                    -1 !==
                    window.location.search.indexOf("?customer_posted=true"),
                  i =
                    -1 !== window.location.search.indexOf("accepts_marketing");
                s
                  ? (t.classList.remove(dn),
                    t.classList.add(hn),
                    e && (e.classList.add(un), t.classList.remove(un)),
                    this.popup && this.cookie.write())
                  : i &&
                    (t.classList.remove(hn),
                    t.classList.add(dn),
                    e && (e.classList.add(un), t.classList.remove(un))),
                  (s || i) &&
                    window.addEventListener("load", () => {
                      this.scrollToForm(t);
                    });
              }
            }
            scrollToForm(t) {
              const e = t.getBoundingClientRect();
              (e.top >= 0 &&
                e.left >= 0 &&
                e.bottom <= f() &&
                e.right <= g()) ||
                setTimeout(() => {
                  nn(t.getBoundingClientRect().top);
                }, 500);
            }
            unload() {
              this.newsletter.removeEventListener(
                "submit",
                this.newsletterSubmit
              );
            }
            constructor(t) {
              (this.sessionStorage = window.sessionStorage),
                (this.newsletter = t),
                (this.popup = this.newsletter.closest(cn)),
                this.popup &&
                  (this.cookie = new rn(
                    this.popup.getAttribute(pn),
                    "user_has_closed",
                    null
                  )),
                (this.stopSubmit = !0),
                (this.isChallengePage = !1),
                (this.formID = null),
                this.checkForChallengePage(),
                (this.newsletterSubmit = (t) => this.newsletterSubmitEvent(t)),
                this.isChallengePage || this.init();
            }
          })(t)
        );
      });
    },
    onUnload() {
      mn[this.id].forEach((t) => {
        "function" == typeof t.unload && t.unload();
      });
    },
  };
  fo("footer", [Ho, vn]);
  const gn = "[data-section-type]",
    fn = "[data-collection-sidebar]",
    yn = "[data-collection-sidebar-slide-out]",
    bn = "[data-collection-sidebar-close]",
    wn = "[data-collection-filters-form]",
    En = "input",
    Sn = "select",
    Ln = "label",
    kn = "textarea",
    An = "[data-field-price-min]",
    Tn = "[data-field-price-max]",
    Cn = "data-field-price-min",
    qn = "data-field-price-max",
    xn = "[data-se-min-value]",
    Mn = "[data-se-max-value]",
    Pn = "data-se-min-value",
    Hn = "data-se-max-value",
    In = "data-se-min",
    Bn = "data-se-max",
    On = "[data-show-more]",
    Fn = "[data-link-hidden]",
    Dn = "[data-collection-nav]",
    $n = "[data-products-grid]",
    _n = "[data-active-filters]",
    Nn = "data-active-filters-count",
    Rn = "[data-filter-update-url]",
    Un = "[data-sort-enabled]",
    zn = "[data-sort-link]",
    Wn = "data-value",
    Vn = "[data-popout-toggle]",
    jn = "[data-sort-button-text]",
    Xn = "hidden",
    Jn = "is-focused",
    Yn = "is-loading",
    Qn = "is-active";
  let Gn = class extends HTMLElement {
    connectedCallback() {
      this.sort &&
        this.sortLinks.length &&
        this.sortLinks.forEach((t) => {
          t.addEventListener("click", this.onSortButtonClickEvent);
        }),
        this.collectionSidebar &&
          this.form &&
          (this.collectionSidebar.addEventListener(
            "input",
            this.updatePriceEvent
          ),
          this.collectionSidebar.addEventListener(
            "theme:range:update",
            this.updateRangeEvent
          )),
        this.showMoreOptions.length &&
          this.showMoreOptions.forEach((t) => {
            t.addEventListener("click", this.showMoreEvent);
          }),
        (this.collectionSidebar || this.sort) &&
          window.addEventListener("popstate", this.submitFormEvent),
        this.filterUrlButtons.length &&
          this.filterUrlButtons.forEach((t) => {
            t.addEventListener("click", this.filterUpdateFromUrlEvent);
          }),
        this.collectionSidebarCloseButtons.length &&
          this.collectionSidebarCloseButtons.forEach((t) => {
            t.addEventListener("click", this.collectionSidebarCloseEvent);
          });
    }
    collectionSidebarClose(t) {
      t.preventDefault(),
        this.container.dispatchEvent(
          new CustomEvent("theme:filter:close", { bubbles: !1 })
        );
    }
    onSortButtonClick(t) {
      t.preventDefault(),
        this.sortButton && this.sortButton.dispatchEvent(new Event("click")),
        this.sortActions(t, t.currentTarget);
    }
    sortActions(t, e, s = !0) {
      const i = this.sort.querySelector(jn),
        o = this.sort.querySelector(`.${Qn}`);
      if (i) {
        const t = e ? e.textContent.trim() : "";
        i.textContent = t;
      }
      o && o.classList.remove(Qn),
        this.sort.classList.toggle(Qn, e),
        e && (e.parentElement.classList.add(Qn), s && this.submitForm(t));
    }
    onSortCheck(t) {
      let e = null;
      if (window.location.search.includes("sort_by")) {
        const t = new window.URL(window.location.href).searchParams;
        for (const [s, i] of t.entries()) {
          const t = this.sort.querySelector(`[${Wn}="${i}"]`);
          if (s.includes("sort_by") && t) {
            e = t;
            break;
          }
        }
      }
      this.sortActions(t, e, !1);
    }
    showMore(t) {
      t.preventDefault();
      const e = t.target.matches(On) ? t.target : t.target.closest(On);
      e.parentElement.classList.add(Xn),
        e.parentElement.previousElementSibling
          .querySelectorAll(Fn)
          .forEach((t, e) => {
            t.classList.remove(Xn);
            const s = t.querySelector(En);
            0 === e &&
              document.body.classList.contains(Jn) &&
              s &&
              (this.collectionSidebarSlideOut || b()
                ? (this.a11y.removeTrapFocus(),
                  this.a11y.trapFocus(this.collectionSidebar, {
                    elementToFocus: s,
                  }))
                : s.focus());
          });
    }
    updatePrice(t) {
      const e = t.type,
        s = t.target;
      if (
        (e === En || e === Sn || e === Ln || e === kn) &&
        this.form &&
        "function" == typeof this.form.submit
      ) {
        const e = this.form.querySelector(An),
          i = this.form.querySelector(Tn);
        e &&
          i &&
          (s.hasAttribute(Cn) && !i.value
            ? (i.value = i.placeholder)
            : s.hasAttribute(qn) && !e.value && (e.value = e.placeholder)),
          this.submitForm(t);
      }
    }
    updateRange(t) {
      if (this.form && "function" == typeof this.form.submit) {
        const e = this.form.querySelector(xn),
          s = this.form.querySelector(Mn),
          i = this.form.querySelector(An),
          o = this.form.querySelector(Tn);
        if (e && s && i && o && e.hasAttribute(Pn) && s.hasAttribute(Hn)) {
          const n = parseInt(i.placeholder),
            r = parseInt(o.placeholder),
            a = parseInt(e.getAttribute(Pn)),
            l = parseInt(s.getAttribute(Hn));
          (n === a && r === l) ||
            ((i.value = a), (o.value = l), this.submitForm(t));
        }
      }
    }
    filterUpdateFromUrl(t) {
      t.preventDefault(),
        this.submitForm(t, t.currentTarget.getAttribute("href"));
    }
    submitForm(t, e = "") {
      if (!t || (t && "popstate" !== t.type))
        if ("" === e) {
          let t = new window.URL(window.location.href).searchParams;
          const e = t,
            s = Object.fromEntries(e),
            i = t.toString();
          if (
            i.includes("filter.") ||
            i.includes("page=") ||
            i.includes("sort_by=")
          )
            for (const e in s)
              (e.includes("filter.") || "page" === e || "sort_by" === e) &&
                t.delete(e);
          if (this.form) {
            const e = new FormData(this.form),
              s = new URLSearchParams(e),
              i = this.form.querySelector(xn),
              o = this.form.querySelector(Mn),
              n = i && i.hasAttribute(In) ? i.getAttribute(In) : "",
              r = o && o.hasAttribute(Bn) ? o.getAttribute(Bn) : "";
            let a = 0;
            for (let [e, i] of s.entries())
              ((e.includes("filter.") && i) || (e.includes("sort_by") && i)) &&
                (t.append(e, i),
                ((i === n && "filter.v.price.gte" === e) ||
                  (i === r && "filter.v.price.lte" === e)) &&
                  (a += 1));
            2 === a &&
              (t.delete("filter.v.price.gte"), t.delete("filter.v.price.lte"));
          }
          const o = t.toString(),
            n = o ? `?${o}` : location.pathname;
          window.history.pushState(null, "", n);
        } else window.history.pushState(null, "", e);
      else this.sort && this.onSortCheck(t);
      this.productsContainer &&
        (this.productsContainer.classList.add(Yn),
        fetch(`${window.location.pathname}${window.location.search}`)
          .then((t) => t.text())
          .then((t) => {
            const e = new DOMParser().parseFromString(t, "text/html");
            if (
              ((this.productsContainer.innerHTML =
                e.querySelector($n).innerHTML),
              this.collectionSidebar)
            ) {
              this.collectionSidebar.innerHTML = e.querySelector(fn).innerHTML;
              const t = this.collectionSidebar.querySelector(`[${Nn}]`),
                s = this.container.querySelectorAll(_n);
              if (t && s.length) {
                const e = parseInt(t.getAttribute(Nn));
                s.forEach((t) => {
                  (t.textContent = e), t.classList.toggle(Xn, e < 1);
                });
              }
            }
            this.collectionNav &&
              nn(
                this.productsContainer.getBoundingClientRect().top -
                  this.collectionNav.offsetHeight
              ),
              setTimeout(() => {
                this.productsContainer.classList.remove(Yn);
              }, 500);
          })
          .catch((t) => {
            console.log(t);
          }));
    }
    disconnectedCallback() {
      this.collectionSidebar &&
        this.form &&
        (this.collectionSidebar.removeEventListener(
          "input",
          this.updatePriceEvent
        ),
        this.collectionSidebar.removeEventListener(
          "theme:range:update",
          this.updateRangeEvent
        )),
        this.showMoreOptions.length &&
          this.showMoreOptions.forEach((t) => {
            t.removeEventListener("click", this.showMoreEvent);
          }),
        this.sort &&
          this.sortLinks.length &&
          this.sortLinks.forEach((t) => {
            t.removeEventListener("click", this.onSortButtonClickEvent);
          }),
        (this.collectionSidebar || this.sort) &&
          window.removeEventListener("popstate", this.submitFormEvent),
        this.filterUrlButtons.length &&
          this.filterUrlButtons.forEach((t) => {
            t.removeEventListener("click", this.filterUpdateFromUrlEvent);
          }),
        this.collectionSidebarCloseButtons.length &&
          this.collectionSidebarCloseButtons.forEach((t) => {
            t.removeEventListener("click", this.collectionSidebarCloseEvent);
          });
    }
    constructor() {
      super(),
        (this.container = this.closest(gn)),
        (this.collectionSidebar = this.container.querySelector(fn)),
        (this.collectionSidebarSlideOut = this.container.querySelector(yn)),
        (this.form = this.querySelector(wn)),
        (this.productsContainer = this.container.querySelector($n)),
        (this.collectionNav = this.container.querySelector(Dn)),
        (this.sort = this.container.querySelector(Un)),
        (this.sortButton = this.container.querySelector(Vn)),
        (this.sortLinks = this.container.querySelectorAll(zn)),
        (this.filterUrlButtons = this.container.querySelectorAll(Rn)),
        (this.collectionSidebarCloseButtons =
          this.container.querySelectorAll(bn)),
        (this.showMoreOptions = this.querySelectorAll(On)),
        (this.a11y = N),
        (this.updatePriceEvent = v((t) => this.updatePrice(t), 500)),
        (this.updateRangeEvent = (t) => this.updateRange(t)),
        (this.showMoreEvent = (t) => this.showMore(t)),
        (this.onSortButtonClickEvent = (t) => this.onSortButtonClick(t)),
        (this.submitFormEvent = (t) => this.submitForm(t)),
        (this.collectionSidebarCloseEvent = (t) =>
          this.collectionSidebarClose(t)),
        (this.filterUpdateFromUrlEvent = (t) => this.filterUpdateFromUrl(t));
    }
  };
  const Kn = "[data-collection-sidebar]",
    Zn = "[data-range-left]",
    tr = "[data-range-right]",
    er = "[data-range-line]",
    sr = "[data-range-holder]",
    ir = "data-se-min",
    or = "data-se-max",
    nr = "data-se-min-value",
    rr = "data-se-max-value",
    ar = "data-se-step",
    lr = "data-range-filter-update",
    cr = "[data-field-price-min]",
    hr = "[data-field-price-max]",
    dr = "is-initialized";
  let ur = class extends HTMLElement {
    connectedCallback() {
      let t = this.min;
      this.hasAttribute(nr) && (t = parseFloat(this.getAttribute(nr)));
      let e = this.max;
      this.hasAttribute(rr) && (e = parseFloat(this.getAttribute(rr))),
        t < this.min && (t = this.min),
        e > this.max && (e = this.max),
        t > e && (t = e),
        this.getAttribute(ar) &&
          (this.step = Math.abs(parseFloat(this.getAttribute(ar)))),
        this.reset(),
        (this.maxX = this.offsetWidth - this.touchRight.offsetWidth),
        (this.selectedTouch = null),
        (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact),
        this.setMinValue(t),
        this.setMaxValue(e),
        this.touchLeft.addEventListener("mousedown", this.onStartEvent),
        this.touchRight.addEventListener("mousedown", this.onStartEvent),
        this.touchLeft.addEventListener("touchstart", this.onStartEvent, {
          passive: !0,
        }),
        this.touchRight.addEventListener("touchstart", this.onStartEvent, {
          passive: !0,
        }),
        this.classList.add(dr);
    }
    reset() {
      (this.touchLeft.style.left = "0px"),
        (this.touchRight.style.left =
          this.offsetWidth - this.touchLeft.offsetWidth + "px"),
        (this.lineSpan.style.marginLeft = "0px"),
        (this.lineSpan.style.width =
          this.offsetWidth - this.touchLeft.offsetWidth + "px"),
        (this.startX = 0),
        (this.x = 0);
    }
    setMinValue(t) {
      const e = (t - this.min) / (this.max - this.min);
      (this.touchLeft.style.left =
        Math.ceil(
          e *
            (this.offsetWidth -
              (this.touchLeft.offsetWidth + this.normalizeFact))
        ) + "px"),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.setAttribute(nr, t);
    }
    setMaxValue(t) {
      const e = (t - this.min) / (this.max - this.min);
      (this.touchRight.style.left =
        Math.ceil(
          e *
            (this.offsetWidth -
              (this.touchLeft.offsetWidth + this.normalizeFact)) +
            this.normalizeFact
        ) + "px"),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.setAttribute(rr, t);
    }
    onStart(t) {
      let e = t;
      t.touches && (e = t.touches[0]),
        t.currentTarget === this.touchLeft
          ? (this.x = this.touchLeft.offsetLeft)
          : t.currentTarget === this.touchRight &&
            (this.x = this.touchRight.offsetLeft),
        (this.startX = e.pageX - this.x),
        (this.selectedTouch = t.currentTarget),
        document.addEventListener("mousemove", this.onMoveEvent),
        document.addEventListener("mouseup", this.onStopEvent),
        document.addEventListener("touchmove", this.onMoveEvent, {
          passive: !0,
        }),
        document.addEventListener("touchend", this.onStopEvent, {
          passive: !0,
        });
    }
    onMove(t) {
      let e = t;
      if (
        (t.touches && (e = t.touches[0]),
        (this.x = e.pageX - this.startX),
        this.selectedTouch === this.touchLeft
          ? (this.x >
            this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10
              ? (this.x =
                  this.touchRight.offsetLeft -
                  this.selectedTouch.offsetWidth +
                  10)
              : this.x < 0 && (this.x = 0),
            (this.selectedTouch.style.left = this.x + "px"))
          : this.selectedTouch === this.touchRight &&
            (this.x <
            this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10
              ? (this.x =
                  this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10)
              : this.x > this.maxX && (this.x = this.maxX),
            (this.selectedTouch.style.left = this.x + "px")),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.calculateValue(),
        this.getAttribute("on-change"))
      ) {
        new Function("min, max", this.getAttribute("on-change"))(
          this.getAttribute(nr),
          this.getAttribute(rr)
        );
      }
      this.onChange(this.getAttribute(nr), this.getAttribute(rr));
    }
    onStop() {
      document.removeEventListener("mousemove", this.onMoveEvent),
        document.removeEventListener("mouseup", this.onStopEvent),
        document.removeEventListener("touchmove", this.onMoveEvent),
        document.removeEventListener("touchend", this.onStopEvent),
        (this.selectedTouch = null),
        this.calculateValue(),
        this.onChanged(this.getAttribute(nr), this.getAttribute(rr));
    }
    onChange(t, e) {
      const s = this.closest(sr);
      if (s) {
        const i = s.querySelector(cr),
          o = s.querySelector(hr);
        i && o && ((i.value = t), (o.value = e));
      }
    }
    onChanged(t, e) {
      this.hasAttribute(lr) &&
        this.dispatchEvent(
          new CustomEvent("theme:range:update", { bubbles: !0 })
        );
    }
    calculateValue() {
      const t =
        (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
      let e = this.lineSpan.offsetLeft / this.initialValue,
        s = e + t;
      if (
        ((e = e * (this.max - this.min) + this.min),
        (s = s * (this.max - this.min) + this.min),
        0 !== this.step)
      ) {
        let t = Math.floor(e / this.step);
        (e = this.step * t),
          (t = Math.floor(s / this.step)),
          (s = this.step * t);
      }
      this.selectedTouch === this.touchLeft && this.setAttribute(nr, e),
        this.selectedTouch === this.touchRight && this.setAttribute(rr, s);
    }
    onSidebarTransitionEnd(t) {
      t.target == this.sidebar &&
        "min-width" == t.propertyName &&
        (this.sidebar.removeEventListener(
          "transitionend",
          this.sidebarTransitionEvent
        ),
        this.connectedCallback());
    }
    disconnectedCallback() {
      this.sidebar.removeEventListener(
        "transitionend",
        this.sidebarTransitionEvent
      ),
        this.resizeEvent &&
          document.removeEventListener("theme:resize:width", this.resizeEvent);
    }
    constructor() {
      super(),
        (this.sidebar = this.closest(Kn)),
        (this.sidebarTransitionEvent = (t) => this.onSidebarTransitionEnd(t)),
        (this.resizeEvent = () => {
          this.connectedCallback(),
            this.sidebar.addEventListener(
              "transitionend",
              this.sidebarTransitionEvent
            );
        }),
        (this.onMoveEvent = (t) => this.onMove(t)),
        (this.onStopEvent = (t) => this.onStop(t)),
        (this.onStartEvent = (t) => this.onStart(t)),
        (this.startX = 0),
        (this.x = 0),
        (this.touchLeft = this.querySelector(Zn)),
        (this.touchRight = this.querySelector(tr)),
        (this.lineSpan = this.querySelector(er)),
        (this.min = parseFloat(this.getAttribute(ir))),
        (this.max = parseFloat(this.getAttribute(or))),
        (this.step = 0),
        (this.normalizeFact = 26),
        document.addEventListener("theme:resize:width", this.resizeEvent);
    }
  };
  const pr = "[data-collection-sidebar]",
    mr = "[data-collection-sidebar-slide-out]",
    vr = "[data-collection-sidebar-close]",
    gr = "[data-aria-toggle]",
    fr = "drawer--animated",
    yr = "expanded",
    br = "no-mobile-animation",
    wr = "is-focused";
  let Er = {};
  fo("collection", [
    on,
    Ho,
    {
      onLoad() {
        Er[this.id] = new (class {
          init() {
            null !== this.groupTagsButton &&
              (document.addEventListener(
                "theme:resize:width",
                this.sidebarResizeEvent
              ),
              this.groupTagsButton.addEventListener(
                "click",
                this.groupTagsButtonClickEvent
              ),
              this.collectionSidebar &&
                setTimeout(() => {
                  this.collectionSidebar.classList.remove(br);
                }, 1e3),
              new MutationObserver((t) => {
                for (const e of t)
                  "attributes" === e.type &&
                    "true" == e.target.getAttribute("aria-expanded") &&
                    this.showSidebarCallback();
              }).observe(this.groupTagsButton, {
                attributes: !0,
                childList: !1,
                subtree: !1,
              })),
              this.container.addEventListener(
                "keyup",
                function (t) {
                  "Escape" === t.code && this.hideSidebar();
                }.bind(this)
              ),
              this.collectionSidebar &&
                (this.collectionSidebar.addEventListener(
                  "transitionend",
                  () => {
                    this.collectionSidebar.classList.contains(yr) ||
                      this.collectionSidebar.classList.remove(fr);
                  }
                ),
                this.toggleSidebarSlider(),
                this.container.addEventListener(
                  "theme:filter:close",
                  this.collectionSidebarCloseEvent
                ));
          }
          showSidebarCallback() {
            const t = this.container.querySelector(mr),
              e = document.documentElement.hasAttribute("data-scroll-locked"),
              s = b();
            this.collectionSidebar.classList.add(fr),
              null === t &&
                !s &&
                e &&
                (this.a11y.removeTrapFocus(),
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                )),
              (s || null !== t) &&
                (t &&
                  this.a11y.trapFocus(this.collectionSidebar, {
                    elementToFocus: this.collectionSidebar.querySelector(vr),
                  }),
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:lock", { bubbles: !0 })
                ));
          }
          hideSidebar() {
            const t = this.container.querySelector(mr),
              e = document.documentElement.hasAttribute("data-scroll-locked");
            this.groupTagsButton.setAttribute("aria-expanded", "false"),
              this.collectionSidebar.classList.remove(yr),
              t && this.a11y.removeTrapFocus(),
              e &&
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                );
          }
          toggleSidebarSlider() {
            b()
              ? this.hideSidebar()
              : this.collectionSidebar.classList.contains(yr) &&
                this.showSidebarCallback();
          }
          collectionSidebarClose(t) {
            t.preventDefault(),
              this.hideSidebar(),
              document.body.classList.contains(wr) &&
                this.groupTagsButton &&
                this.groupTagsButton.focus();
          }
          groupTagsButtonClick() {
            document.documentElement.hasAttribute("data-scroll-locked") &&
              document.dispatchEvent(
                new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
              );
          }
          onUnload() {
            null !== this.groupTagsButton &&
              (document.removeEventListener(
                "theme:resize:width",
                this.sidebarResizeEvent
              ),
              this.groupTagsButton.removeEventListener(
                "click",
                this.groupTagsButtonClickEvent
              )),
              this.collectionSidebar &&
                this.container.removeEventListener(
                  "theme:filter:close",
                  this.collectionSidebarCloseEvent
                );
          }
          constructor(t) {
            (this.container = t.container),
              (this.collectionSidebar = this.container.querySelector(pr)),
              (this.groupTagsButton = this.container.querySelector(gr)),
              (this.a11y = N),
              (this.groupTagsButtonClickEvent = (t) =>
                this.groupTagsButtonClick(t)),
              (this.sidebarResizeEvent = () => this.toggleSidebarSlider()),
              (this.collectionSidebarCloseEvent = (t) =>
                this.collectionSidebarClose(t)),
              this.init();
          }
        })(this);
      },
      onUnload() {
        Er[this.id].onUnload();
      },
    },
    Mo,
  ]),
    customElements.get("collection-filters-form") ||
      customElements.define("collection-filters-form", Gn),
    customElements.get("range-slider") ||
      customElements.define("range-slider", ur);
  const Sr = "[data-ticker-scale]",
    Lr = "[data-ticker-text]",
    kr = "data-clone",
    Ar = "autoplay",
    Tr = "speed",
    Cr = "ticker--animated",
    qr = "ticker--unloaded",
    xr = "ticker__comparitor",
    Mr = 1.63,
    Pr = 100;
  let Hr = class extends HTMLElement {
    connectedCallback() {
      this.checkWidth(),
        this.addEventListener("theme:ticker:refresh", this.checkWidthEvent),
        document.addEventListener("theme:resize:width", this.checkWidthEvent);
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize:width", this.checkWidthEvent);
    }
    checkWidth() {
      const t = 2 * window.getComputedStyle(this).paddingLeft.replace("px", "");
      if (this.clientWidth - t < this.comparitor.clientWidth || this.autoplay) {
        if ((this.text.classList.add(Cr), 1 === this.scale.childElementCount)) {
          if (
            ((this.clone = this.text.cloneNode(!0)),
            this.clone.setAttribute(kr, ""),
            this.scale.appendChild(this.clone),
            this.autoplay)
          )
            for (let t = 0; t < 10; t++) {
              const t = this.text.cloneNode(!0);
              t.setAttribute(kr, ""), this.scale.appendChild(t);
            }
          const t = ((this.text.clientWidth / Pr) * Number(this.speed)).toFixed(
            2
          );
          this.scale.style.setProperty("--animation-time", `${t}s`);
        }
      } else {
        this.text.classList.add(Cr);
        let t = this.scale.querySelector(`[${kr}]`);
        t && this.scale.removeChild(t), this.text.classList.remove(Cr);
      }
    }
    constructor() {
      super(),
        (this.autoplay = this.hasAttribute(Ar)),
        (this.scale = this.querySelector(Sr)),
        (this.text = this.querySelector(Lr)),
        (this.speed = this.hasAttribute(Tr) ? this.getAttribute(Tr) : Mr),
        (this.comparitor = this.text.cloneNode(!0)),
        this.comparitor.classList.add(xr),
        this.appendChild(this.comparitor),
        this.scale.classList.remove(qr),
        (this.checkWidthEvent = this.checkWidth.bind(this));
    }
  };
  const Ir = { slide: "[data-slide]", slider: "[data-slider]" },
    Br = "data-target-referrer";
  let Or = class extends HTMLElement {
    connectedCallback() {
      this.removeAnnouncement(),
        this.slider && this.initSliders(),
        this.addEventListener("theme:block:select", (t) => {
          this.onBlockSelect(t);
        }),
        this.addEventListener("theme:block:deselect", (t) => {
          this.onBlockDeselect(t);
        }),
        document.dispatchEvent(
          new CustomEvent("theme:announcement:init", { bubbles: !0 })
        );
    }
    removeAnnouncement() {
      for (let t = 0; t < this.slides.length; t++) {
        const e = this.slides[t];
        e.hasAttribute(Br) &&
          (-1 !== this.locationPath.indexOf(e.getAttribute(Br)) ||
            window.Shopify.designMode ||
            e.parentNode.removeChild(e));
      }
    }
    initSliders() {
      this.initSlider(),
        document.addEventListener("theme:resize:width", this.initSliderEvent),
        this.addEventListener("theme:slider:loaded", () => {
          var t;
          null === (t = this.querySelectorAll(Ir.tickerBar)) ||
            void 0 === t ||
            t.forEach((t) => {
              t.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
            });
        });
    }
    initSlider() {
      const t = y(),
        e = !t;
      var s, i;
      ((t && this.enableSlider) || (e && !this.enableSlider)) &&
        (null === (s = this.slider.flkty) || void 0 === s || s.destroy(),
        t && this.enableSlider
          ? (this.enableSlider = !1)
          : e && !this.enableSlider && (this.enableSlider = !0),
        (this.slider = new sn(this, this.querySelector(Ir.slider))),
        null === (i = this.slider.flkty) || void 0 === i || i.reposition());
    }
    onBlockSelect(t) {
      this.slider && this.slider.onBlockSelect(t);
    }
    onBlockDeselect(t) {
      this.slider && this.slider.onBlockDeselect(t);
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize:width", this.initSliderEvent),
        document.removeEventListener(
          "theme:resize:width",
          this.tickerResizeEvent
        ),
        this.removeEventListener("theme:block:select", (t) => {
          this.onBlockSelect(t);
        }),
        this.removeEventListener("theme:block:deselect", (t) => {
          this.onBlockDeselect(t);
        });
    }
    constructor() {
      super(),
        (this.locationPath = location.href),
        (this.slides = this.querySelectorAll(Ir.slide)),
        (this.slider = this.querySelector(Ir.slider)),
        (this.enableSlider = y()),
        (this.initSliderEvent = (t) => this.initSlider(t));
    }
  };
  customElements.get("announcement-bar") ||
    customElements.define("announcement-bar", Or),
    customElements.get("ticker-bar") || customElements.define("ticker-bar", Hr);
  const Fr = "body",
    Dr = "[data-drawer]",
    $r = "[data-drawer-inner]",
    _r = "[data-drawer-underlay]",
    Nr = "[data-stagger-animation]",
    Rr = "[data-header-wrapper]",
    Ur = "data-drawer-toggle",
    zr = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    Wr = "drawer--animated",
    Vr = "is-open",
    jr = "is-focused";
  let Xr = {};
  const Jr = {
      onLoad() {
        Xr[this.id] = [];
        this.container.querySelectorAll(Dr).forEach((t) => {
          Xr[this.id].push(
            new (class {
              connectToggle() {
                this.buttons.forEach((t) => {
                  t.addEventListener("click", () => {
                    this.drawer.dispatchEvent(
                      new CustomEvent("theme:drawer:toggle", { bubbles: !1 })
                    );
                  });
                });
              }
              connectDrawer() {
                this.drawer.addEventListener("theme:drawer:toggle", () => {
                  this.drawer.classList.contains(Vr)
                    ? this.drawer.dispatchEvent(
                        new CustomEvent("theme:drawer:close", { bubbles: !0 })
                      )
                    : this.drawer.dispatchEvent(
                        new CustomEvent("theme:drawer:open", { bubbles: !0 })
                      );
                }),
                  this.drawerInner &&
                    this.drawerInner.addEventListener("transitionend", (t) => {
                      t.target == this.drawerInner &&
                        (this.drawer.classList.contains(Vr) ||
                          (this.drawer.classList.remove(Wr),
                          document.dispatchEvent(
                            new CustomEvent("theme:sliderule:close", {
                              bubbles: !1,
                            })
                          )));
                    }),
                  document.addEventListener("theme:cart:open", this.hideDrawer),
                  document.addEventListener(
                    "theme:drawer:close",
                    this.hideDrawer
                  ),
                  document.addEventListener(
                    "theme:drawer:open",
                    this.showDrawer
                  );
              }
              watchFocus(t) {
                !this.wrapper.contains(t.target) &&
                  this.body.classList.contains(jr) &&
                  this.hideDrawer();
              }
              closers() {
                this.wrapper.addEventListener(
                  "keyup",
                  function (t) {
                    "Escape" === t.code &&
                      (this.hideDrawer(), this.buttons[0].focus());
                  }.bind(this)
                ),
                  this.underlay.addEventListener("click", () => {
                    this.hideDrawer();
                  });
              }
              showDrawer() {
                this.drawerInner &&
                  this.drawerInner.querySelector(this.btnSelector) &&
                  (this.accessibility.removeTrapFocus(),
                  this.drawerInner.addEventListener("transitionend", (t) => {
                    t.target == this.drawerInner &&
                      this.drawer.classList.contains(Vr) &&
                      this.accessibility.trapFocus(this.drawerInner, {
                        elementToFocus: this.drawerInner.querySelector(
                          this.btnSelector
                        ),
                      });
                  })),
                  this.buttons.forEach((t) => {
                    t.setAttribute("aria-expanded", !0);
                  }),
                  this.drawer.classList.add(Vr),
                  this.drawer.classList.add(Wr),
                  this.drawer.querySelector(zr).focus(),
                  document.addEventListener("focusin", this.initWatchFocus),
                  document.dispatchEvent(
                    new CustomEvent("theme:scroll:lock", { bubbles: !0 })
                  );
              }
              hideDrawer() {
                this.drawer.classList.contains(Vr) &&
                  (this.accessibility.removeTrapFocus(),
                  this.body.classList.contains(jr) &&
                    this.buttons.length &&
                    this.buttons[0].focus(),
                  this.buttons.forEach((t) => {
                    t.setAttribute("aria-expanded", !1);
                  }),
                  this.drawer.classList.remove(Vr),
                  document.removeEventListener("focusin", this.initWatchFocus),
                  document.dispatchEvent(
                    new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                  ));
              }
              onUnload() {
                document.removeEventListener(
                  "theme:cart:open",
                  this.hideDrawer
                ),
                  document.removeEventListener(
                    "theme:drawer:close",
                    this.hideDrawer
                  ),
                  document.removeEventListener(
                    "theme:drawer:open",
                    this.showDrawer
                  );
              }
              constructor(t) {
                (this.drawer = t),
                  (this.drawerWrapper = this.drawer.closest(Dr)),
                  (this.drawerInner = this.drawer.querySelector($r)),
                  (this.underlay = this.drawer.querySelector(_r)),
                  (this.wrapper = this.drawer.closest(Rr)),
                  (this.key = this.drawer.dataset.drawer),
                  (this.btnSelector = `[${Ur}='${this.key}']`),
                  (this.buttons = document.querySelectorAll(this.btnSelector)),
                  (this.staggers = this.drawer.querySelectorAll(Nr)),
                  (this.body = document.querySelector(Fr)),
                  (this.accessibility = N),
                  (this.initWatchFocus = (t) => this.watchFocus(t)),
                  (this.showDrawer = this.showDrawer.bind(this)),
                  (this.hideDrawer = this.hideDrawer.bind(this)),
                  this.connectToggle(),
                  this.connectDrawer(),
                  this.closers();
              }
            })(t)
          );
        });
      },
      onUnload() {
        Xr[this.id].forEach((t) => {
          "function" == typeof t.onUnload && t.onUnload();
        });
      },
    },
    Yr = ".page-header",
    Qr = "js__header__stuck",
    Gr = "has-header-sticky",
    Kr = "shopify-section-group-header-group",
    Zr = "data-header-sticky",
    ta = "data-scroll-locked";
  let ea = {};
  const sa = {
      onLoad() {
        ea = new (class {
          listen() {
            document.addEventListener("theme:scroll", this.scrollEvent),
              document.addEventListener(
                "shopify:section:load",
                this.updateHeaderOffset
              ),
              document.addEventListener(
                "shopify:section:unload",
                this.updateHeaderOffset
              );
          }
          onScroll(t) {
            t.detail.down
              ? !this.isStuck &&
                t.detail.position > this.headerOffset &&
                this.stickSimple()
              : t.detail.position <= this.headerOffset && this.unstickSimple();
          }
          updateHeaderOffset(t) {
            t.target.classList.contains(Kr) &&
              setTimeout(() => {
                var t;
                this.headerOffset =
                  null === (t = document.querySelector(Yr)) || void 0 === t
                    ? void 0
                    : t.offsetTop;
              });
          }
          stickOnLoad() {
            window.scrollY > this.headerOffset && this.stickSimple();
          }
          stickSimple() {
            this.cls.add(Qr), (this.isStuck = !0);
          }
          unstickSimple() {
            document.documentElement.hasAttribute(ta) ||
              (this.cls.remove(Qr), (this.isStuck = !1));
          }
          unload() {
            document.removeEventListener("theme:scroll", this.scrollEvent),
              document.removeEventListener(
                "shopify:section:load",
                this.updateHeaderOffset
              ),
              document.removeEventListener(
                "shopify:section:unload",
                this.updateHeaderOffset
              );
          }
          constructor(t) {
            var e;
            (this.wrapper = t),
              (this.sticks = this.wrapper.hasAttribute(Zr)),
              document.body.classList.toggle(Gr, this.sticks),
              this.sticks &&
                ((this.isStuck = !1),
                (this.cls = this.wrapper.classList),
                (this.headerOffset =
                  null === (e = document.querySelector(Yr)) || void 0 === e
                    ? void 0
                    : e.offsetTop),
                (this.updateHeaderOffset = this.updateHeaderOffset.bind(this)),
                (this.scrollEvent = (t) => this.onScroll(t)),
                this.listen(),
                this.stickOnLoad());
          }
        })(this.container);
      },
      onUnload: function () {
        "function" == typeof ea.unload && ea.unload();
      },
    },
    ia = "data-hover-disclosure-toggle",
    oa = "[data-hover-disclosure]",
    na = "[data-top-link]",
    ra = "[data-header-wrapper]",
    aa = "[data-stagger]",
    la = "[data-stagger-first]",
    ca = "[data-stagger-second]",
    ha = "is-visible",
    da = "meganav--visible",
    ua = "meganav--is-transitioning";
  let pa = {},
    ma = {};
  const va = {
      onLoad() {
        (pa[this.id] = []),
          (ma = this.container.querySelectorAll(oa)),
          ma.forEach((t) => {
            pa[this.id].push(
              new (class {
                onBlockSelect(t) {
                  this.disclosure.contains(t.target) && this.showDisclosure(t);
                }
                onBlockDeselect(t) {
                  this.disclosure.contains(t.target) && this.hideDisclosure();
                }
                showDisclosure(t) {
                  t &&
                    t.type &&
                    "mouseenter" === t.type &&
                    this.wrapper.classList.add(ua),
                    this.grandparent
                      ? this.wrapper.classList.add(da)
                      : this.wrapper.classList.remove(da),
                    this.trigger.setAttribute("aria-expanded", !0),
                    this.trigger.classList.add(ha),
                    this.disclosure.classList.add(ha),
                    this.transitionTimeout &&
                      clearTimeout(this.transitionTimeout),
                    (this.transitionTimeout = setTimeout(() => {
                      this.wrapper.classList.remove(ua);
                    }, 200));
                }
                hideDisclosure() {
                  this.disclosure.classList.remove(ha),
                    this.trigger.classList.remove(ha),
                    this.trigger.setAttribute("aria-expanded", !1),
                    this.wrapper.classList.remove(da, ua);
                }
                staggerChildAnimations() {
                  this.disclosure.querySelectorAll(aa).forEach((t, e) => {
                    t.style.transitionDelay = 50 * e + 10 + "ms";
                  }),
                    this.disclosure.querySelectorAll(la).forEach((t, e) => {
                      const s = 100 * e;
                      (t.style.transitionDelay = `${s}ms`),
                        t.parentElement.querySelectorAll(ca).forEach((t, e) => {
                          const i = 20 * (e + 1);
                          t.style.transitionDelay = `${s + i}ms`;
                        });
                    });
                }
                handleTablets() {
                  this.trigger.addEventListener(
                    "touchstart",
                    function (t) {
                      this.disclosure.classList.contains(ha) ||
                        (t.preventDefault(), this.showDisclosure(t));
                    }.bind(this),
                    { passive: !0 }
                  );
                }
                connectHoverToggle() {
                  this.trigger.addEventListener("mouseenter", (t) =>
                    this.showDisclosure(t)
                  ),
                    this.link.addEventListener("focus", (t) =>
                      this.showDisclosure(t)
                    ),
                    this.trigger.addEventListener("mouseleave", () =>
                      this.hideDisclosure()
                    ),
                    this.trigger.addEventListener("focusout", (t) => {
                      this.trigger.contains(t.relatedTarget) ||
                        this.hideDisclosure();
                    }),
                    this.disclosure.addEventListener("keyup", (t) => {
                      "Escape" === t.code && this.hideDisclosure();
                    });
                }
                constructor(t) {
                  (this.disclosure = t),
                    (this.wrapper = t.closest(ra)),
                    (this.key = this.disclosure.id),
                    (this.trigger = document.querySelector(
                      `[${ia}='${this.key}']`
                    )),
                    (this.link = this.trigger.querySelector(na)),
                    (this.grandparent =
                      this.trigger.classList.contains("grandparent")),
                    (this.transitionTimeout = 0),
                    this.trigger.setAttribute("aria-haspopup", !0),
                    this.trigger.setAttribute("aria-expanded", !1),
                    this.trigger.setAttribute("aria-controls", this.key),
                    this.connectHoverToggle(),
                    this.handleTablets(),
                    this.staggerChildAnimations();
                }
              })(t)
            );
          });
      },
      onBlockSelect(t) {
        pa[this.id].forEach((e) => {
          "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
        });
      },
      onBlockDeselect(t) {
        pa[this.id].forEach((e) => {
          "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
        });
      },
    },
    ga = "data-cart-count";
  const fa = {
      onLoad() {
        new (class {
          listen() {
            document.addEventListener("theme:cart:change", (t) => {
              (this.cartCount = t.detail.cartCount), this.update();
            });
          }
          update() {
            null !== this.cartCount &&
              this.counts.forEach((t) => {
                t.setAttribute(ga, this.cartCount),
                  (t.innerHTML =
                    this.cartCount < 10 ? `${this.cartCount}` : "9+");
              });
          }
          constructor(t) {
            (this.section = t),
              (this.counts = this.section.querySelectorAll(`[${ga}]`)),
              (this.cartCount = null),
              this.listen();
          }
        })(this.container);
      },
    },
    ya = {
      slideruleOpen: "data-sliderule-open",
      slideruleClose: "data-sliderule-close",
      sliderulePane: "data-sliderule-pane",
      slideruleWrappper: "[data-sliderule]",
      drawerContent: "[data-drawer-content]",
      focusable:
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      dataAnimates: "data-animates",
      children:
        ":scope > [data-animates],\n             :scope > * > [data-animates],\n             :scope > * > * >[data-animates],\n             :scope > * > .sliderule-grid  > *",
    },
    ba = "is-visible",
    wa = "is-hiding",
    Ea = "is-hidden",
    Sa = "is-focused",
    La = "is-scrolling";
  let ka = {};
  const Aa = {
      onLoad() {
        ka[this.id] = [];
        this.container.querySelectorAll(ya.slideruleWrappper).forEach((t) => {
          ka[this.id].push(
            new (class {
              clickEvents() {
                this.trigger.addEventListener("click", () => {
                  (this.cachedButton = this.trigger), this.showSliderule();
                }),
                  this.exit.forEach((t) => {
                    t.addEventListener("click", () => {
                      this.hideSliderule();
                    });
                  });
              }
              keyboardEvents() {
                this.sliderule.addEventListener("keyup", (t) => {
                  t.stopPropagation(),
                    "Escape" === t.code && this.hideSliderule();
                });
              }
              trapFocusSliderule(t = !0) {
                const e = t
                  ? this.sliderule.querySelector(this.exitSelector)
                  : this.cachedButton;
                this.accessibility.removeTrapFocus(),
                  e &&
                    this.drawerContent &&
                    this.accessibility.trapFocus(this.drawerContent, {
                      elementToFocus: document.body.classList.contains(Sa)
                        ? e
                        : null,
                    });
              }
              hideSliderule(t = !1) {
                const e = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
                this.pane.setAttribute(ya.sliderulePane, e),
                  this.pane.classList.add(wa),
                  this.sliderule.classList.add(wa);
                const s = t
                    ? `[${ya.dataAnimates}].${Ea}`
                    : `[${ya.dataAnimates}="${e}"]`,
                  i = this.pane.querySelectorAll(s);
                i.length &&
                  i.forEach((t) => {
                    t.classList.remove(Ea);
                  });
                const o = t
                  ? this.pane.querySelectorAll(`.${ba}, .${wa}`)
                  : this.children;
                o.forEach((s, i) => {
                  const n = o.length - 1 == i;
                  s.classList.remove(ba),
                    t &&
                      (s.classList.remove(wa), this.pane.classList.remove(wa));
                  const r = () => {
                    parseInt(this.pane.getAttribute(ya.sliderulePane)) === e &&
                      this.sliderule.classList.remove(ba),
                      this.sliderule.classList.remove(wa),
                      this.pane.classList.remove(wa),
                      n &&
                        (this.accessibility.removeTrapFocus(),
                        t || this.trapFocusSliderule(!1)),
                      s.removeEventListener("animationend", r);
                  };
                  window.theme.settings.enableAnimations
                    ? s.addEventListener("animationend", r)
                    : r();
                });
              }
              showSliderule() {
                let t = null;
                const e = this.sliderule.closest(`.${ba}`);
                let s = this.pane;
                e && (s = e),
                  s.scrollTo({ top: 0, left: 0, behavior: "smooth" }),
                  s.classList.add(La);
                const i = () => {
                  s.scrollTop <= 0
                    ? (s.classList.remove(La), t && cancelAnimationFrame(t))
                    : (t = requestAnimationFrame(i));
                };
                (t = requestAnimationFrame(i)),
                  this.sliderule.classList.add(ba);
                const o = parseInt(this.pane.dataset.sliderulePane, 10),
                  n = o + 1;
                this.pane.setAttribute(ya.sliderulePane, n);
                const r = this.pane.querySelectorAll(
                  `[${ya.dataAnimates}="${o}"]`
                );
                r.length &&
                  r.forEach((t, e) => {
                    const s = r.length - 1 == e;
                    t.classList.add(wa);
                    const i = () => {
                      t.classList.remove(wa),
                        parseInt(this.pane.getAttribute(ya.sliderulePane)) !==
                          o && t.classList.add(Ea),
                        s && this.trapFocusSliderule(),
                        t.removeEventListener("animationend", i);
                    };
                    window.theme.settings.enableAnimations
                      ? t.addEventListener("animationend", i)
                      : i();
                  });
              }
              closeSliderule() {
                this.pane &&
                  this.pane.hasAttribute(ya.sliderulePane) &&
                  parseInt(this.pane.getAttribute(ya.sliderulePane)) > 0 &&
                  (this.hideSliderule(!0),
                  parseInt(this.pane.getAttribute(ya.sliderulePane)) > 0 &&
                    this.pane.setAttribute(ya.sliderulePane, 0));
              }
              onUnload() {
                document.removeEventListener(
                  "theme:sliderule:close",
                  this.closeSliderule
                );
              }
              constructor(t) {
                (this.sliderule = t), (this.key = this.sliderule.id);
                const e = `[${ya.slideruleOpen}='${this.key}']`;
                (this.exitSelector = `[${ya.slideruleClose}='${this.key}']`),
                  (this.trigger = document.querySelector(e)),
                  (this.exit = document.querySelectorAll(this.exitSelector)),
                  (this.pane = document.querySelector(`[${ya.sliderulePane}]`)),
                  (this.children = this.sliderule.querySelectorAll(
                    ya.children
                  )),
                  (this.drawerContent = document.querySelector(
                    ya.drawerContent
                  )),
                  (this.cachedButton = null),
                  (this.accessibility = N),
                  this.trigger.setAttribute("aria-haspopup", !0),
                  this.trigger.setAttribute("aria-expanded", !1),
                  this.trigger.setAttribute("aria-controls", this.key),
                  (this.closeSliderule = this.closeSliderule.bind(this)),
                  this.clickEvents(),
                  this.keyboardEvents(),
                  document.addEventListener(
                    "theme:sliderule:close",
                    this.closeSliderule
                  );
              }
            })(t)
          );
        });
      },
      onUnload() {
        ka[this.id].forEach((t) => {
          "function" == typeof t.onUnload && t.onUnload();
        });
      },
    },
    Ta = "[data-takes-space-wrapper]",
    Ca = "[data-child-takes-space]",
    qa = "[data-header-desktop]",
    xa = '.navlink[href="#"]',
    Ma = "[data-cart-toggle]",
    Pa =
      ".main-content > .shopify-section.section-overlay-header:first-of-type",
    Ha = "js__header__clone",
    Ia = "has-first-section-overlay-header",
    Ba = "js__show__mobile",
    Oa = "has-header-transparent",
    Fa = "data-header-transparent";
  let Da = {};
  fo("header", [
    {
      onLoad() {
        Da = new (class {
          initTicker(t = !1) {
            this.tickerFrames.forEach((e) => {
              new Hr(e, t);
            }),
              (this.tickerResizeEvent = (t) => this.onTickerResize(t)),
              document.addEventListener(
                "theme:resize:width",
                this.tickerResizeEvent
              );
          }
          listenWidth() {
            "ResizeObserver" in window
              ? ((this.resizeObserver = new ResizeObserver(this.checkWidth)),
                this.resizeObserver.observe(this.wrapper))
              : document.addEventListener("theme:resize", this.checkWidth);
          }
          killDeadLinks() {
            this.deadLinks.forEach((t) => {
              t.onclick = (t) => {
                t.preventDefault();
              };
            });
          }
          checkWidth() {
            if (document.body.clientWidth < this.minWidth) {
              this.wrapper.classList.add(Ba);
              const { headerHeight: t } = c();
              document.documentElement.style.setProperty(
                "--header-height",
                `${t}px`
              );
            } else this.wrapper.classList.remove(Ba);
          }
          getMinWidth() {
            const t = this.wrapper.cloneNode(!0);
            t.classList.add(Ha), document.body.appendChild(t);
            const e = t.querySelectorAll(Ta);
            let s = 0,
              i = 0;
            return (
              e.forEach((t) => {
                const e = t.querySelectorAll(Ca);
                let o = 0;
                (o =
                  3 === e.length
                    ? (function (t) {
                        let e = [];
                        return (
                          t.forEach((t) => {
                            t.firstElementChild &&
                              e.push(t.firstElementChild.clientWidth);
                          }),
                          e[0] > e[2] ? (e[2] = e[0]) : (e[0] = e[2]),
                          e.reduce((t, e) => t + e)
                        );
                      })(e)
                    : (function (t) {
                        let e = 0;
                        return (
                          t.forEach((t) => {
                            e += t.clientWidth;
                          }),
                          e
                        );
                      })(e)),
                  o > s && ((s = o), (i = 20 * e.length));
              }),
              document.body.removeChild(t),
              s + i
            );
          }
          cartToggleEvent() {
            const t = this.wrapper.querySelectorAll(Ma);
            t.length &&
              t.forEach((t) => {
                t.addEventListener("click", (t) => {
                  t.preventDefault(),
                    document.dispatchEvent(
                      new CustomEvent("theme:cart:toggle", { bubbles: !0 })
                    );
                });
              });
          }
          unload() {
            var t;
            "ResizeObserver" in window
              ? null === (t = this.resizeObserver) ||
                void 0 === t ||
                t.unobserve(this.wrapper)
              : document.removeEventListener("theme:resize", this.checkWidth);
          }
          constructor(t) {
            (this.wrapper = t),
              (this.style = this.wrapper.dataset.style),
              (this.desktop = this.wrapper.querySelector(qa)),
              (this.deadLinks = document.querySelectorAll(xa)),
              (this.resizeObserver = null),
              (this.checkWidth = this.checkWidth.bind(this)),
              this.killDeadLinks(),
              "drawer" !== this.style &&
                this.desktop &&
                ((this.minWidth = this.getMinWidth()), this.listenWidth()),
              this.cartToggleEvent();
            const e = document.querySelector(Pa);
            document.body.classList.toggle(Oa, this.wrapper.hasAttribute(Fa)),
              document.body.classList.toggle(Ia, e);
          }
        })(this.container);
      },
      onUnload() {
        "function" == typeof Da.unload && Da.unload();
      },
    },
    Jr,
    Aa,
    sa,
    va,
    fa,
  ]),
    customElements.get("ticker-bar") || customElements.define("ticker-bar", Hr);
  const $a = "[data-block-scroll]",
    _a = "flickity-enabled",
    Na = {};
  const Ra = {
      onLoad() {
        Na[this.id] = new (class {
          onBlockSelect(t) {
            const e = this.container.querySelector($a);
            if (e && !e.classList.contains(_a)) {
              const s = t.srcElement;
              s &&
                e.scrollTo({ top: 0, left: s.offsetLeft, behavior: "smooth" });
            }
          }
          constructor(t) {
            this.container = t.container;
          }
        })(this);
      },
      onBlockSelect(t) {
        Na[this.id].onBlockSelect(t);
      },
    },
    Ua = "[data-slider-mobile]",
    za = "[data-slide]",
    Wa = "[data-slider-thumb]",
    Va = "[data-slider-container]",
    ja = "[data-popup-container]",
    Xa = "[data-popup-close]",
    Ja = "is-animating",
    Ya = "is-open",
    Qa = "data-slider-thumb",
    Ga = {};
  function Ka() {
    this.entries = [];
  }
  function Za(t, e) {
    tl(t);
    var s = (function (t, e) {
      tl(t),
        (function (t) {
          if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
          if (0 === t.length) throw new Error(t + " is empty.");
          if (!t[0].hasOwnProperty("name"))
            throw new Error(t[0] + "does not contain name key.");
          if ("string" != typeof t[0].name)
            throw new TypeError(
              "Invalid value type passed for name of option " +
                t[0].name +
                ". Value should be string."
            );
        })(e);
      var s = [];
      return (
        e.forEach(function (e) {
          for (var i = 0; i < t.options.length; i++) {
            if (
              (t.options[i].name || t.options[i]).toLowerCase() ===
              e.name.toLowerCase()
            ) {
              s[i] = e.value;
              break;
            }
          }
        }),
        s
      );
    })(t, e);
    return (function (t, e) {
      return (
        tl(t),
        (function (t) {
          if (Array.isArray(t) && "object" == typeof t[0])
            throw new Error(t + "is not a valid array of options.");
        })(e),
        t.variants.filter(function (t) {
          return e.every(function (e, s) {
            return t.options[s] === e;
          });
        })[0] || null
      );
    })(t, s);
  }
  function tl(t) {
    if ("object" != typeof t) throw new TypeError(t + " is not an object.");
    if (0 === Object.keys(t).length && t.constructor === Object)
      throw new Error(t + " is empty.");
  }
  fo("look", [
    {
      onLoad() {
        Ga[this.id] = new (class {
          init() {
            this.slider &&
              this.slides.length &&
              this.thumbs.length &&
              (this.popupContainer.addEventListener("transitionend", (t) => {
                t.target == this.popupContainer &&
                  (this.popupContainer.classList.remove(Ja),
                  t.target.classList.contains(Ya)
                    ? this.popupOpenCallback()
                    : this.popupCloseCallback());
              }),
              this.popupContainer.addEventListener("transitionstart", (t) => {
                t.target == this.popupContainer &&
                  this.popupContainer.classList.add(Ja);
              }),
              this.popupClose.forEach((t) => {
                t.addEventListener("click", () => {
                  this.popupContainer.classList.remove(Ya),
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                    );
                });
              }),
              this.thumbs.forEach((t, e) => {
                t.addEventListener("click", (s) => {
                  s.preventDefault();
                  const i =
                      t.hasAttribute(Qa) && "" !== t.getAttribute(Qa)
                        ? parseInt(t.getAttribute(Qa))
                        : e,
                    o = this.slides[i];
                  if (b()) {
                    const t = parseInt(
                      window.getComputedStyle(this.slider).paddingLeft
                    );
                    this.slider.scrollTo({
                      top: 0,
                      left: o.offsetLeft - t,
                      behavior: "auto",
                    }),
                      document.dispatchEvent(
                        new CustomEvent("theme:scroll:lock", { bubbles: !0 })
                      ),
                      this.popupContainer.classList.add(Ja, Ya);
                  } else {
                    let { stickyHeaderHeight: t } = c();
                    const e = o.getBoundingClientRect().top,
                      s = o.offsetHeight / 2,
                      i = window.innerHeight,
                      n = i / 2,
                      r = this.container.querySelector(Va);
                    let a = e + s - n + window.scrollY;
                    if (r) {
                      const e = r.getBoundingClientRect().top + window.scrollY,
                        s = e + r.offsetHeight;
                      a < e ? (a = e - t) : a + i > s && (a = s - i);
                    }
                    window.scrollTo({ top: a, left: 0, behavior: "smooth" });
                  }
                });
              }));
          }
          popupCloseByEvent() {
            this.popupContainer.classList.remove(Ya);
          }
          popupOpenCallback() {
            document.addEventListener(
              "theme:quick-add:open",
              this.popupCloseByEvent,
              { once: !0 }
            ),
              document.addEventListener(
                "theme:product:added",
                this.popupCloseByEvent,
                { once: !0 }
              );
          }
          popupCloseCallback() {
            document.removeEventListener(
              "theme:quick-add:open",
              this.popupCloseByEvent,
              { once: !0 }
            ),
              document.removeEventListener(
                "theme:product:added",
                this.popupCloseByEvent,
                { once: !0 }
              );
          }
          constructor(t) {
            (this.container = t.container),
              (this.slider = this.container.querySelector(Ua)),
              (this.slides = this.container.querySelectorAll(za)),
              (this.thumbs = this.container.querySelectorAll(Wa)),
              (this.popupContainer = this.container.querySelector(ja)),
              (this.popupClose = this.container.querySelectorAll(Xa)),
              (this.popupCloseByEvent = this.popupCloseByEvent.bind(this)),
              this.init();
          }
        })(this);
      },
    },
    Ra,
  ]),
    (Ka.prototype.add = function (t, e, s) {
      this.entries.push({ element: t, event: e, fn: s }),
        t.addEventListener(e, s);
    }),
    (Ka.prototype.removeAll = function () {
      this.entries = this.entries.filter(function (t) {
        return t.element.removeEventListener(t.event, t.fn), !1;
      });
    });
  var el = '[name="id"]',
    sl = '[name="selling_plan"]',
    il = '[name^="options"]',
    ol = '[name="quantity"]',
    nl = '[name^="properties"]';
  const rl = "data-scrollbar",
    al = "data-scrollbar-slider",
    ll = "data-scrollbar-slide-fullwidth",
    cl = "[data-scrollbar-arrow-prev]",
    hl = "[data-scrollbar-arrow-next]",
    dl = "is-hidden",
    ul = 200;
  let pl = class {
    init() {
      this.arrowNext &&
        this.arrowPrev &&
        (this.toggleNextArrow(), this.events());
    }
    listen() {
      document.addEventListener("theme:modal:open", () => {
        this.toggleNextArrow();
      }),
        document.addEventListener("theme:resize", () => {
          this.toggleNextArrow();
        });
    }
    events() {
      this.arrowNext.addEventListener("click", (t) => {
        t.preventDefault(), this.goToNext();
      }),
        this.arrowPrev.addEventListener("click", (t) => {
          t.preventDefault(), this.goToPrev();
        }),
        this.scrollbar.addEventListener("scroll", () => {
          this.togglePrevArrow(), this.toggleNextArrow();
        });
    }
    goToNext() {
      const t =
        (this.scrollbar.hasAttribute(ll)
          ? this.scrollbar.getBoundingClientRect().width
          : this.scrollbar.getBoundingClientRect().width / 2) +
        this.scrollbar.scrollLeft;
      this.move(t), this.arrowPrev.classList.remove(dl), this.toggleNextArrow();
    }
    goToPrev() {
      const t = this.scrollbar.hasAttribute(ll)
          ? this.scrollbar.getBoundingClientRect().width
          : this.scrollbar.getBoundingClientRect().width / 2,
        e = this.scrollbar.scrollLeft - t;
      this.move(e), this.arrowNext.classList.remove(dl), this.togglePrevArrow();
    }
    toggleNextArrow() {
      setTimeout(() => {
        this.arrowNext.classList.toggle(
          dl,
          Math.round(
            this.scrollbar.scrollLeft +
              this.scrollbar.getBoundingClientRect().width +
              1
          ) >= this.scrollbar.scrollWidth
        );
      }, ul);
    }
    togglePrevArrow() {
      setTimeout(() => {
        this.arrowPrev.classList.toggle(dl, this.scrollbar.scrollLeft <= 0);
      }, ul);
    }
    scrollToVisibleElement() {
      [].forEach.call(this.scrollbar.children, (t) => {
        t.addEventListener("click", (e) => {
          e.preventDefault(), this.move(t.offsetLeft - t.clientWidth);
        });
      });
    }
    move(t) {
      this.scrollbar.scrollTo({ top: 0, left: t, behavior: "smooth" });
    }
    constructor(t) {
      (this.scrollbar = t),
        (this.arrowNext = this.scrollbar.parentNode.querySelector(hl)),
        (this.arrowPrev = this.scrollbar.parentNode.querySelector(cl)),
        this.scrollbar.hasAttribute(rl) && (this.init(), this.listen()),
        this.scrollbar.hasAttribute(al) && this.scrollToVisibleElement();
    }
  };
  const ml = "[data-grid-swatch-form]",
    vl = "[data-grid-item]",
    gl = "[data-product-information]",
    fl = "[data-product-image]",
    yl = "[data-swatch-button]",
    bl = "[data-swatch-link]",
    wl = "[data-swatch-text]",
    El = "[data-swatch-template]",
    Sl = "is-visible",
    Ll = "hidden",
    kl = "no-events",
    Al = "swatch",
    Tl = "data-swatch-handle",
    Cl = "data-swatch-label",
    ql = "data-scrollbar",
    xl = "data-swatch-count",
    Ml = "data-tooltip",
    Pl = "data-swatch-variant-name",
    Hl = "data-variant-title",
    Il = "data-swatch-values";
  let Bl = class extends HTMLElement {
      connectedCallback() {
        this.hasAttribute(Ml) && new xo(this);
      }
      constructor() {
        super();
      }
    },
    Ol = class extends HTMLElement {
      connectedCallback() {
        (this.handle = this.getAttribute(Tl)),
          (this.productItem = this.closest(vl)),
          (this.productInfo = this.closest(gl)),
          (this.productImage = this.productItem.querySelector(fl)),
          (this.template = document.querySelector(El).innerHTML),
          (this.swatchesJSON = this.getSwatchesJSON());
        const t = this.getAttribute(Cl).trim().toLowerCase();
        (function (t) {
          const e = `${window.theme.routes.root}products/${t}.js`;
          return window
            .fetch(e)
            .then((t) => t.json())
            .catch((t) => {
              console.error(t);
            });
        })(this.handle).then((e) => {
          (this.product = e),
            (this.colorOption = e.options.find(function (e) {
              return e.name.toLowerCase() === t || null;
            })),
            this.colorOption &&
              ((this.swatches = this.colorOption.values), this.init());
        });
      }
      init() {
        (this.innerHTML = ""),
          (this.count = 0),
          this.swatches.forEach((t) => {
            let e = null,
              s = !1,
              i = "";
            for (const s of this.product.variants) {
              const o = s.options.includes(t);
              if ((!e && o && (e = s), o && s.featured_media)) {
                (i = s.featured_media.preview_image.src), (e = s);
                break;
              }
            }
            for (const e of this.product.variants) {
              if (e.options.includes(t) && e.available) {
                s = !0;
                break;
              }
            }
            if (e) {
              const r = document.createElement("div");
              r.innerHTML = this.template;
              const a = r.querySelector(yl),
                l = r.querySelector(bl),
                c = r.querySelector(wl),
                h = this.swatchesJSON[t],
                d = e.title.replaceAll('"', "'");
              (a.style = `--animation-delay: ${(100 * this.count) / 1e3}s`),
                a.classList.add(`${Al}-${h}`),
                (a.dataset.tooltip = t),
                (a.dataset.swatchVariant = e.id),
                (a.dataset.swatchVariantName = d),
                (a.dataset.swatchImage = i),
                (a.dataset.variant = e.id),
                a.style.setProperty("--swatch", `var(--${h})`),
                (l.href =
                  ((o = this.product.url),
                  (n = e.id),
                  /variant=/.test(o)
                    ? o.replace(/(variant=)[^&]+/, "$1" + n)
                    : /\?/.test(o)
                    ? o.concat("&variant=").concat(n)
                    : o.concat("?variant=").concat(n))),
                (l.dataset.swatch = t),
                (l.disabled = !s),
                (c.innerText = t),
                (this.innerHTML += r.innerHTML),
                this.count++;
            }
            var o, n;
          }),
          (this.swatchCount = this.productInfo.querySelector(`[${xl}]`)),
          (this.swatchElements = this.querySelectorAll(bl)),
          (this.swatchForm = this.productInfo.querySelector(ml)),
          (this.hideSwatchesTimer = 0),
          this.swatchCount.hasAttribute(xl) &&
            ((this.swatchCount.innerText = `${this.count} ${
              this.count > 1 ? theme.strings.otherColor : theme.strings.oneColor
            }`),
            this.swatchCount.addEventListener("mouseenter", () => {
              this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer),
                this.productInfo.classList.add(kl),
                this.swatchForm.classList.add(Sl);
            }),
            this.productInfo.addEventListener("mouseleave", () => {
              this.hideSwatchesTimer = setTimeout(() => {
                this.productInfo.classList.remove(kl),
                  this.swatchForm.classList.remove(Sl);
              }, 100);
            })),
          this.hasAttribute(ql) && new pl(this),
          this.showDeferredImage(),
          this.bindSwatchButtonEvents();
      }
      showDeferredImage() {
        const t = this.productItem.querySelectorAll(`[${Hl}]`);
        t.length &&
          this.productItem.addEventListener(
            "mouseenter",
            () => {
              t.forEach((t) => {
                t.classList.remove(Ll);
              });
            },
            { once: !0 }
          );
      }
      bindSwatchButtonEvents() {
        var t;
        null === (t = this.querySelectorAll(yl)) ||
          void 0 === t ||
          t.forEach((t) => {
            t.addEventListener("mouseenter", this.showVariantImageEvent),
              t.hasAttribute(Ml) && new xo(t);
          }),
          this.productItem.addEventListener(
            "mouseleave",
            this.productItemMouseLeaveEvent
          );
      }
      showVariantImage(t) {
        var e;
        const s =
            null === (e = t.target.getAttribute(Pl)) || void 0 === e
              ? void 0
              : e.replaceAll('"', "'"),
          i = this.productImage.querySelectorAll(`[${Hl}]`),
          o = this.productImage.querySelector(`[${Hl}="${s}"]`);
        null == i ||
          i.forEach((t) => {
            t.classList.remove(Sl);
          }),
          null == o || o.classList.add(Sl);
      }
      hideVariantImages() {
        var t;
        null === (t = this.productImage.querySelectorAll(`[${Hl}].${Sl}`)) ||
          void 0 === t ||
          t.forEach((t) => {
            t.classList.remove(Sl);
          });
      }
      getSwatchesJSON() {
        if (!this.hasAttribute(Il)) return {};
        const t = this.getAttribute(Il).split(","),
          e = {};
        return (
          null == t ||
            t.forEach((t) => {
              const [s, i] = t.split(":");
              e[s.trim()] = i.trim();
            }),
          e
        );
      }
      constructor() {
        super(),
          (this.productItemMouseLeaveEvent = () => this.hideVariantImages()),
          (this.showVariantImageEvent = (t) => this.showVariantImage(t));
      }
    };
  const Fl = {
      productCutline: "[data-product-cutline]",
      productLink: "[data-product-link]",
      productGridItem: "[data-grid-item]",
      productInfo: "[data-product-information]",
      productImage: "[data-product-image-default]",
      productImageSibling: "[data-product-image-sibling]",
      productPrice: "[data-product-price]",
      siblingsInnerHolder: "[data-sibling-inner]",
      siblingCount: "[data-sibling-count]",
      siblingFieldset: "[data-sibling-fieldset]",
      siblingLink: "[data-sibling-link]",
      tooltip: "[data-tooltip]",
    },
    Dl = "is-visible",
    $l = "is-fade",
    _l = "no-events",
    Nl = "is-active",
    Rl = "data-sibling-cutline",
    Ul = "data-sibling-image",
    zl = "data-sibling-link",
    Wl = "data-sibling-price",
    Vl = "data-product-link";
  let jl = class extends HTMLElement {
    connectedCallback() {
      (this.product = this.closest(Fl.productGridItem)),
        (this.siblingScrollbar = this.querySelector(Fl.siblingsInnerHolder)),
        (this.siblingCount = this.querySelector(Fl.siblingCount)),
        (this.siblingFieldset = this.querySelector(Fl.siblingFieldset)),
        (this.siblingLinks = this.querySelectorAll(Fl.siblingLink)),
        (this.productInfo = this.closest(Fl.productInfo)),
        (this.productLink = this.closest(Fl.link)),
        (this.hideSwatchesTimer = 0),
        this.initScrollbar(),
        this.siblingCount &&
          this.siblingFieldset &&
          this.productInfo &&
          (this.siblingCount.addEventListener("mouseenter", () =>
            this.showSiblings()
          ),
          this.productInfo.addEventListener("mouseleave", () =>
            this.hideSiblings()
          )),
        this.siblingLinks.length &&
          new (class {
            init() {
              this.cacheDefaultValues(),
                this.product.addEventListener("mouseleave", () =>
                  this.resetProductValues()
                ),
                this.swatches.forEach((t) => {
                  t.addEventListener("mouseenter", (t) => this.showSibling(t));
                }),
                this.productLinks.length &&
                  this.swatches.forEach((t) => {
                    t.addEventListener("click", () => {
                      this.productLinks[0].click();
                    });
                  });
            }
            cacheDefaultValues() {
              (this.productLinkValue = this.productLinks[0].hasAttribute(Vl)
                ? this.productLinks[0].getAttribute(Vl)
                : ""),
                (this.productPriceValue = this.productPrice.innerHTML),
                this.productCutline &&
                  (this.productCutlineValue = this.productCutline.innerHTML);
            }
            resetProductValues() {
              this.product.classList.remove(Nl),
                this.productLinkValue &&
                  this.productLinks.forEach((t) => {
                    t.href = this.productLinkValue;
                  }),
                this.productPrice &&
                  (this.productPrice.innerHTML = this.productPriceValue),
                this.productCutline &&
                  this.productCutline &&
                  ((this.productCutline.innerHTML = this.productCutlineValue),
                  (this.productCutline.title = this.productCutlineValue)),
                this.hideSiblingImage();
            }
            showSibling(t) {
              const e = t.target,
                s = e.hasAttribute(zl) ? e.getAttribute(zl) : "",
                i = e.hasAttribute(Wl) ? e.getAttribute(Wl) : "",
                o = e.hasAttribute(Rl) ? e.getAttribute(Rl) : "",
                n = e.hasAttribute(Ul) ? e.getAttribute(Ul) : "";
              s &&
                this.productLinks.forEach((t) => {
                  t.href = s;
                }),
                i && (this.productPrice.innerHTML = i),
                o
                  ? ((this.productCutline.innerHTML = o),
                    (this.productCutline.title = o))
                  : ((this.productCutline.innerHTML = ""),
                    (this.productCutline.title = "")),
                n && this.showSiblingImage(n);
            }
            showSiblingImage(t) {
              if (!this.productImageSibling) return;
              const e = window.devicePixelRatio || 1,
                s = this.productImage.offsetWidth * e,
                i = 180 * Math.ceil(s / 180),
                o = r.getSizedImageUrl(t, `${i}x`),
                n = this.productImageSibling.querySelector(`[src="${o}"]`),
                a = () => {
                  this.productImageSibling.classList.add(Dl),
                    this.productImageSibling
                      .querySelector(`[src="${o}"]`)
                      .classList.add($l);
                },
                l = () => {
                  this.productImageSibling
                    .querySelectorAll("img")
                    .forEach((t) => {
                      t.classList.remove($l);
                    }),
                    requestAnimationFrame(a);
                };
              if (n) l();
              else {
                const t = document.createElement("img");
                (t.src = o),
                  this.productCutline &&
                    (t.alt = this.productCutline.innerText),
                  t.addEventListener("load", () => {
                    this.productImageSibling.append(t), l();
                  });
              }
            }
            hideSiblingImage() {
              this.productImageSibling &&
                (this.productImageSibling.classList.remove(Dl),
                this.productImageSibling
                  .querySelectorAll("img")
                  .forEach((t) => {
                    t.classList.remove($l);
                  }));
            }
            constructor(t, e) {
              (this.swatches = t),
                (this.product = e),
                (this.productLinks = this.product.querySelectorAll(
                  Fl.productLink
                )),
                (this.productCutline = this.product.querySelector(
                  Fl.productCutline
                )),
                (this.productPrice = this.product.querySelector(
                  Fl.productPrice
                )),
                (this.productImage = this.product.querySelector(
                  Fl.productImage
                )),
                (this.productImageSibling = this.product.querySelector(
                  Fl.productImageSibling
                )),
                this.init();
            }
          })(this.siblingLinks, this.product),
        this.querySelectorAll(Fl.tooltip).forEach((t) => {
          new xo(t);
        });
    }
    showSiblings() {
      this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer),
        this.productLink && this.productLink.classList.add(_l),
        this.siblingFieldset.classList.add(Dl);
    }
    hideSiblings() {
      this.hideSwatchesTimer = setTimeout(() => {
        this.productLink && this.productLink.classList.remove(_l),
          this.siblingFieldset.classList.remove(Dl);
      }, 100);
    }
    initScrollbar() {
      this.siblingScrollbar && new pl(this.siblingScrollbar);
    }
    constructor() {
      super();
    }
  };
  const Xl = "body",
    Jl = "[data-related-section]",
    Yl = "[data-tabs-holder]",
    Ql = "data-tab",
    Gl = "data-tab-index",
    Kl = "[data-aos]",
    Zl = "data-block-id",
    tc = "[data-tab]",
    ec = ".tab-link",
    sc = ".tab-link__recent",
    ic = ".tab-content",
    oc = "[data-scrollbar]",
    nc = "current",
    rc = "hidden",
    ac = "aos-animate",
    lc = "aos-no-transition",
    cc = "is-focused",
    hc = {};
  const dc = {
    onLoad() {
      hc[this.id] = [];
      this.container.querySelectorAll(Yl).forEach((t) => {
        hc[this.id].push(
          new (class {
            init() {
              const t = this.container.querySelectorAll(tc);
              this.container.addEventListener("theme:tab:check", () =>
                this.checkRecentTab()
              ),
                this.container.addEventListener("theme:tab:hide", () =>
                  this.hideRelatedTab()
                ),
                t.length &&
                  t.forEach((t) => {
                    const e = parseInt(t.getAttribute(Ql)),
                      s = this.container.querySelector(`${ic}-${e}`);
                    t.addEventListener("click", () => {
                      this.tabChange(t, s);
                    }),
                      t.addEventListener("keyup", (e) => {
                        ("Space" !== e.code && "Enter" !== e.code) ||
                          !this.body.classList.contains(cc) ||
                          this.tabChange(t, s);
                      });
                  });
            }
            tabChange(t, e) {
              if (t.classList.contains(nc)) return;
              const s = this.container.querySelector(`${tc}.${nc}`),
                i = this.container.querySelector(`${ic}.${nc}`);
              null == s || s.classList.remove(nc),
                null == i || i.classList.remove(nc),
                t.classList.add(nc),
                e.classList.add(nc),
                t.classList.contains(rc) && e.classList.add(rc),
                this.accessibility.a11y.removeTrapFocus(),
                this.container.dispatchEvent(
                  new CustomEvent("theme:tab:change", { bubbles: !0 })
                ),
                t.dispatchEvent(
                  new CustomEvent("theme:form:sticky", {
                    bubbles: !0,
                    detail: { element: "tab" },
                  })
                ),
                this.animateItems(e);
            }
            animateItems(t, e = !0) {
              const s = t.querySelectorAll(Kl);
              s.length &&
                s.forEach((t) => {
                  t.classList.remove(ac),
                    e &&
                      (t.classList.add(lc),
                      requestAnimationFrame(() => {
                        t.classList.remove(lc), t.classList.add(ac);
                      }));
                });
            }
            initNativeScrollbar() {
              this.scrollbarHolder.length &&
                this.scrollbarHolder.forEach((t) => {
                  new pl(t);
                });
            }
            checkRecentTab() {
              const t = this.container.querySelector(sc);
              if (t) {
                t.classList.remove(rc);
                const e = parseInt(t.getAttribute(Ql)),
                  s = this.container.querySelector(`${ic}[${Gl}="${e}"]`);
                s && (s.classList.remove(rc), this.animateItems(s, !1)),
                  this.initNativeScrollbar();
              }
            }
            hideRelatedTab() {
              const t = this.container.querySelector(Jl);
              if (!t) return;
              const e = t.closest(`${ic}.${nc}`);
              if (!e) return;
              const s = parseInt(e.getAttribute(Gl)),
                i = this.container.querySelectorAll(tc);
              if (i.length > s) {
                const t = i[s].nextSibling;
                t &&
                  (i[s].classList.add(rc),
                  t.dispatchEvent(new Event("click")),
                  this.initNativeScrollbar());
              }
            }
            onBlockSelect(t) {
              const e = this.container.querySelector(
                `${ec}[${Zl}="${t.detail.blockId}"]`
              );
              e &&
                (e.dispatchEvent(new Event("click")),
                e.parentNode.scrollTo({
                  top: 0,
                  left: e.offsetLeft - e.clientWidth,
                  behavior: "smooth",
                }));
            }
            constructor(t) {
              (this.container = t),
                (this.body = document.querySelector(Xl)),
                (this.accessibility = window.accessibility),
                this.container &&
                  ((this.scrollbarHolder = this.container.querySelectorAll(oc)),
                  this.init(),
                  this.initNativeScrollbar());
            }
          })(t)
        );
      });
    },
    onBlockSelect(t) {
      hc[this.id].forEach((e) => {
        "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
      });
    },
  };
  function uc() {
    const t = Boolean(
        document.querySelectorAll("dialog[open][data-scroll-lock-required]")
          .length
      ),
      e = Boolean(document.querySelectorAll(".drawer.is-open").length);
    return t || e;
  }
  const pc = {
      added: "is-added",
      animated: "is-animated",
      disabled: "is-disabled",
      error: "has-error",
      loading: "is-loading",
      open: "is-open",
      overlayText: "product-item--overlay-text",
      visible: "is-visible",
      siblingLinkCurrent: "sibling__link--current",
    },
    mc = 3e3,
    vc = "[data-animation]",
    gc = "[data-api-content]",
    fc = "[data-quick-add-btn]",
    yc = "[data-add-to-cart]",
    bc = "[data-cart-drawer]",
    wc = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    Ec = "[data-message-error]",
    Sc = "[data-quick-add-modal-handle]",
    Lc = "[data-product-upsell-ajax]",
    kc = "[data-quick-add-modal-close]",
    Ac = "data-grid-item",
    Tc = "[data-product-information]",
    Cc = "[data-quick-add-holder]",
    qc = "[data-quick-add-modal]",
    xc = "[data-quick-add-modal-template]",
    Mc = "closing",
    Pc = "data-product-id",
    Hc = "data-quick-add-modal-handle",
    Ic = "data-sibling-swapper",
    Bc = "data-quick-add-holder";
  let Oc = class extends HTMLElement {
    connectedCallback() {
      this.modalButton &&
        this.modalButton.addEventListener("click", this.modalButtonClickEvent),
        this.buttonATC &&
          this.buttonATC.addEventListener("click", (t) => {
            t.preventDefault(),
              (window.accessibility.lastElement = this.buttonATC),
              document.dispatchEvent(
                new CustomEvent("theme:cart:add", {
                  detail: { button: this.buttonATC },
                })
              );
          }),
        this.quickAddHolder &&
          (this.quickAddHolder.addEventListener(
            "animationend",
            this.quickAddLoadingToggle
          ),
          this.errorHandler());
    }
    modalButtonClickEvent(t) {
      t.preventDefault();
      const e = this.modalButton.hasAttribute(Ic),
        s = this.modalButton.classList.contains(pc.siblingLinkCurrent);
      s ||
        (this.modalButton.classList.add(pc.loading),
        (this.modalButton.disabled = !0),
        e &&
          !s &&
          ((this.currentModal = t.target.closest(qc)),
          this.currentModal.classList.add(pc.loading)),
        this.renderModal());
    }
    modalCreate(t) {
      const e = document.querySelector(`${qc}[${Pc}="${this.productId}"]`);
      if (e) (this.modal = e), this.modalOpen();
      else {
        const e = this.quickAddHolder.querySelector(xc);
        if (!e) return;
        const s = document.createElement("div");
        (s.innerHTML = e.innerHTML),
          document.body.appendChild(s.querySelector(qc)),
          e.remove(),
          (this.modal = document.querySelector(
            `${qc}[${Pc}="${this.productId}"]`
          )),
          (this.modal.querySelector(Lc).innerHTML = new DOMParser()
            .parseFromString(t, "text/html")
            .querySelector(gc).innerHTML),
          this.modalCreatedCallback();
      }
    }
    modalOpen() {
      this.currentModal &&
        this.currentModal.dispatchEvent(
          new CustomEvent("theme:modal:close", { bubbles: !1 })
        ),
        "function" == typeof this.modal.show && this.modal.show(),
        this.modal.setAttribute("open", !0),
        this.modal.removeAttribute("inert"),
        this.quickAddHolder.classList.add(pc.disabled),
        this.modalButton &&
          (this.modalButton.classList.remove(pc.loading),
          (this.modalButton.disabled = !1),
          (window.accessibility.lastElement = this.modalButton)),
        requestAnimationFrame(() => {
          this.modal.querySelectorAll(vc).forEach((t) => {
            t.classList.add(pc.animated);
          });
        }),
        document.dispatchEvent(
          new CustomEvent("theme:quick-add:open", { bubbles: !0 })
        ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", { bubbles: !0 })
        ),
        document.addEventListener(
          "theme:product:added",
          this.modalCloseOnProductAdded,
          { once: !0 }
        );
    }
    modalClose() {
      if (!this.isAnimating) {
        if (!this.modal.hasAttribute(Mc))
          return this.modal.setAttribute(Mc, ""), void (this.isAnimating = !0);
        "function" == typeof this.modal.close
          ? this.modal.close()
          : this.modal.removeAttribute("open"),
          this.modal.removeAttribute(Mc),
          this.modal.setAttribute("inert", ""),
          this.modal.classList.remove(pc.loading),
          this.modalButton && (this.modalButton.disabled = !1),
          this.quickAddHolder &&
            this.quickAddHolder.classList.contains(pc.disabled) &&
            this.quickAddHolder.classList.remove(pc.disabled),
          this.resetAnimatedItems(),
          uc() ||
            document.dispatchEvent(
              new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
            ),
          document.removeEventListener(
            "theme:product:added",
            this.modalCloseOnProductAdded
          ),
          this.a11y.removeTrapFocus(),
          this.a11y.autoFocusLastElement();
      }
    }
    modalEvents() {
      var t;
      null === (t = this.modal.querySelector(kc)) ||
        void 0 === t ||
        t.addEventListener("click", (t) => {
          t.preventDefault(), this.modalClose();
        }),
        this.modal.addEventListener("click", (t) => {
          "DIALOG" === t.target.nodeName &&
            "click" === t.type &&
            this.modalClose();
        }),
        this.modal.addEventListener("keydown", (t) => {
          "Escape" == t.code && (t.preventDefault(), this.modalClose());
        }),
        this.modal.addEventListener("theme:modal:close", () => {
          this.modalClose();
        }),
        this.modal.addEventListener("animationend", (t) => {
          t.target === this.modal &&
            ((this.isAnimating = !1),
            this.modal.hasAttribute(Mc)
              ? this.modalClose()
              : setTimeout(() => {
                  this.a11y.trapFocus(this.modal);
                  const t =
                    this.modal.querySelector("[autofocus]") ||
                    this.modal.querySelector(wc);
                  null == t || t.focus();
                }, 50));
        });
    }
    modalCloseOnProductAdded() {
      this.resetQuickAddButtons(),
        this.modal && this.modal.hasAttribute("open") && this.modalClose();
    }
    quickAddLoadingToggle(t) {
      t.target == this.quickAddHolder &&
        this.quickAddHolder.classList.remove(pc.disabled);
    }
    errorHandler() {
      this.quickAddHolder.addEventListener("theme:cart:error", (t) => {
        const e = t.detail.holder,
          s = e.closest(`[${Ac}]`);
        if (!s) return;
        const i = e.querySelector(Ec),
          o = s.classList.contains(pc.overlayText),
          n = s.querySelector(Tc),
          r = e.querySelector(yc);
        r &&
          (r.classList.remove(pc.added, pc.loading), e.classList.add(pc.error)),
          i && (i.innerText = t.detail.description),
          o && n.classList.add(pc.hidden),
          setTimeout(() => {
            this.resetQuickAddButtons(), o && n.classList.remove(pc.hidden);
          }, mc);
      });
    }
    resetQuickAddButtons() {
      this.quickAddHolder &&
        this.quickAddHolder.classList.remove(pc.visible, pc.error),
        this.buttonQuickAdd &&
          (this.buttonQuickAdd.classList.remove(pc.added),
          (this.buttonQuickAdd.disabled = !1));
    }
    renderModal() {
      this.modal
        ? this.modalOpen()
        : window
            .fetch(
              `${window.theme.routes.root}products/${this.handle}?section_id=api-product-upsell`
            )
            .then(this.upsellErrorsHandler)
            .then((t) => t.text())
            .then((t) => {
              this.modalCreate(t);
            });
    }
    modalCreatedCallback() {
      this.modalEvents(), this.modalOpen(), H(this.modal);
    }
    upsellErrorsHandler(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new Me({ status: t.statusText, headers: t.headers, json: e });
          });
    }
    resetAnimatedItems() {
      var t;
      null === (t = this.modal) ||
        void 0 === t ||
        t.querySelectorAll(vc).forEach((t) => {
          t.classList.remove(pc.animated);
        });
    }
    constructor() {
      var t;
      (super(),
      (this.container = this),
      (this.quickAddHolder = this.container.querySelector(Cc)),
      this.quickAddHolder) &&
        ((this.modal = null),
        (this.currentModal = null),
        (this.productId = this.quickAddHolder.getAttribute(Bc)),
        (this.modalButton = this.quickAddHolder.querySelector(Sc)),
        (this.handle =
          null === (t = this.modalButton) || void 0 === t
            ? void 0
            : t.getAttribute(Hc)),
        (this.cartDrawer = document.querySelector(bc)),
        (this.buttonQuickAdd = this.quickAddHolder.querySelector(fc)),
        (this.buttonATC = this.quickAddHolder.querySelector(yc)),
        (this.button = this.modalButton || this.buttonATC),
        (this.modalClose = this.modalClose.bind(this)),
        (this.modalCloseOnProductAdded =
          this.modalCloseOnProductAdded.bind(this)),
        (this.a11y = N),
        (this.isAnimating = !1),
        (this.modalButtonClickEvent = this.modalButtonClickEvent.bind(this)),
        (this.quickAddLoadingToggle = this.quickAddLoadingToggle.bind(this)));
    }
  };
  fo("product-grid", [dc]),
    customElements.get("quick-add-product") ||
      customElements.define("quick-add-product", Oc),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", Bl),
    customElements.get("grid-swatch") ||
      customElements.define("grid-swatch", Ol),
    customElements.get("product-siblings") ||
      customElements.define("product-siblings", jl);
  const Fc = "complementary-products",
    Dc = "quick-add-product",
    $c = "is-loaded",
    _c = "data-url";
  let Nc = class extends HTMLElement {
    connectedCallback() {
      new IntersectionObserver(
        ((t, e) => {
          t[0].isIntersecting &&
            (e.unobserve(this),
            this.hasAttribute(_c) &&
              "" !== this.getAttribute(_c) &&
              fetch(this.getAttribute(_c))
                .then((t) => t.text())
                .then((t) => {
                  const e = document.createElement("div");
                  e.innerHTML = t;
                  const s = e.querySelector(Fc);
                  s &&
                    s.innerHTML.trim().length &&
                    (this.innerHTML = s.innerHTML),
                    e.querySelector(`${Fc} ${Dc}`) && this.classList.add($c);
                })
                .catch((t) => {
                  console.error(t);
                }));
        }).bind(this),
        { rootMargin: "0px 0px 400px 0px" }
      ).observe(this);
    }
    constructor() {
      super();
    }
  };
  const Rc = 'input:not([type="checkbox"]):not([type="hidden"]), textarea',
    Uc = 'input[type="email"]',
    zc = 'input[type="checkbox"]',
    Wc = "[data-form-wrapper]";
  let Vc = class extends HTMLElement {
    connectedCallback() {
      this.fieldCheckbox &&
        (this.fieldCheckbox.addEventListener("change", this.onChangeEvent),
        this.form &&
          this.form.addEventListener("theme:product:add", () => {
            (this.fieldCheckbox.checked = !1),
              this.fieldCheckbox.dispatchEvent(new Event("change"));
          }));
    }
    clearInputValues() {
      this.fields.length &&
        this.fields.forEach((t) => {
          t.value = "";
        });
    }
    onChange(t) {
      (this.fieldEmail.required = Boolean(t.target.checked)),
        t.target.checked || this.clearInputValues();
    }
    disconnectedCallback() {
      this.fieldCheckbox.removeEventListener("change", this.onChangeEvent);
    }
    constructor() {
      super(),
        (this.fieldCheckbox = this.querySelector(zc)),
        (this.fieldEmail = this.querySelector(Uc)),
        (this.fields = this.querySelectorAll(Rc)),
        (this.form = this.closest(Wc)),
        (this.onChangeEvent = (t) => this.onChange(t));
    }
  };
  const jc = ".product__page",
    Xc = "[data-form-wrapper]",
    Jc = "[data-header-sticky]",
    Yc = "[data-product-media-list]",
    Qc = "is-sticky",
    Gc = "data-sticky-enabled";
  window.theme.variables = { productPageSticky: !1 };
  const Kc = {};
  const Zc = {
      onLoad() {
        Kc[this.id] = new (class {
          init() {
            this.stickyEnabled &&
              (this.stickyScrollCheck(),
              document.addEventListener("theme:resize", this.resizeEvent)),
              this.initSticky();
          }
          initSticky() {
            theme.variables.productPageSticky &&
              ((this.requestAnimationSticky = requestAnimationFrame(() =>
                this.calculateStickyPosition()
              )),
              this.formWrapper.addEventListener(
                "theme:form:sticky",
                this.stickyFormEvent
              ),
              document.addEventListener("theme:scroll", this.scrollEvent));
          }
          stickyFormEvents(t) {
            this.removeAnimationFrameSticky(),
              (this.requestAnimationSticky = requestAnimationFrame(() =>
                this.calculateStickyPosition(t)
              ));
          }
          scrollEvents(t) {
            (this.scrollTop = t.detail.position),
              (this.scrollDirectionDown = t.detail.down),
              this.requestAnimationSticky ||
                (this.requestAnimationSticky = requestAnimationFrame(() =>
                  this.calculateStickyPosition()
                ));
          }
          resizeEvents(t) {
            this.stickyScrollCheck(),
              document.removeEventListener("theme:scroll", this.scrollEvent),
              this.formWrapper.removeEventListener(
                "theme:form:sticky",
                this.stickyFormEvent
              ),
              this.initSticky();
          }
          stickyScrollCheck() {
            const t = this.container.querySelector(`${jc} ${Xc}`);
            if (t)
              if (y()) {
                const e = this.container.querySelector(Xc),
                  s = this.container.querySelector(Yc);
                if (!e || !s) return;
                e.offsetHeight < s.offsetHeight
                  ? ((theme.variables.productPageSticky = !0),
                    t.classList.add(Qc))
                  : ((theme.variables.productPageSticky = !1),
                    t.classList.remove(Qc));
              } else
                (theme.variables.productPageSticky = !1),
                  t.classList.remove(Qc);
          }
          calculateStickyPosition(t = null) {
            if (document.documentElement.hasAttribute("data-scroll-locked"))
              return void this.removeAnimationFrameSticky();
            const e = Boolean(t && t.detail),
              s = Boolean(
                e && t.detail.element && "accordion" === t.detail.element
              ),
              i = this.formWrapper.offsetHeight,
              o = window.innerHeight - i - this.defaultTopBottomSpacings,
              n = Math.abs(this.scrollTop - this.scrollLastPosition);
            if (
              (this.scrollDirectionDown
                ? (this.stickyScrollTop -= n)
                : (this.stickyScrollTop += n),
              this.stickyFormLoad)
            ) {
              if (document.querySelector(Jc)) {
                let { headerHeight: t } = c();
                this.stickyDefaultTop = t;
              } else this.stickyDefaultTop = this.defaultTopBottomSpacings;
              this.stickyScrollTop = this.stickyDefaultTop;
            }
            this.stickyScrollTop = Math.min(
              Math.max(this.stickyScrollTop, o),
              this.stickyDefaultTop
            );
            const r = this.stickyScrollTop - this.currentPoint;
            (this.currentPoint = this.stickyFormLoad
              ? this.stickyScrollTop
              : this.currentPoint + 0.5 * r),
              this.formWrapper.style.setProperty(
                "--sticky-top",
                `${this.currentPoint}px`
              ),
              (this.scrollLastPosition = this.scrollTop),
              (this.stickyFormLoad = !1),
              (s && this.onChangeCounter <= 10) ||
              (s && this.stickyFormLastHeight !== i) ||
              (this.stickyScrollTop !== this.currentPoint &&
                this.requestAnimationSticky)
                ? (s && (this.onChangeCounter += 1),
                  s &&
                    this.stickyFormLastHeight !== i &&
                    (this.onChangeCounter = 11),
                  (this.requestAnimationSticky = requestAnimationFrame(() =>
                    this.calculateStickyPosition(t)
                  )))
                : this.requestAnimationSticky &&
                  this.removeAnimationFrameSticky(),
              (this.stickyFormLastHeight = i);
          }
          removeAnimationFrameSticky() {
            this.requestAnimationSticky &&
              (cancelAnimationFrame(this.requestAnimationSticky),
              (this.requestAnimationSticky = null),
              (this.onChangeCounter = 0));
          }
          onUnload() {
            this.stickyEnabled &&
              document.removeEventListener("theme:resize", this.resizeEvent),
              theme.variables.productPageSticky &&
                document.removeEventListener("theme:scroll", this.scrollEvent);
          }
          constructor(t) {
            (this.section = t),
              (this.container = t.container),
              (this.stickyEnabled = "true" === this.container.getAttribute(Gc)),
              (this.formWrapper = this.container.querySelector(Xc)),
              (this.stickyScrollTop = 0),
              (this.scrollLastPosition = 0),
              (this.stickyDefaultTop = 0),
              (this.currentPoint = 0),
              (this.defaultTopBottomSpacings = 30),
              (this.scrollTop = window.scrollY),
              (this.scrollDirectionDown = !0),
              (this.requestAnimationSticky = null),
              (this.stickyFormLoad = !0),
              (this.stickyFormLastHeight = null),
              (this.onChangeCounter = 0),
              (this.scrollEvent = (t) => this.scrollEvents(t)),
              (this.resizeEvent = (t) => this.resizeEvents(t)),
              (this.stickyFormEvent = (t) => this.stickyFormEvents(t)),
              setTimeout(() => {
                this.init();
              }, 50);
          }
        })(this);
      },
      onUnload() {
        Kc[this.id].onUnload();
      },
    },
    th = "data-section-type",
    eh = "[data-share-button]",
    sh = "[data-share-message]",
    ih = "is-visible";
  let oh = class extends HTMLElement {
    init() {
      navigator.share
        ? this.shareButton.addEventListener("click", () => {
            navigator.share({ url: this.urlToShare, title: document.title });
          })
        : this.shareButton.addEventListener(
            "click",
            this.copyToClipboard.bind(this)
          );
    }
    updateShareLink() {
      "product" == this.container.getAttribute(th) &&
        this.container.addEventListener("theme:variant:change", (t) => {
          t.detail.variant &&
            (this.urlToShare = `${this.urlToShare.split("?")[0]}?variant=${
              t.detail.variant.id
            }`);
        });
    }
    copyToClipboard() {
      navigator.clipboard.writeText(this.urlToShare).then(() => {
        this.shareMessage.classList.add(ih);
        const t = () => {
          this.shareMessage.classList.remove(ih),
            this.shareMessage.removeEventListener("animationend", t);
        };
        this.shareMessage.addEventListener("animationend", t);
      });
    }
    constructor() {
      super(),
        (this.container = this.closest(`[${th}]`)),
        (this.shareButton = this.querySelector(eh)),
        (this.shareMessage = this.querySelector(sh)),
        (this.urlToShare = this.shareButton.dataset.shareUrl
          ? this.shareButton.dataset.shareUrl
          : document.location.href),
        this.init(),
        this.updateShareLink();
    }
  };
  const nh = "[data-button-arrow]",
    rh = "[data-deferred-media-button]",
    ah = "model-viewer, video, iframe, button, [href], input, [tabindex]",
    lh = "[data-image-id]",
    ch = "[data-product-media-list]",
    hh = "[data-section-type]",
    dh = "slider__arrows",
    uh = "is-dragging",
    ph = "is-focused",
    mh = "media--active",
    vh = "media--hidden",
    gh = "media--hiding",
    fh = "data-active-media",
    yh = "data-button-prev",
    bh = "data-button-next",
    wh = "data-image-id",
    Eh = "data-media-id",
    Sh = "data-fader-desktop",
    Lh = "data-fader-mobile";
  let kh = class extends HTMLElement {
    connectedCallback() {
      this.productMediaObserver(),
        this.toggleEvents(),
        this.listen(),
        this.setHeight();
    }
    disconnectedCallback() {
      this.unlisten();
    }
    listen() {
      document.addEventListener("theme:resize:width", this.toggleEvents),
        document.addEventListener("theme:resize:width", this.setHeight),
        this.addEventListener("theme:media:select", this.selectMediaEvent);
    }
    unlisten() {
      document.removeEventListener("theme:resize:width", this.toggleEvents),
        document.removeEventListener("theme:resize:width", this.setHeight),
        this.removeEventListener("theme:media:select", this.selectMediaEvent);
    }
    toggleEvents() {
      const t = b();
      (t && this.hasAttribute(Lh)) || (!t && this.hasAttribute(Sh))
        ? this.bindEventListeners()
        : this.unbindEventListeners();
    }
    bindEventListeners() {
      this.initialized ||
        (this.productMediaList.addEventListener(
          "mousedown",
          this.handleMouseDown
        ),
        this.productMediaList.addEventListener(
          "mouseleave",
          this.handleMouseLeave
        ),
        this.productMediaList.addEventListener("mouseup", this.handleMouseUp),
        this.productMediaList.addEventListener(
          "mousemove",
          this.handleMouseMove
        ),
        this.productMediaList.addEventListener(
          "touchstart",
          this.handleMouseDown,
          { passive: !0 }
        ),
        this.productMediaList.addEventListener("touchend", this.handleMouseUp, {
          passive: !0,
        }),
        this.productMediaList.addEventListener(
          "touchmove",
          this.handleMouseMove,
          { passive: !0 }
        ),
        this.productMediaList.addEventListener("keyup", this.handleKeyUp),
        this.initArrows(),
        this.resetScrollPosition(),
        (this.initialized = !0));
    }
    unbindEventListeners() {
      this.initialized &&
        (this.productMediaList.removeEventListener(
          "mousedown",
          this.handleMouseDown
        ),
        this.productMediaList.removeEventListener(
          "mouseleave",
          this.handleMouseLeave
        ),
        this.productMediaList.removeEventListener(
          "mouseup",
          this.handleMouseUp
        ),
        this.productMediaList.removeEventListener(
          "mousemove",
          this.handleMouseMove
        ),
        this.productMediaList.removeEventListener(
          "touchstart",
          this.handleMouseDown
        ),
        this.productMediaList.removeEventListener(
          "touchend",
          this.handleMouseUp
        ),
        this.productMediaList.removeEventListener(
          "touchmove",
          this.handleMouseMove
        ),
        this.productMediaList.removeEventListener("keyup", this.handleKeyUp),
        this.removeArrows(),
        (this.initialized = !1));
    }
    handleMouseDown(t) {
      (this.isDown = !0),
        (this.startX =
          (t.pageX || t.changedTouches[0].screenX) - this.offsetLeft);
    }
    handleMouseLeave() {
      this.isDown && (this.isDown = !1);
    }
    handleMouseUp(t) {
      const e =
          (t.pageX || t.changedTouches[0].screenX) -
          this.offsetLeft -
          this.startX,
        s = e > 0 ? 1 : -1;
      Math.abs(e) > 10 &&
        (s < 0 ? this.showNextImage() : this.showPreviousImage()),
        (this.isDown = !1),
        requestAnimationFrame(() => {
          this.classList.remove(uh);
        });
    }
    handleMouseMove() {
      this.isDown && this.classList.add(uh);
    }
    handleKeyUp(t) {
      "ArrowLeft" === t.code && this.showPreviousImage(),
        "ArrowRight" === t.code && this.showNextImage();
    }
    handleArrowsClickEvent() {
      var t;
      null === (t = this.querySelectorAll(nh)) ||
        void 0 === t ||
        t.forEach((t) => {
          t.addEventListener("click", (t) => {
            t.preventDefault(),
              t.target.hasAttribute(yh) && this.showPreviousImage(),
              t.target.hasAttribute(bh) && this.showNextImage();
          });
        });
    }
    resetScrollPosition() {
      0 !== this.productMediaList.scrollLeft &&
        (this.productMediaList.scrollLeft = 0);
    }
    initArrows() {
      if (!this.buttons.length) {
        const t = document.createElement("div");
        t.classList.add(dh),
          (t.innerHTML = theme.sliderArrows.prev + theme.sliderArrows.next),
          this.productMediaList.append(t),
          (this.buttons = this.querySelectorAll(nh)),
          (this.buttonPrev = this.querySelector(`[${yh}]`)),
          (this.buttonNext = this.querySelector(`[${bh}]`));
      }
      this.handleArrowsClickEvent(), this.preloadImageOnArrowHover();
    }
    removeArrows() {
      var t;
      null === (t = this.querySelector(`.${dh}`)) || void 0 === t || t.remove();
    }
    preloadImageOnArrowHover() {
      var t, e;
      null === (t = this.buttonPrev) ||
        void 0 === t ||
        t.addEventListener("mouseover", () => {
          const t = this.getPreviousMediaId();
          this.preloadImage(t);
        }),
        null === (e = this.buttonNext) ||
          void 0 === e ||
          e.addEventListener("mouseover", () => {
            const t = this.getNextMediaId();
            this.preloadImage(t);
          });
    }
    preloadImage(t) {
      var e;
      null === (e = this.querySelector(`[${Eh}="${t}"] img`)) ||
        void 0 === e ||
        e.setAttribute("loading", "eager");
    }
    showMediaOnVariantSelect(t) {
      const e = t.detail.id;
      this.setActiveMedia(e);
    }
    getCurrentMedia() {
      return this.querySelector(`${lh}.${mh}`);
    }
    getNextMediaId() {
      const t = this.getCurrentMedia(),
        e = (null == t ? void 0 : t.nextElementSibling.hasAttribute(wh))
          ? null == t
            ? void 0
            : t.nextElementSibling
          : this.querySelector(lh);
      return null == e ? void 0 : e.getAttribute(Eh);
    }
    getPreviousMediaId() {
      const t = this.getCurrentMedia(),
        e = this.productMediaItems.length - 1,
        s =
          (null == t ? void 0 : t.previousElementSibling) ||
          this.productMediaItems[e];
      return null == s ? void 0 : s.getAttribute(Eh);
    }
    showNextImage() {
      const t = this.getNextMediaId();
      this.selectMedia(t);
    }
    showPreviousImage() {
      const t = this.getPreviousMediaId();
      this.selectMedia(t);
    }
    selectMedia(t) {
      this.dispatchEvent(
        new CustomEvent("theme:media:select", { detail: { id: t } })
      );
    }
    setActiveMedia(t) {
      if (!t) return;
      this.setAttribute(fh, t);
      const e = this.querySelector(`${lh}.${mh}`),
        s = this.querySelector(`[${Eh}="${t}"]`),
        i = null == s ? void 0 : s.querySelector(ah),
        o = s.querySelector("deferred-media");
      var n;
      (null == e || e.classList.add(gh),
      null == e || e.classList.remove(mh),
      null == s || s.classList.remove(gh, vh),
      null == s || s.classList.add(mh),
      o && !0 !== o.getAttribute("loaded")) &&
        (null === (n = s.querySelector(rh)) ||
          void 0 === n ||
          n.dispatchEvent(new Event("click", { bubbles: !1 })));
      requestAnimationFrame(() => {
        this.setHeight(),
          document.body.classList.contains(ph) && (null == i || i.focus());
      });
    }
    setHeight() {
      var t, e;
      const s =
        (null === (t = this.querySelector(`${lh}.${mh}`)) || void 0 === t
          ? void 0
          : t.offsetHeight) ||
        (null === (e = this.productMediaItems[0]) || void 0 === e
          ? void 0
          : e.offsetHeight);
      this.style.setProperty("--height", `${s}px`);
    }
    productMediaObserver() {
      this.productMediaItems.forEach((t) => {
        t.addEventListener("transitionend", (e) => {
          e.target == t &&
            t.classList.contains(gh) &&
            (t.classList.remove(gh), t.classList.add(vh));
        }),
          t.addEventListener("transitioncancel", (e) => {
            e.target == t &&
              t.classList.contains(gh) &&
              (t.classList.remove(gh), t.classList.add(vh));
          });
      });
    }
    constructor() {
      super(),
        (this.initialized = !1),
        (this.buttons = !1),
        (this.isDown = !1),
        (this.startX = 0),
        (this.scrollLeft = 0),
        (this.onButtonArrowClick = (t) => this.buttonArrowClickEvent(t)),
        (this.container = this.closest(hh)),
        (this.handleMouseDown = this.handleMouseDown.bind(this)),
        (this.handleMouseLeave = this.handleMouseLeave.bind(this)),
        (this.handleMouseUp = this.handleMouseUp.bind(this)),
        (this.handleMouseMove = this.handleMouseMove.bind(this)),
        (this.handleKeyUp = this.handleKeyUp.bind(this)),
        (this.productMediaItems = this.querySelectorAll(lh)),
        (this.productMediaList = this.querySelector(ch)),
        (this.setHeight = this.setHeight.bind(this)),
        (this.toggleEvents = this.toggleEvents.bind(this)),
        (this.selectMediaEvent = (t) => this.showMediaOnVariantSelect(t));
    }
  };
  const Ah = "data-option-position",
    Th = '[name^="options"], [data-popout-option]',
    Ch = '[name^="options"]:checked, [name^="options"][type="hidden"]',
    qh = "data-value",
    xh = "[data-popout]",
    Mh = "sold-out",
    Ph = "unavailable",
    Hh = "sale";
  const Ih = "[data-product]",
    Bh = "[data-product-form]",
    Oh = "[data-add-to-cart]",
    Fh = "[data-add-to-cart-text]",
    Dh = "[data-compare-price]",
    $h = "[data-compare-text]",
    _h = "[data-form-wrapper]",
    Nh = "[data-product-select]",
    Rh = "[data-price-wrapper]",
    Uh = "product-images",
    zh = "[data-product-media-list]",
    Wh = "[data-product-json]",
    Vh = "[data-product-price]",
    jh = "[data-product-unit-price]",
    Xh = "[data-product-base]",
    Jh = "[data-product-unit]",
    Yh = "[data-product-preorder]",
    Qh = "[data-subscription-watch-price]",
    Gh = "[data-subscription-selectors]",
    Kh = "[data-toggles-group]",
    Zh = "data-group-toggle",
    td = "[data-plan-description]",
    ed = "[data-section-type]",
    sd = "[data-quick-add-modal]",
    id = "[data-price-off]",
    od = "[data-price-off-type]",
    nd = "[data-price-off-amount]",
    rd = "[data-remaining-count]",
    ad = "[data-remaining-max]",
    ld = "[data-remaining-wrapper]",
    cd = "[data-product-remaining-json]",
    hd = "[data-option-value]",
    dd = "[data-option-position]",
    ud = "[data-product-form-installment]",
    pd = 'input[name="id"]',
    md = "hidden",
    vd = "variant--soldout",
    gd = "variant--unavailable",
    fd = "product__price--sale",
    yd = "count-is-low",
    bd = "count-is-in",
    wd = "count-is-out",
    Ed = "count-is-unavailable",
    Sd = "data-remaining-max",
    Ld = "data-enable-history-state",
    kd = "data-fader-desktop",
    Ad = "data-fader-mobile",
    Td = "data-option-position",
    Cd = "data-image-id",
    qd = "data-media-id",
    xd = "data-quick-add-btn";
  let Md = class extends HTMLElement {
    connectedCallback() {
      if (
        (this.cartAddEvents(),
        (this.container = this.closest(ed) || this.closest(sd)),
        !this.container)
      )
        return;
      if (
        ((this.sectionId = this.container.dataset.sectionId),
        (this.product = this.container.querySelector(Ih)),
        (this.productForm = this.container.querySelector(Bh)),
        (this.productImages = this.container.querySelector(Uh)),
        (this.productMediaList = this.container.querySelector(zh)),
        (this.installmentForm = this.container.querySelector(ud)),
        (this.sellout = null),
        (this.priceOffWrap = this.container.querySelector(id)),
        (this.priceOffAmount = this.container.querySelector(nd)),
        (this.priceOffType = this.container.querySelector(od)),
        (this.planDescription = this.container.querySelector(td)),
        (this.remainingWrapper = this.container.querySelector(ld)),
        this.remainingWrapper)
      ) {
        const t = this.container.querySelector(ad);
        t &&
          ((this.remainingMaxInt = parseInt(t.getAttribute(Sd), 10)),
          (this.remainingCount = this.container.querySelector(rd)),
          (this.remainingJSONWrapper = this.container.querySelector(cd)),
          (this.remainingJSON = null),
          this.remainingJSONWrapper &&
          "" !== this.remainingJSONWrapper.innerHTML
            ? (this.remainingJSON = JSON.parse(
                this.remainingJSONWrapper.innerHTML
              ))
            : console.warn("Missing product quantity JSON"));
      }
      (this.enableHistoryState = "true" === this.container.getAttribute(Ld)),
        (this.hasUnitPricing = this.container.querySelector(Jh)),
        (this.subSelectors = this.container.querySelector(Gh)),
        (this.subPrices = this.container.querySelector(Qh)),
        (this.isPreOrder = this.container.querySelector(Yh));
      let t = null;
      const e = this.container.querySelector(Wh);
      e && (t = e.innerHTML),
        t
          ? ((this.productJSON = JSON.parse(t)),
            this.linkForm(),
            (this.sellout = new (class {
              init() {
                this.update();
              }
              update() {
                this.getCurrentState(),
                  this.optionElements.forEach((t) => {
                    const e = t.closest(`[${Ah}]`);
                    if (!e) return;
                    const s = t.value || t.getAttribute(qh),
                      i = e.getAttribute(Ah),
                      o = parseInt(i, 10) - 1,
                      n = t.closest(xh);
                    let r = [...this.selections];
                    r[o] = s;
                    const a = this.productJSON.variants.find((t) => {
                      let e = !0;
                      for (let s = 0; s < r.length; s++)
                        t.options[s] !== r[s] && (e = !1);
                      return e;
                    });
                    t.classList.remove(Mh, Ph),
                      t.parentNode.classList.remove(Hh),
                      n && n.classList.remove(Mh, Ph, Hh),
                      void 0 === a
                        ? (t.classList.add(Ph), n && n.classList.add(Ph))
                        : a &&
                          !1 === a.available &&
                          (t.classList.add(Mh), n && n.classList.add(Mh)),
                      a &&
                        a.compare_at_price > a.price &&
                        theme.settings.variantOnSale &&
                        t.parentNode.classList.add(Hh);
                  });
              }
              getCurrentState() {
                this.selections = [];
                const t = this.container.querySelectorAll(Ch);
                t.length &&
                  t.forEach((t) => {
                    const e = t.value;
                    e && "" !== e && this.selections.push(e);
                  });
              }
              constructor(t, e) {
                (this.container = t),
                  (this.productJSON = e),
                  (this.optionElements = this.container.querySelectorAll(Th)),
                  this.productJSON && this.optionElements.length && this.init();
              }
            })(this.container, this.productJSON)))
          : console.error("Missing product JSON");
    }
    cartAddEvents() {
      (this.buttonATC = this.querySelector(Oh)),
        this.buttonATC &&
          this.buttonATC.addEventListener("click", (t) => {
            t.preventDefault(),
              document.dispatchEvent(
                new CustomEvent("theme:cart:add", {
                  detail: { button: this.buttonATC },
                  bubbles: !1,
                })
              );
          });
    }
    destroy() {
      this.productForm.destroy();
    }
    linkForm() {
      (this.productForm = new (class {
        destroy() {
          this._listeners.removeAll();
        }
        options() {
          return this._serializeInputValues(this.optionInputs, function (t) {
            return (t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]), t;
          });
        }
        variant() {
          const t = this.options();
          return t.length ? Za(this.product, t) : this.product.variants[0];
        }
        plan(t) {
          let e = { allocation: null, group: null, detail: null };
          const s = this.element.querySelector(`${sl}:checked`);
          if (!s) return null;
          const i = s.value,
            o = i && "" !== i ? i : null;
          return (
            o &&
              t &&
              (e.allocation = t.selling_plan_allocations.find(function (t) {
                return t.selling_plan_id.toString() === o.toString();
              })),
            e.allocation &&
              (e.group = this.product.selling_plan_groups.find(function (t) {
                return (
                  t.id.toString() ===
                  e.allocation.selling_plan_group_id.toString()
                );
              })),
            e.group &&
              (e.detail = e.group.selling_plans.find(function (t) {
                return t.id.toString() === o.toString();
              })),
            e && e.allocation && e.detail && e.allocation ? e : null
          );
        }
        properties() {
          return this._serializeInputValues(this.propertyInputs, function (t) {
            return (
              (t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2]), t
            );
          });
        }
        quantity() {
          return this.quantityInputs[0]
            ? Number.parseInt(this.quantityInputs[0].value, 10)
            : 1;
        }
        getFormState() {
          const t = this.variant();
          return {
            options: this.options(),
            variant: t,
            properties: this.properties(),
            quantity: this.quantity(),
            plan: this.plan(t),
          };
        }
        _setIdInputValue(t) {
          t && t.id
            ? (this.variantElement.value = t.id.toString())
            : (this.variantElement.value = ""),
            this.variantElement.dispatchEvent(new Event("change"));
        }
        _onSubmit(t, e) {
          (e.dataset = this.getFormState()),
            t.onFormSubmit && t.onFormSubmit(e);
        }
        _onOptionChange(t) {
          this._setIdInputValue(t.dataset.variant);
        }
        _onFormEvent(t) {
          return void 0 === t
            ? Function.prototype.bind()
            : function (e) {
                (e.dataset = this.getFormState()),
                  this._setIdInputValue(e.dataset.variant),
                  t(e);
              }.bind(this);
        }
        _initInputs(t, e) {
          return Array.prototype.slice
            .call(this.element.querySelectorAll(t))
            .map(
              function (t) {
                return (
                  this._listeners.add(t, "change", this._onFormEvent(e)), t
                );
              }.bind(this)
            );
        }
        _serializeInputValues(t, e) {
          return t.reduce(function (t, s) {
            return (
              (s.checked || ("radio" !== s.type && "checkbox" !== s.type)) &&
                t.push(e({ name: s.name, value: s.value })),
              t
            );
          }, []);
        }
        _validateProductObject(t) {
          if ("object" != typeof t)
            throw new TypeError(t + " is not an object.");
          if (void 0 === t.variants[0].options)
            throw new TypeError(
              "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route"
            );
          return t;
        }
        constructor(t, e, s) {
          (this.element = t),
            (this.product = this._validateProductObject(e)),
            (this.variantElement = this.element.querySelector(el)),
            (s = s || {}),
            (this._listeners = new Ka()),
            this._listeners.add(
              this.element,
              "submit",
              this._onSubmit.bind(this, s)
            ),
            (this.optionInputs = this._initInputs(il, s.onOptionChange)),
            (this.planInputs = this._initInputs(sl, s.onPlanChange)),
            (this.quantityInputs = this._initInputs(ol, s.onQuantityChange)),
            (this.propertyInputs = this._initInputs(nl, s.onPropertyChange));
        }
      })(this.container, this.productJSON, {
        onOptionChange: this.onOptionChange.bind(this),
        onPlanChange: this.onPlanChange.bind(this),
      })),
        this.pushState(this.productForm.getFormState(), !0),
        this.subsToggleListeners();
    }
    onOptionChange(t) {
      this.pushState(t.dataset), this.updateProductImage(t);
    }
    onPlanChange(t) {
      this.subPrices && this.pushState(t.dataset);
    }
    pushState(t, e = !1) {
      var s;
      (this.productState = this.setProductState(t)),
        this.updateAddToCartState(t),
        this.updateProductPrices(t),
        this.updateSaleText(t),
        this.updateSubscriptionText(t),
        this.updateRemaining(t),
        this.updateLegend(t),
        this.fireHookEvent(t),
        null === (s = this.sellout) || void 0 === s || s.update(t),
        this.enableHistoryState && !e && this.updateHistoryState(t);
    }
    updateAddToCartState(t) {
      const e = t.variant;
      let s = theme.strings.addToCart;
      const i = this.container.querySelectorAll(Rh),
        o = this.container.querySelectorAll(Oh),
        n = this.container.querySelectorAll(Fh),
        r = this.container.querySelectorAll(_h);
      if (this.installmentForm && e) {
        const t = this.installmentForm.querySelector(pd);
        (t.value = e.id), t.dispatchEvent(new Event("change", { bubbles: !0 }));
      }
      this.isPreOrder && (s = theme.strings.preOrder),
        i.length &&
          e &&
          i.forEach((t) => {
            t.classList.remove(md);
          }),
        o.length &&
          o.forEach((t) => {
            t.hasAttribute(xd) ||
              (e && e.available ? (t.disabled = !1) : (t.disabled = !0));
          }),
        n.length &&
          n.forEach((t) => {
            e
              ? e.available
                ? (t.innerHTML = s)
                : (t.innerHTML = theme.strings.soldOut)
              : (t.innerHTML = theme.strings.unavailable);
          }),
        r.length &&
          r.forEach((t) => {
            if (e) {
              e.available
                ? t.classList.remove(vd, gd)
                : (t.classList.add(vd), t.classList.remove(gd));
              const s = t.querySelector(Nh);
              s && (s.value = e.id);
              const i = t.querySelector(`${pd}[form]`);
              i && ((i.value = e.id), i.dispatchEvent(new Event("change")));
            } else t.classList.add(gd), t.classList.remove(vd);
          });
    }
    updateHistoryState(t) {
      const e = t.variant,
        s = t.plan,
        i = window.location.href;
      if (e && i.includes("/product")) {
        const t = new window.URL(i),
          o = t.searchParams;
        o.set("variant", e.id),
          s && s.detail && s.detail.id && this.productState.hasPlan
            ? o.set("selling_plan", s.detail.id)
            : o.delete("selling_plan"),
          (t.search = o.toString());
        const n = t.toString();
        window.history.replaceState({ path: n }, "", n);
      }
    }
    updateRemaining(t) {
      var e;
      const s = t.variant;
      if (
        (null === (e = this.remainingWrapper) ||
          void 0 === e ||
          e.classList.remove(bd, wd, Ed, yd),
        s && this.remainingWrapper && this.remainingJSON)
      ) {
        const t = this.remainingJSON[s.id];
        ("out" === t || t < 1) && this.remainingWrapper.classList.add(wd),
          ("in" === t || t >= this.remainingMaxInt) &&
            this.remainingWrapper.classList.add(bd),
          ("low" === t || (t > 0 && t < this.remainingMaxInt)) &&
            (this.remainingWrapper.classList.add(yd),
            this.remainingCount && (this.remainingCount.innerHTML = t));
      } else
        !s && this.remainingWrapper && this.remainingWrapper.classList.add(Ed);
    }
    getBaseUnit(t) {
      return 1 === t.unit_price_measurement.reference_value
        ? t.unit_price_measurement.reference_unit
        : t.unit_price_measurement.reference_value +
            t.unit_price_measurement.reference_unit;
    }
    subsToggleListeners() {
      this.container.querySelectorAll(Kh).forEach((t) => {
        t.addEventListener(
          "change",
          function (t) {
            const e = t.target.value.toString(),
              s = this.container.querySelector(`[${Zh}="${e}"]`),
              i = this.container.querySelectorAll(`[${Zh}]`);
            if (s) {
              s.classList.remove(md);
              const t = s.querySelector('[name="selling_plan"]');
              (t.checked = !0), t.dispatchEvent(new Event("change"));
            }
            i.forEach((t) => {
              if (t !== s) {
                t.classList.add(md);
                t.querySelectorAll('[name="selling_plan"]').forEach((t) => {
                  (t.checked = !1), t.dispatchEvent(new Event("change"));
                });
              }
            });
          }.bind(this)
        );
      });
    }
    updateSaleText(t) {
      this.productState.planSale
        ? this.updateSaleTextSubscription(t)
        : this.productState.onSale
        ? this.updateSaleTextStandard(t)
        : this.priceOffWrap && this.priceOffWrap.classList.add(md);
    }
    updateSaleTextStandard(t) {
      if (
        (this.priceOffType &&
          (this.priceOffType.innerHTML = window.theme.strings.sale || "sale"),
        this.priceOffAmount && this.priceOffWrap)
      ) {
        const e = t.variant,
          s = (e.compare_at_price - e.price) / e.compare_at_price,
          i = Math.floor(100 * s);
        (this.priceOffAmount.innerHTML = `${i}%`),
          this.priceOffWrap.classList.remove(md);
      }
    }
    updateSubscriptionText(t) {
      t.plan && this.planDescription
        ? ((this.planDescription.innerHTML = t.plan.detail.description),
          this.planDescription.classList.remove(md))
        : this.planDescription && this.planDescription.classList.add(md);
    }
    updateSaleTextSubscription(t) {
      if (
        (this.priceOffType &&
          (this.priceOffType.innerHTML =
            window.theme.strings.subscription || "subscripton"),
        this.priceOffAmount && this.priceOffWrap)
      ) {
        const e = t.plan.detail.price_adjustments[0],
          i = e.value;
        e && "percentage" === e.value_type
          ? (this.priceOffAmount.innerHTML = `${i}%`)
          : (this.priceOffAmount.innerHTML = s.formatMoney(
              i,
              theme.moneyFormat
            )),
          this.priceOffWrap.classList.remove(md);
      }
    }
    updateProductPrices(t) {
      const e = t.variant,
        i = t.plan;
      this.container.querySelectorAll(Rh).forEach((t) => {
        const o = t.querySelector(Dh),
          n = t.querySelector(Vh),
          r = t.querySelector($h);
        let a = "",
          l = "";
        this.productState.available &&
          ((a = e.compare_at_price), (l = e.price)),
          this.productState.hasPlan && (l = i.allocation.price),
          this.productState.planSale &&
            ((a = i.allocation.compare_at_price), (l = i.allocation.price)),
          o &&
            (this.productState.onSale || this.productState.planSale
              ? (o.classList.remove(md),
                r.classList.remove(md),
                n.classList.add(fd))
              : (o.classList.add(md),
                r.classList.add(md),
                n.classList.remove(fd)),
            (o.innerHTML = s.formatMoney(a, theme.moneyFormat))),
          (n.innerHTML =
            0 === l
              ? window.theme.strings.free
              : s.formatMoney(l, theme.moneyFormat));
      }),
        this.hasUnitPricing && this.updateProductUnits(t);
    }
    updateProductUnits(t) {
      const e = t.variant,
        i = t.plan;
      let o = null;
      if (
        (e && e.unit_price && (o = e.unit_price),
        i &&
          i.allocation &&
          i.allocation.unit_price &&
          (o = i.allocation.unit_price),
        o)
      ) {
        const t = this.getBaseUnit(e),
          i = s.formatMoney(o, theme.moneyFormat);
        (this.container.querySelector(jh).innerHTML = i),
          (this.container.querySelector(Xh).innerHTML = t),
          qe(this.container.querySelector(Jh));
      } else
        (n = this.container.querySelector(Jh)) && (n.style.display = "none");
      var n;
    }
    fireHookEvent(t) {
      const e = t.variant;
      this.container.dispatchEvent(
        new CustomEvent("theme:variant:change", {
          detail: { variant: e },
          bubbles: !0,
        })
      );
    }
    setProductState(t) {
      const e = t.variant,
        s = t.plan,
        i = {
          available: !0,
          soldOut: !1,
          onSale: !1,
          showUnitPrice: !1,
          requiresPlan: !1,
          hasPlan: !1,
          planPerDelivery: !1,
          planSale: !1,
        };
      return (
        !e || (e.requires_selling_plan && !s)
          ? (i.available = !1)
          : (e.available || (i.soldOut = !0),
            e.compare_at_price > e.price && (i.onSale = !0),
            e.unit_price && (i.showUnitPrice = !0),
            this.product &&
              this.product.requires_selling_plan &&
              (i.requiresPlan = !0),
            s &&
              this.subPrices &&
              ((i.hasPlan = !0),
              s.allocation.per_delivery_price !== s.allocation.price &&
                (i.planPerDelivery = !0),
              e.price > s.allocation.price && (i.planSale = !0))),
        i
      );
    }
    updateProductImage(t) {
      const e = t.dataset.variant;
      if (e && e.featured_media) {
        const t = this.container.querySelector(
          `[${Cd}="${e.featured_media.id}"]`
        );
        if (t) {
          const e = t.getAttribute(qd),
            s = y();
          if (
            (t.dispatchEvent(
              new CustomEvent("theme:media:select", {
                bubbles: !0,
                detail: { id: e },
              })
            ),
            s && !this.productImages.hasAttribute(kd))
          ) {
            const e = t.getBoundingClientRect().top;
            document.dispatchEvent(
              new CustomEvent("theme:tooltip:close", {
                bubbles: !1,
                detail: { hideTransition: !1 },
              })
            ),
              nn(e);
          }
          s ||
            this.productImages.hasAttribute(Ad) ||
            this.productMediaList.scrollTo({ left: t.offsetLeft });
        }
      }
    }
    updateLegend(t) {
      const e = t.variant;
      if (e) {
        const t = this.container.querySelectorAll(hd);
        t.length &&
          t.forEach((t) => {
            const s = t.closest(dd);
            if (s) {
              const i = s.getAttribute(Td),
                o = parseInt(i, 10) - 1,
                n = e.options[o];
              t.innerHTML = n;
            }
          });
      }
    }
    constructor() {
      super();
    }
  };
  const Pd = "[data-image-id]",
    Hd = "product-images",
    Id = "[data-section-type]",
    Bd = "[data-thumb-item]",
    Od = "[data-thumb-link]",
    Fd = "[data-thumbs-slider]",
    Dd = "data-active-media",
    $d = "data-media-id",
    _d = "is-active";
  class Nd extends HTMLElement {
    connectedCallback() {
      this.handleEvents(),
        this.preloadImagesOnHover(),
        this.activeMediaObserver();
    }
    disconnectedCallback() {
      this.observer && this.observer.disconnect();
    }
    activeMediaObserver() {
      (this.observer = new MutationObserver((t) => {
        for (const e of t)
          "attributes" === e.type &&
            e.attributeName == Dd &&
            this.setActiveThumb();
      })),
        this.observer.observe(this.productImagesContainer, {
          attributes: !0,
          childList: !1,
          subtree: !1,
        });
    }
    handleEvents() {
      this.thumbLinks.forEach((t) => {
        t.addEventListener("click", (e) => {
          e.preventDefault();
          const s = t.closest(Bd),
            i = t.getAttribute($d);
          s.classList.contains(_d) ||
            this.dispatchEvent(
              new CustomEvent("theme:media:select", {
                bubbles: !0,
                detail: { id: i },
              })
            );
        }),
          t.addEventListener("keyup", (e) => {
            if ("Enter" === e.code) {
              var s;
              const e = t.getAttribute($d),
                i =
                  null ===
                    (s = this.productImagesContainer.querySelector(
                      `[${$d}="${e}"]`
                    )) || void 0 === s
                    ? void 0
                    : s.querySelectorAll(
                        'model-viewer, video, iframe, button, [href], input, [tabindex]:not([tabindex="-1"])'
                      )[0];
              i &&
                (i.dispatchEvent(new Event("focus")),
                i.dispatchEvent(new Event("select")));
            }
          });
      });
    }
    preloadImagesOnHover() {
      this.thumbLinks.forEach((t) => {
        t.addEventListener("mouseover", () => {
          const e = t.getAttribute($d),
            s = this.productImagesContainer.querySelector(`[${$d}="${e}"] img`);
          null == s || s.setAttribute("loading", "eager");
        });
      });
    }
    setActiveThumb() {
      var t;
      const e = this.productImagesContainer.getAttribute(Dd),
        s = this.querySelector(`[${$d}="${e}"]`);
      null === (t = this.querySelector(`${Bd}.${_d}`)) ||
        void 0 === t ||
        t.classList.remove(_d),
        null == s || s.parentNode.classList.add(_d),
        requestAnimationFrame(() => {
          this.scrollToThumb();
        });
    }
    scrollToThumb() {
      const t = this.thumbSlider;
      if (t) {
        const e = t.querySelector(`.${_d}`);
        if (!e) return;
        const s = t.scrollTop,
          i = t.scrollLeft,
          o = t.offsetWidth,
          n = t.offsetHeight,
          r = s + n,
          a = i + o,
          l = e.offsetTop,
          c = e.offsetLeft,
          h = e.offsetWidth,
          d = e.offsetHeight,
          u = s > l,
          p = i > c,
          m = c + h > a,
          v = l + d > r || u,
          g = m || p,
          f = b();
        if (v || g) {
          let e = l - n + d,
            s = c - o + h;
          u && (e = l),
            m && f && (s += parseInt(window.getComputedStyle(t).paddingRight)),
            p &&
              ((s = c),
              f && (s -= parseInt(window.getComputedStyle(t).paddingLeft))),
            t.scrollTo({ top: e, left: s, behavior: "smooth" });
        }
      }
    }
    constructor() {
      super(),
        (this.container = this.closest(Id)),
        (this.productImages = this.container.querySelectorAll(Pd)),
        (this.productImagesContainer = this.container.querySelector(Hd)),
        (this.productThumbs = this.container.querySelectorAll(Bd)),
        (this.thumbSlider = this.querySelector(Fd)),
        (this.thumbLinks = this.querySelectorAll(Od));
    }
  }
  const Rd = "[data-popup-open]",
    Ud = "[data-popup-close]",
    zd = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    Wd = "closing";
  let Vd = class {
    popupOpen() {
      this.popup &&
        (this.showModal && "function" == typeof this.popup.showModal
          ? this.popup.showModal()
          : this.showModal ||
            "function" != typeof this.popup.show ||
            this.popup.show(),
        this.popup.setAttribute("open", !0),
        this.popup.removeAttribute("inert"),
        this.popup.dispatchEvent(
          new CustomEvent("theme:popup:open", { bubbles: !1 })
        ),
        this.enableScrollLock &&
          document.dispatchEvent(
            new CustomEvent("theme:scroll:lock", { bubbles: !0 })
          ));
    }
    popupClose() {
      if (
        !this.isAnimating &&
        this.popup &&
        !this.popup.hasAttribute("inert")
      ) {
        if (!this.popup.hasAttribute(Wd))
          return this.popup.setAttribute(Wd, ""), void (this.isAnimating = !0);
        "function" == typeof this.popup.close
          ? this.popup.close()
          : this.popup.removeAttribute("open"),
          this.popup.removeAttribute(Wd),
          this.popup.setAttribute("inert", ""),
          !uc() &&
            this.enableScrollLock &&
            document.dispatchEvent(
              new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
            ),
          this.popup.dispatchEvent(
            new CustomEvent("theme:popup:onclose", { bubbles: !1 })
          ),
          this.enableScrollLock &&
            (this.a11y.removeTrapFocus(), this.a11y.autoFocusLastElement());
      }
    }
    popupEvents() {
      var t;
      if (!this.popup) return;
      null === (t = this.buttonPopupOpen) ||
        void 0 === t ||
        t.addEventListener("click", (t) => {
          t.preventDefault(),
            this.popupOpen(),
            (window.accessibility.lastElement = this.buttonPopupOpen);
        });
      const e = this.popup.querySelectorAll(Ud);
      e.length &&
        e.forEach((t) => {
          t.addEventListener("click", (t) => {
            t.preventDefault(), this.popupClose();
          });
        }),
        this.showModal &&
          this.popup.addEventListener("click", (t) => {
            "DIALOG" === t.target.nodeName &&
              "click" === t.type &&
              this.popupClose();
          }),
        this.popup.addEventListener("keydown", (t) => {
          "Escape" === t.code && (t.preventDefault(), this.popupClose());
        }),
        this.popup.addEventListener("theme:popup:close", () => {
          this.popupClose();
        }),
        this.popup.addEventListener("animationend", (t) => {
          if (t.target === this.popup)
            if (((this.isAnimating = !1), this.popup.hasAttribute(Wd)))
              this.popupClose();
            else {
              this.enableScrollLock && this.a11y.trapFocus(this.popup);
              const t =
                this.popup.querySelector("[autofocus]") ||
                this.popup.querySelector(zd);
              null == t || t.focus();
            }
        });
    }
    constructor(t, e, s = !0, i = !0) {
      var o;
      (this.popup = t),
        (this.holder = e),
        (this.a11y = N),
        (this.isAnimating = !1),
        (this.showModal = s),
        (this.enableScrollLock = i),
        (this.buttonPopupOpen =
          null === (o = this.holder) || void 0 === o
            ? void 0
            : o.querySelector(Rd)),
        this.popupEvents();
    }
  };
  const jd = "dialog";
  let Xd = class extends HTMLElement {
      connectedCallback() {
        new Vd(this.querySelector(jd), this, !0, !0);
      }
      constructor() {
        super();
      }
    },
    Jd = class extends Yt {
      loadContent() {
        super.loadContent(),
          Shopify.loadFeatures([
            {
              name: "model-viewer-ui",
              version: "1.0",
              onLoad: this.setupModelViewerUI.bind(this),
            },
          ]);
      }
      setupModelViewerUI(t) {
        t ||
          (this.modelViewerUI = new Shopify.ModelViewerUI(
            this.querySelector("model-viewer")
          ));
      }
      constructor() {
        super();
      }
    };
  (window.ProductModel = {
    loadShopifyXR() {
      Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: this.setupShopifyXR.bind(this),
        },
      ]);
    },
    setupShopifyXR(t) {
      t ||
        (window.ShopifyXR
          ? (document.querySelectorAll('[id^="ModelJSON-"]').forEach((t) => {
              window.ShopifyXR.addModels(JSON.parse(t.textContent)), t.remove();
            }),
            window.ShopifyXR.setupXRElements())
          : document.addEventListener("shopify_xr_initialized", () =>
              this.setupShopifyXR()
            ));
    },
  }),
    window.addEventListener("DOMContentLoaded", () => {
      window.ProductModel && window.ProductModel.loadShopifyXR();
    });
  const Yd = "data-store-availability-container",
    Qd = ".shopify-section",
    Gd = "[data-pickup-drawer]",
    Kd = "[data-section-type]",
    Zd = "hidden";
  let tu = class extends HTMLElement {
    connectedCallback() {
      (this.container = this.closest(Kd)),
        (this.drawer = null),
        this.container.addEventListener("theme:variant:change", (t) =>
          this.fetchPickupAvailability(t)
        ),
        this.fetchPickupAvailability();
    }
    fetchPickupAvailability(t) {
      if (
        (t && !t.detail.variant) ||
        (t && t.detail.variant && !t.detail.variant.available)
      )
        return void this.classList.add(Zd);
      const e =
        t && t.detail.variant ? t.detail.variant.id : this.getAttribute(Yd);
      e &&
        ((this.popupActions = null),
        fetch(
          `${window.theme.routes.root}variants/${e}/?section_id=api-pickup-availability`
        )
          .then(this.handleErrors)
          .then((t) => t.text())
          .then((t) => {
            const e = new DOMParser()
              .parseFromString(t, "text/html")
              .querySelector(Qd).innerHTML;
            (this.innerHTML = e),
              (this.drawer = this.querySelector(Gd)),
              this.drawer
                ? (this.classList.remove(Zd),
                  (this.popupActions = new Vd(this.drawer, this, !0, !0)))
                : this.classList.add(Zd);
          })
          .catch((t) => {
            console.error(t);
          }));
    }
    handleErrors(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new Me({ status: t.statusText, headers: t.headers, json: e });
          });
    }
    constructor() {
      super();
    }
  };
  const eu = {};
  function su(t = {}) {
    if ((t.type || (t.type = "json"), t.url))
      return eu[t.url]
        ? eu[t.url]
        : (function (t, e) {
            const s = new Promise((s, i) => {
              "text" === e
                ? fetch(t)
                    .then((t) => t.text())
                    .then((t) => {
                      s(t);
                    })
                    .catch((t) => {
                      i(t);
                    })
                : (function (t, e, s) {
                    let i = document.getElementsByTagName("head")[0],
                      o = !1,
                      n = document.createElement("script");
                    (n.src = t),
                      (n.onload = n.onreadystatechange =
                        function () {
                          o ||
                          (this.readyState &&
                            "loaded" != this.readyState &&
                            "complete" != this.readyState)
                            ? s()
                            : ((o = !0), e());
                        }),
                      i.appendChild(n);
                  })(
                    t,
                    function () {
                      s();
                    },
                    function () {
                      i();
                    }
                  );
            });
            return (eu[t] = s), s;
          })(t.url, t.type);
    if (t.json)
      return eu[t.json]
        ? Promise.resolve(eu[t.json])
        : window
            .fetch(t.json)
            .then((t) => t.json())
            .then((e) => ((eu[t.json] = e), e));
    if (t.name) {
      const e = "".concat(t.name, t.version);
      return eu[e]
        ? eu[e]
        : (function (t) {
            const e = "".concat(t.name, t.version),
              s = new Promise((e, s) => {
                try {
                  window.Shopify.loadFeatures([
                    {
                      name: t.name,
                      version: t.version,
                      onLoad: (t) => {
                        !(function (t, e, s) {
                          s ? e(s) : t();
                        })(e, s, t);
                      },
                    },
                  ]);
                } catch (t) {
                  s(t);
                }
              });
            return (eu[e] = s), s;
          })(t);
    }
    return Promise.reject();
  }
  (window.isYoutubeAPILoaded = !1), (window.isVimeoAPILoaded = !1);
  const iu = ".pswp",
    ou = ".pswp__custom-close",
    nu = "iframe, video",
    ru = ".pswp__thumbs",
    au = "is-current",
    lu = "pswp--custom-loader",
    cu = "pswp--custom-opening",
    hu = "pswp__loader",
    du = "is-focused",
    uu = "data-pswp-option-classes",
    pu = "aria-current",
    mu = `<div class="${hu}"><div class="loader pswp__loader-line"><div class="loader-indeterminate"></div></div></div>`;
  let vu = class {
    init() {
      this.pswpElement.classList.add(cu),
        this.initLoader(),
        su({ url: window.theme.assets.photoswipe })
          .then(() => this.loadPopup())
          .catch((t) => console.error(t));
    }
    initLoader() {
      if (
        this.pswpElement.classList.contains(lu) &&
        "" !== this.options &&
        this.options.mainClass
      ) {
        this.pswpElement.setAttribute(uu, this.options.mainClass);
        let t = document.createElement("div");
        (t.innerHTML = mu), (t = t.firstChild), this.pswpElement.appendChild(t);
      } else this.pswpElement.setAttribute(uu, "");
    }
    loadPopup() {
      const t = window.themePhotoswipe.PhotoSwipe.default,
        e = window.themePhotoswipe.PhotoSwipeUI.default;
      this.pswpElement.classList.contains(lu) &&
        this.pswpElement.classList.remove(lu),
        this.pswpElement.classList.remove(cu),
        (this.popup = new t(this.pswpElement, e, this.items, this.options)),
        this.popup.init(),
        this.thumbsActions(),
        document.body.classList.contains(du) &&
          setTimeout(() => {
            this.a11y.trapFocus(this.pswpElement, {
              elementToFocus: this.closeBtn,
            });
          }, 200),
        this.popup.listen("close", () => this.onClose()),
        this.options &&
          this.options.closeElClasses &&
          this.options.closeElClasses.length &&
          this.options.closeElClasses.forEach((t) => {
            const e = this.pswpElement.querySelector(`.pswp__${t}`);
            e && e.addEventListener("keyup", this.keyupCloseEvent);
          });
    }
    thumbsActions() {
      this.popupThumbsContainer &&
        this.popupThumbsContainer.children.length &&
        (this.popupThumbsContainer.addEventListener("wheel", (t) =>
          this.stopDisabledScroll(t)
        ),
        this.popupThumbsContainer.addEventListener("mousewheel", (t) =>
          this.stopDisabledScroll(t)
        ),
        this.popupThumbsContainer.addEventListener("DOMMouseScroll", (t) =>
          this.stopDisabledScroll(t)
        ),
        (this.popupThumbs = this.pswpElement.querySelectorAll(`${ru} > *`)),
        this.popupThumbs.forEach((t, e) => {
          t.addEventListener("click", (s) => {
            s.preventDefault();
            const i = t.parentElement.querySelector(`.${au}`);
            i.classList.remove(au),
              i.setAttribute(pu, !1),
              t.classList.add(au),
              t.setAttribute(pu, !0),
              this.popup.goTo(e);
          });
        }),
        this.popup.listen("imageLoadComplete", () => this.setCurrentThumb()),
        this.popup.listen("beforeChange", () => this.setCurrentThumb()));
    }
    stopDisabledScroll(t) {
      t.stopPropagation();
    }
    keyupClose(t) {
      "Enter" === t.code && this.popup.close();
    }
    onClose() {
      const t = this.pswpElement.querySelector(nu);
      if (
        (t && t.parentNode.removeChild(t),
        this.popupThumbsContainer && this.popupThumbsContainer.firstChild)
      )
        for (; this.popupThumbsContainer.firstChild; )
          this.popupThumbsContainer.removeChild(
            this.popupThumbsContainer.firstChild
          );
      this.pswpElement.setAttribute(uu, "");
      const e = this.pswpElement.querySelector(`.${hu}`);
      e && this.pswpElement.removeChild(e),
        this.options &&
          this.options.closeElClasses &&
          this.options.closeElClasses.length &&
          this.options.closeElClasses.forEach((t) => {
            const e = this.pswpElement.querySelector(`.pswp__${t}`);
            e && e.removeEventListener("keyup", this.keyupCloseEvent);
          }),
        this.a11y.removeTrapFocus(),
        this.a11y.autoFocusLastElement();
    }
    setCurrentThumb() {
      const t = this.pswpElement.querySelector(`${ru} > .${au}`);
      if (
        (t && (t.classList.remove(au), t.setAttribute(pu, !1)),
        !this.popupThumbs)
      )
        return;
      const e = this.popupThumbs[this.popup.getCurrentIndex()];
      e.classList.add(au), e.setAttribute(pu, !0), this.scrollThumbs(e);
    }
    scrollThumbs(t) {
      const e =
          this.popupThumbsContainer.scrollLeft +
          this.popupThumbsContainer.offsetWidth,
        s = t.offsetLeft;
      if (e <= s + t.offsetWidth || e > s) {
        const e = parseInt(window.getComputedStyle(t).marginLeft);
        this.popupThumbsContainer.scrollTo({
          top: 0,
          left: s - e,
          behavior: "smooth",
        });
      }
    }
    constructor(t, e = "") {
      (this.items = t),
        (this.pswpElement = document.querySelectorAll(iu)[0]),
        (this.popup = null),
        (this.popupThumbs = null),
        (this.popupThumbsContainer = this.pswpElement.querySelector(ru)),
        (this.closeBtn = this.pswpElement.querySelector(ou)),
        (this.keyupCloseEvent = (t) => this.keyupClose(t)),
        (this.a11y = N);
      (this.options = "" !== e ? e : { history: !1, focus: !1, mainClass: "" }),
        this.init();
    }
  };
  const gu = "[data-zoom-caption]",
    fu = "[data-zoom-image]",
    yu = "[data-pswp-thumbs-template]",
    bu = "[data-section-type]",
    wu = ".pswp__thumbs",
    Eu = "product-images",
    Su = "is-dragging",
    Lu = "variant--soldout",
    ku = "variant--unavailable",
    Au = "pswp-zoom-gallery",
    Tu = "pswp-zoom-gallery--single",
    Cu = "data-image-src",
    qu = "data-image-width",
    xu = "data-image-height";
  let Mu = class extends HTMLElement {
    connectedCallback() {
      this.images.forEach((t, e) => {
        t.addEventListener("click", (s) => {
          s.preventDefault(),
            t.closest(Eu).classList.contains(Su) ||
              (this.createZoom(e), (window.accessibility.lastElement = t));
        }),
          t.addEventListener("keyup", (s) => {
            "Enter" === s.code &&
              (s.preventDefault(),
              this.createZoom(e),
              (window.accessibility.lastElement = t));
          });
      });
    }
    createZoom(t) {
      const e = this.container.querySelector(yu),
        s = null == e ? void 0 : e.innerHTML;
      let i = [],
        o = 0;
      this.images.forEach((e) => {
        const n = e.getAttribute(Cu);
        if (
          ((o += 1),
          i.push({
            src: n,
            w: parseInt(e.getAttribute(qu)),
            h: parseInt(e.getAttribute(xu)),
            msrc: n,
          }),
          this.images.length === o)
        ) {
          new vu(i, {
            history: !1,
            focus: !1,
            index: t,
            mainClass: 1 === o ? `${Au} ${Tu}` : `${Au}`,
            showHideOpacity: !0,
            howAnimationDuration: 150,
            hideAnimationDuration: 250,
            closeOnScroll: !1,
            closeOnVerticalDrag: !1,
            captionEl: !0,
            closeEl: !0,
            closeElClasses: ["caption-close", "title"],
            tapToClose: !1,
            clickToCloseNonZoomable: !1,
            maxSpreadZoom: 2,
            loop: !0,
            spacing: 0,
            allowPanToNext: !0,
            pinchToClose: !1,
            addCaptionHTMLFn: (t, e, s) => {
              this.zoomCaption(t, e, s);
            },
            getThumbBoundsFn: () => {
              const e = this.images[t],
                s = window.scrollY || document.documentElement.scrollTop,
                i = e.getBoundingClientRect();
              return { x: i.left, y: i.top + s, w: i.width };
            },
          }),
            this.thumbsContainer &&
              "" !== s &&
              (this.thumbsContainer.innerHTML = s);
        }
      });
    }
    zoomCaption(t, e) {
      let s = "";
      const i = e.children[0];
      return (
        this.zoomCaptions &&
          ((s = this.zoomCaptions.innerHTML),
          this.zoomCaptions.closest(`.${Lu}`)
            ? i.classList.add(Lu)
            : i.classList.remove(Lu),
          this.zoomCaptions.closest(`.${ku}`)
            ? i.classList.add(ku)
            : i.classList.remove(ku)),
        (i.innerHTML = s),
        !1
      );
    }
    constructor() {
      super(),
        (this.container = this.closest(bu)),
        (this.images = this.querySelectorAll(fu)),
        (this.zoomCaptions = this.container.querySelector(gu)),
        (this.thumbsContainer = document.querySelector(wu));
    }
  };
  const Pu = "[data-add-to-cart]",
    Hu = "[data-product-json]",
    Iu = "[data-product-form]",
    Bu = "data-section-id",
    Ou = "data-cart-bar",
    Fu = "#cart-bar",
    Du = "data-add-to-cart-bar",
    $u = "data-cart-bar-scroll",
    _u = ".product__submit__add",
    Nu = "[data-form-wrapper]",
    Ru = "[data-product-variants]",
    Uu = "[data-slider]",
    zu = "data-slider-index",
    Wu = "is-visible",
    Vu = "is-loading",
    ju = {};
  const Xu = {
    onLoad() {
      ju[this.id] = new (class {
        initCartBar() {
          (this.cartBarBtn = this.cartBar.querySelector(_u)),
            this.cartBarBtn &&
              (this.cartBarBtn.addEventListener("click", (t) => {
                t.preventDefault(),
                  t.currentTarget.hasAttribute(Du)
                    ? (theme.settings.cartDrawerEnabled &&
                        (t.currentTarget.classList.add(Vu),
                        t.currentTarget.setAttribute("disabled", "disabled")),
                      this.form
                        .querySelector(Pu)
                        .dispatchEvent(new Event("click", { bubbles: !0 })))
                    : t.currentTarget.hasAttribute($u) && this.scrollToTop();
              }),
              this.cartBarBtn.hasAttribute(Du) &&
                document.addEventListener(
                  "theme:product:add-error",
                  this.scrollToTop
                )),
            this.setCartBarHeight();
        }
        scrollToTop() {
          const t = this.container.querySelector(Ru),
            e = (y() ? this.container : t || this.form).getBoundingClientRect()
              .top;
          nn(y() ? e : e - 10);
        }
        toggleCartBarOnScroll() {
          const t = window.scrollY,
            e =
              theme.variables.productPageSticky && this.formWrapper
                ? this.formWrapper
                : this.form;
          if (e && this.cartBar) {
            const s = t > e.offsetTop + e.offsetHeight;
            this.cartBar.classList.toggle(Wu, s);
          }
        }
        setCartBarHeight() {
          const t = this.cartBar.offsetHeight;
          document.documentElement.style.setProperty(
            "--cart-bar-height",
            `${t}px`
          );
        }
        onUnload() {
          document.removeEventListener(
            "theme:product:add-error",
            this.scrollToTop
          ),
            this.cartBarExist &&
              (document.removeEventListener(
                "theme:scroll",
                this.toggleCartBarOnScroll
              ),
              document.removeEventListener(
                "theme:resize",
                this.setCartBarHeight
              ));
        }
        onBlockSelect(t) {
          const e = t.srcElement.closest(Uu);
          if (e && this.slider.length) {
            const s = e.hasAttribute(zu) ? e.getAttribute(zu) : 0;
            if (!this.slider[s]) return;
            this.slider[s].onBlockSelect(t);
          }
        }
        onBlockDeselect(t) {
          const e = t.srcElement.closest(Uu);
          if (e && this.slider.length) {
            const s = e.hasAttribute(zu) ? e.getAttribute(zu) : 0;
            if (!this.slider[s]) return;
            this.slider[s].onBlockDeselect(t);
          }
        }
        constructor(t) {
          (this.section = t),
            (this.container = t.container),
            (this.id = this.container.getAttribute(Bu)),
            (this.sliders = this.container.querySelectorAll(Uu)),
            (this.slider = []),
            (this.formWrapper = this.container.querySelector(Nu)),
            (this.cartBarExist = "true" === this.container.getAttribute(Ou)),
            (this.cartBar = this.container.querySelector(Fu)),
            (this.setCartBarHeight = this.setCartBarHeight.bind(this)),
            (this.scrollToTop = this.scrollToTop.bind(this)),
            (this.toggleCartBarOnScroll =
              this.toggleCartBarOnScroll.bind(this)),
            (this.unlockTimer = 0),
            (this.accessibility = N);
          const e = this.container.querySelector(Hu);
          if ((e && !e.innerHTML) || !e) return;
          const s = JSON.parse(e.innerHTML).handle;
          let i = {};
          s && (i = { handle: s }),
            Shopify.Products.recordRecentlyViewed(i),
            (this.form = this.container.querySelector(Iu)),
            this.sliders.length &&
              this.sliders.forEach((t, e) => {
                t.setAttribute(zu, e),
                  this.slider.push(new sn(this.container, t));
              }),
            this.cartBarExist &&
              (this.initCartBar(),
              this.setCartBarHeight(),
              document.addEventListener(
                "theme:scroll",
                this.toggleCartBarOnScroll
              ),
              document.addEventListener("theme:resize", this.setCartBarHeight));
        }
      })(this);
    },
    onUnload(t) {
      ju[this.id].onUnload(t);
    },
    onBlockSelect(t) {
      ju[this.id].onBlockSelect(t);
    },
    onBlockDeselect(t) {
      ju[this.id].onBlockDeselect(t);
    },
  };
  fo("product", [Xu, Mo, dc, Zc]),
    customElements.get("complementary-products") ||
      customElements.define("complementary-products", Nc),
    customElements.get("pickup-availability") ||
      customElements.define("pickup-availability", tu),
    customElements.get("product-form") ||
      customElements.define("product-form", Md),
    customElements.get("product-images") ||
      customElements.define("product-images", kh),
    customElements.get("product-thumbs") ||
      customElements.define("product-thumbs", Nd),
    customElements.get("product-modal") ||
      customElements.define("product-modal", Xd),
    customElements.get("product-model") ||
      customElements.define("product-model", Jd),
    customElements.get("product-siblings") ||
      customElements.define("product-siblings", jl),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", Bl),
    customElements.get("recipient-form") ||
      customElements.define("recipient-form", Vc),
    customElements.get("share-button") ||
      customElements.define("share-button", oh),
    customElements.get("zoom-images") ||
      customElements.define("zoom-images", Mu);
  const Ju = "[data-api-related-template]",
    Yu = "[data-related-section]",
    Qu = "[data-grid-item]",
    Gu = "[data-recent-wrapper]",
    Ku = "[data-recently-viewed-wrapper]",
    Zu = ".product-item",
    tp = "grid-slider",
    ep = "data-limit",
    sp = "data-minimum",
    ip = "data-product-id",
    op = "is-hidden",
    np = {};
  const rp = {
    onLoad() {
      np[this.id] = new (class {
        related() {
          const t = this.container.querySelector(Yu);
          if (!t) return;
          const e = t.getAttribute(ip),
            s = t.getAttribute(ep),
            i = `${window.theme.routes.product_recommendations_url}?section_id=api-product-recommendation&limit=${s}&product_id=${e}&intent=related`;
          fetch(i)
            .then((t) => t.text())
            .then((e) => {
              const s = document.createElement("div");
              (s.innerHTML = new DOMParser()
                .parseFromString(e, "text/html")
                .querySelector(Ju).innerHTML),
                s.querySelector(Qu)
                  ? (t.innerHTML = s.innerHTML)
                  : t.dispatchEvent(
                      new CustomEvent("theme:tab:hide", { bubbles: !0 })
                    );
            })
            .catch(function () {
              t.dispatchEvent(
                new CustomEvent("theme:tab:hide", { bubbles: !0 })
              );
            });
        }
        recent() {
          const t = this.container.querySelector(Gu),
            e = t ? parseInt(t.getAttribute(ep)) : 4;
          Shopify.Products.showRecentlyViewed({
            howManyToShow: e,
            wrapperId: `recently-viewed-products-${this.sectionId}`,
            section: this.section,
            onComplete: (t, e) => {
              const s = e.container,
                i = s.querySelector(Gu),
                o = s.querySelector(Ku),
                n = t.querySelectorAll(Zu),
                r = i.querySelector(tp),
                a = i.hasAttribute(sp) ? parseInt(i.getAttribute(sp)) : 4,
                l = !o && n.length > 0,
                c = o && n.length >= a;
              (l || c) &&
                (c && o.classList.remove(op),
                i.classList.remove("is-hidden"),
                i.dispatchEvent(
                  new CustomEvent("theme:tab:check", { bubbles: !0 })
                ),
                r &&
                  r.dispatchEvent(
                    new CustomEvent("theme:grid-slider:init", { bubbles: !0 })
                  ));
            },
          });
        }
        constructor(t) {
          (this.section = t),
            (this.sectionId = t.id),
            (this.container = t.container),
            this.related(),
            this.recent();
        }
      })(this);
    },
  };
  fo("related", [rp, dc]), fo("reviews", [on, Ra]);
  const ap = {},
    lp = "[data-slider-logos]",
    cp = "[data-slider-text]",
    hp = "[data-slide]",
    dp = "is-selected",
    up = "is-initialized",
    pp = "flickity-enabled",
    mp = "data-slide",
    vp = "data-slide-index";
  fo("logos", [
    {
      onLoad() {
        ap[this.id] = new (class {
          getSlidesWidth() {
            return 200 * this.logoSlides.length;
          }
          initSlideshowText() {
            this.slideshowText &&
              (this.flkty = new n(this.slideshowText, {
                fade: !0,
                autoPlay: !1,
                prevNextButtons: !1,
                cellAlign: "left",
                contain: !0,
                pageDots: !1,
                wrapAround: !1,
                selectedAttraction: 0.2,
                friction: 0.6,
                draggable: !1,
                accessibility: !1,
                on: {
                  ready: () => this.sliderAccessibility(),
                  change: () => this.sliderAccessibility(),
                },
              }));
          }
          sliderAccessibility() {
            const t = this.slideshowText.querySelectorAll(
              `${hp} a, ${hp} button`
            );
            t.length &&
              t.forEach((t) => {
                const e = t.closest(hp);
                if (e) {
                  const s = e.classList.contains(dp) ? 0 : -1;
                  t.setAttribute("tabindex", s);
                }
              });
          }
          initSlideshowNav() {
            this.slideshowNav &&
              (this.logoSlides.length &&
                this.logoSlides.forEach((t) => {
                  t.addEventListener("click", (e) => {
                    e.preventDefault();
                    const s = parseInt(t.getAttribute(vp)),
                      i = this.slideshowNav.classList.contains(pp);
                    if ((this.flkty && this.flkty.select(s), i))
                      this.flktyNav.select(s),
                        this.slideshowNav.classList.contains(dp) ||
                          this.flktyNav.playPlayer();
                    else {
                      const e = this.slideshowNav.querySelector(`.${dp}`);
                      e && e.classList.remove(dp), t.classList.add(dp);
                    }
                  });
                }),
              this.setSlideshowNavState(),
              document.addEventListener(
                "theme:resize",
                this.setSlideshowNavStateOnResize
              ));
          }
          setSlideshowNavState() {
            const t = this.slideshowNav.classList.contains(pp);
            if (this.logoSlidesWidth > g()) {
              if (!t) {
                this.slideshowNav.classList.add(up);
                const t = this.slideshowNav.querySelector(`.${dp}`);
                t && t.classList.remove(dp),
                  this.logoSlides[0].classList.add(dp),
                  this.flktyNav ||
                    ((this.flktyNav = new o(this.slideshowNav, {
                      autoPlay: 4e3,
                      prevNextButtons: !1,
                      contain: !1,
                      pageDots: !1,
                      wrapAround: !0,
                      watchCSS: !0,
                      selectedAttraction: 0.05,
                      friction: 0.8,
                      initialIndex: 0,
                    })),
                    this.flktyNav.on("deactivate", () => {
                      this.slideshowNav.querySelector(hp).classList.add(dp),
                        this.flkty && this.flkty.select(0);
                    }),
                    this.flkty &&
                      (this.flkty.select(0),
                      this.flktyNav.on("change", (t) => this.flkty.select(t))));
              }
            } else t && this.slideshowNav.classList.remove(up);
          }
          onBlockSelect(t) {
            if (!this.slideshowNav) return;
            const e = this.slideshowNav.querySelector(
                `[${mp}="${t.detail.blockId}"]`
              ),
              s = parseInt(e.getAttribute(vp));
            this.slideshowNav.classList.contains(pp)
              ? (this.flktyNav.select(s),
                this.flktyNav.stopPlayer(),
                this.slideshowNav.classList.add(dp))
              : e.dispatchEvent(new Event("click"));
          }
          onBlockDeselect() {
            this.slideshowNav &&
              this.slideshowNav.classList.contains(pp) &&
              (this.flktyNav.playPlayer(),
              this.slideshowNav.classList.remove(dp));
          }
          onUnload() {
            document.removeEventListener(
              "theme:resize",
              this.setSlideshowNavStateOnResize
            );
          }
          constructor(t) {
            (this.container = t.container),
              (this.slideshowNav = this.container.querySelector(lp)),
              (this.slideshowText = this.container.querySelector(cp)),
              (this.setSlideshowNavStateOnResize = () =>
                this.setSlideshowNavState()),
              (this.flkty = null),
              (this.flktyNav = null),
              (this.logoSlides = this.slideshowNav.querySelectorAll(hp)),
              (this.logoSlidesWidth = this.getSlidesWidth()),
              this.initSlideshowText(),
              this.initSlideshowNav();
          }
        })(this);
      },
      onUnload(t) {
        ap[this.id].onUnload(t);
      },
      onBlockSelect(t) {
        ap[this.id].onBlockSelect(t);
      },
      onBlockDeselect(t) {
        ap[this.id].onBlockDeselect(t);
      },
    },
    Ra,
  ]);
  const gp = "data-video-play";
  let fp = class extends HTMLElement {
    connectedCallback() {
      var t;
      (this.videoPlay = this.querySelectorAll(`[${gp}]`)),
        null === (t = this.videoPlay) ||
          void 0 === t ||
          t.forEach((t) => {
            t.addEventListener("click", (t) => {
              const e = t.currentTarget;
              if ("" !== e.getAttribute(gp).trim()) {
                t.preventDefault();
                const s = [{ html: e.getAttribute(gp) }];
                new vu(s), (window.accessibility.lastElement = e);
              }
            });
          });
    }
    constructor() {
      super();
    }
  };
  const yp = "[data-video-template]",
    bp = "is-loading",
    wp = "data-video-id";
  let Ep = class extends HTMLElement {
    connectedCallback() {
      (this.videoId = this.getAttribute(wp)),
        (this.videoTemplate = this.querySelector(yp)),
        (this.video = null),
        this.videoId &&
          (document.addEventListener(
            "touchstart",
            this.powerSaverVideoPlay.bind(this),
            { passive: !0 }
          ),
          this.renderVideo());
    }
    powerSaverVideoPlay() {
      var t;
      null === (t = this.video) || void 0 === t || t.play();
    }
    renderVideo() {
      (this.videoTemplateObserver = new IntersectionObserver(
        (t, e) => {
          t.forEach((t) => {
            if (t.isIntersecting) {
              const s = this.videoTemplate.innerHTML;
              (this.innerHTML = s),
                this.classList.remove(bp),
                (this.video = this.querySelector("video")),
                this.observeVideoPlayToggle(),
                e.unobserve(t.target);
            }
          });
        },
        {
          root: null,
          rootMargin: "300px",
          threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
        }
      )),
        this.videoTemplateObserver.observe(this);
    }
    observeVideoPlayToggle() {
      if (!this.video) return;
      (this.videoPlayObserver = new IntersectionObserver(
        (t) => {
          t.forEach((t) => {
            const e = t.isIntersecting;
            e && "function" == typeof this.video.play && this.video.play(),
              e || "function" != typeof this.video.pause || this.video.pause();
          });
        },
        { rootMargin: "0px", threshold: [0, 1] }
      )),
        this.videoPlayObserver.observe(this.video);
    }
    disconnectedCallback() {
      this.videoTemplateObserver && this.videoTemplateObserver.disconnect(),
        this.videoPlayObserver && this.videoPlayObserver.disconnect(),
        this.videoId &&
          document.removeEventListener(
            "touchstart",
            this.powerSaverVideoPlay.bind(this),
            { passive: !0 }
          );
    }
    constructor() {
      super();
    }
  };
  fo("featured-video", [Ho]),
    customElements.get("video-background") ||
      customElements.define("video-background", Ep),
    customElements.get("video-popup") ||
      customElements.define("video-popup", fp),
    fo("slideshow", [on, Ho]);
  const Sp = "[data-images-holder]",
    Lp = "[data-image-holder]",
    kp = "[data-image-element]",
    Ap = "[data-images-button]",
    Tp = "data-start-position",
    Cp = {};
  const qp = {
    onLoad() {
      Cp[this.id] = [];
      this.container.querySelectorAll(Sp).forEach((t) => {
        Cp[this.id].push(
          new (class {
            init() {
              this.changeValues(),
                this.imagesButton.addEventListener(
                  "mousedown",
                  this.onStartEvent
                ),
                this.imagesButton.addEventListener(
                  "touchstart",
                  this.onStartEvent,
                  { passive: !0 }
                );
            }
            changeValues(t) {
              const e = this.imagesHolder.offsetWidth,
                s = this.imagesButton.offsetWidth;
              if (
                (!t ||
                  (t && "touchmove" !== t.type && "mousemove" !== t.type)) &&
                ((this.imageElement.style.width = `${e}px`),
                (this.imageHolder.style.width =
                  100 - parseInt(this.startPosition) + "%"),
                0 !== this.startPosition)
              ) {
                const t = (e * parseInt(this.startPosition)) / 100;
                this.x = t - s / 2;
              }
              this.x > e - s ? (this.x = e - s) : this.x < 0 && (this.x = 0),
                (this.imagesButton.style.left = (this.x / e) * 100 + "%"),
                (this.imageHolder.style.width =
                  100 - ((this.x + s / 2) / e) * 100 + "%");
            }
            onStart(t) {
              t.preventDefault();
              let e = t;
              t.touches && (e = t.touches[0]),
                (this.x = this.imagesButton.offsetLeft),
                (this.startX = e.pageX - this.x),
                this.imagesHolder.addEventListener(
                  "mousemove",
                  this.onMoveEvent
                ),
                this.imagesHolder.addEventListener("mouseup", this.onStopEvent),
                this.imagesHolder.addEventListener(
                  "touchmove",
                  this.onMoveEvent
                ),
                this.imagesHolder.addEventListener(
                  "touchend",
                  this.onStopEvent
                );
            }
            onMove(t) {
              let e = t;
              t.touches && (e = t.touches[0]),
                (this.x = e.pageX - this.startX),
                this.changeValues(t);
            }
            onStop(t) {
              this.imagesHolder.removeEventListener(
                "mousemove",
                this.onMoveEvent
              ),
                this.imagesHolder.removeEventListener(
                  "mouseup",
                  this.onStopEvent
                ),
                this.imagesHolder.removeEventListener(
                  "touchmove",
                  this.onMoveEvent
                ),
                this.imagesHolder.removeEventListener(
                  "touchend",
                  this.onStopEvent
                );
            }
            onUnload() {
              this.changeValuesEvent &&
                document.removeEventListener(
                  "theme:resize",
                  this.changeValuesEvent
                );
            }
            constructor(t) {
              (this.imagesHolder = t),
                this.imagesHolder &&
                  ((this.imageHolder = this.imagesHolder.querySelector(Lp)),
                  (this.imageElement = this.imagesHolder.querySelector(kp)),
                  (this.imagesButton = this.imagesHolder.querySelector(Ap)),
                  (this.startPosition = this.imagesHolder.hasAttribute(Tp)
                    ? this.imagesHolder.getAttribute(Tp)
                    : 0),
                  (this.startX = 0),
                  (this.x = 0),
                  (this.changeValuesEvent = (t) => this.changeValues(t)),
                  (this.onMoveEvent = (t) => this.onMove(t)),
                  (this.onStopEvent = (t) => this.onStop(t)),
                  (this.onStartEvent = (t) => this.onStart(t)),
                  this.init(),
                  document.addEventListener(
                    "theme:resize",
                    this.changeValuesEvent
                  ));
            }
          })(t)
        );
      });
    },
    onUnload() {
      Cp[this.id].forEach((t) => {
        "function" == typeof t.onUnload && t.onUnload();
      });
    },
  };
  fo("custom-content", [on, Ho, qp, vn]),
    customElements.get("video-background") ||
      customElements.define("video-background", Ep),
    customElements.get("video-popup") ||
      customElements.define("video-popup", fp);
  var xp = {};
  function Mp(t) {
    return xp[t];
  }
  (xp.basic = []),
    (xp.light = [
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [
          { visibility: "simplified" },
          { lightness: "64" },
          { hue: "#ff0000" },
        ],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{ color: "#bdbdbd" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [{ color: "#f0f0f0" }, { visibility: "simplified" }],
      },
      {
        featureType: "landscape.natural.landcover",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "landscape.natural.terrain",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ lightness: "100" }],
      },
      {
        featureType: "poi.park",
        elementType: "all",
        stylers: [{ visibility: "on" }],
      },
      {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{ saturation: "-41" }, { color: "#e8ede7" }],
      },
      {
        featureType: "poi.park",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [{ saturation: "-100" }],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [
          { lightness: "25" },
          { gamma: "1.06" },
          { saturation: "-100" },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ gamma: "10.00" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }, { visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ gamma: "10.00" }, { lightness: "100" }, { weight: "0.4" }],
      },
      {
        featureType: "road.local",
        elementType: "labels",
        stylers: [
          { visibility: "simplified" },
          { weight: "0.01" },
          { lightness: "39" },
        ],
      },
      {
        featureType: "road.local",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.50" }, { gamma: "10.00" }, { lightness: "100" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [{ color: "#cfe5ee" }, { visibility: "on" }],
      },
    ]),
    (xp.white_label = [
      {
        featureType: "all",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "all",
        elementType: "labels",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{ gamma: "3.86" }, { lightness: "100" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{ color: "#cccccc" }],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [{ color: "#f2f2f2" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [{ saturation: -100 }, { lightness: 45 }],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0" }],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "labels.text",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [{ color: "#e4e4e4" }, { visibility: "on" }],
      },
    ]),
    (xp.dark_label = [
      {
        featureType: "all",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }],
      },
      {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [
          { visibility: "on" },
          { color: "#000000" },
          { lightness: 16 },
        ],
      },
      {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{ color: "#000000" }, { lightness: 20 }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }],
      },
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{ visibility: "simplified" }, { lightness: "-82" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.stroke",
        stylers: [{ invert_lightness: !0 }, { weight: "7.15" }],
      },
      {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 20 }],
      },
      {
        featureType: "landscape",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 21 }],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: "0.01" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 18 }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 16 }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 19 }],
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 17 }],
      },
    ]),
    (window.theme.allMaps = window.theme.allMaps || {});
  let Pp = window.theme.allMaps;
  window.theme.mapAPI = window.theme.mapAPI || null;
  fo("map", {
    onLoad() {
      Pp[this.id] = new (class {
        initMaps() {
          (function (t) {
            if (null === window.theme.mapAPI) {
              const e = `https://maps.googleapis.com/maps/api/js?key=${t}`;
              window.theme.mapAPI = su({ url: e });
            }
            return window.theme.mapAPI;
          })(this.key)
            .then(() => {
              return "true" === this.enableCorrection &&
                "" !== this.lat &&
                "" !== this.long
                ? new google.maps.LatLng(this.lat, this.long)
                : ((t = this.address),
                  new Promise((e, s) => {
                    new google.maps.Geocoder().geocode(
                      { address: t },
                      function (t, i) {
                        if ("OK" == i) {
                          var o = {
                            lat: t[0].geometry.location.lat(),
                            lng: t[0].geometry.location.lng(),
                          };
                          e(o);
                        } else s(i);
                      }
                    );
                  }));
              var t;
            })
            .then((t) => {
              const e = {
                  zoom: parseInt(this.zoomString, 10),
                  styles: Mp(this.styleString),
                  center: t,
                  draggable: !0,
                  clickableIcons: !1,
                  scrollwheel: !1,
                  zoomControl: !1,
                  disableDefaultUI: !0,
                },
                s = (function (t, e) {
                  var s = new google.maps.Map(t, e),
                    i = s.getCenter();
                  return (
                    new google.maps.Marker({ map: s, position: i }),
                    google.maps.event.addDomListener(
                      window,
                      "resize",
                      function () {
                        google.maps.event.trigger(s, "resize"), s.setCenter(i);
                      }
                    ),
                    s
                  );
                })(this.mapContainer, e);
              return s;
            })
            .then((t) => {
              (this.map = t), (Pp[this.id] = t);
            })
            .catch((t) => {
              console.log("Failed to load Google Map"), console.log(t);
            });
        }
        unload() {
          void 0 !== window.google &&
            google.maps.event.clearListeners(this.map, "resize");
        }
        constructor(t) {
          (this.container = t.container),
            (this.mapContainer = this.container.querySelector(
              "[data-map-container]"
            )),
            (this.key = this.container.getAttribute("data-api-key")),
            (this.styleString =
              this.container.getAttribute("data-style") || ""),
            (this.zoomString = this.container.getAttribute("data-zoom") || 14),
            (this.address = this.container.getAttribute("data-address")),
            (this.enableCorrection = this.container.getAttribute(
              "data-latlong-correction"
            )),
            (this.lat = this.container.getAttribute("data-lat")),
            (this.long = this.container.getAttribute("data-long")),
            this.key && this.initMaps();
        }
      })(this);
    },
    onUnload() {
      "function" == typeof Pp[this.id].unload && Pp[this.id].unload();
    },
  });
  const Hp = "[data-large-promo]",
    Ip = "[data-large-promo-inner]",
    Bp = "[data-tracking-consent]",
    Op = "[data-confirm-cookies]",
    Fp = "cart-bar",
    Dp = "[data-newsletter]",
    $p = "[data-newsletter-holder]",
    _p = "[data-newsletter-heading]",
    Np = "[data-newsletter-field]",
    Rp = "[data-promo-text]",
    Up = "[data-newsletter-form]",
    zp = "data-popup-delay",
    Wp = "data-cookie-name",
    Vp = "data-target-referrer",
    jp = "hidden",
    Xp = "has-value",
    Jp = "cart-bar-visible",
    Yp = "is-visible",
    Qp = "has-success",
    Gp = "selected",
    Kp = "has-block-selected",
    Zp = "mobile",
    tm = "desktop",
    em = "bottom",
    sm = "data-enable";
  let im = {},
    om = class {
      always() {
        this.popupActions.popupOpen();
      }
      delayed(t = 10) {
        setTimeout(() => {
          this.popupActions.popupOpen();
        }, 1e3 * t);
      }
      idle() {
        let t = 0;
        const e = [
            "mousemove",
            "mousedown",
            "click",
            "touchmove",
            "touchstart",
            "touchend",
            "keydown",
            "keypress",
          ],
          s = ["load", "resize", "scroll"],
          i = () => {
            (t = setTimeout(() => {
              (t = 0), this.popupActions.popupOpen();
            }, 6e4)),
              e.forEach((t) => {
                document.addEventListener(t, o);
              }),
              s.forEach((t) => {
                window.addEventListener(t, o);
              });
          },
          o = () => {
            t && clearTimeout(t),
              e.forEach((t) => {
                document.removeEventListener(t, o);
              }),
              s.forEach((t) => {
                window.removeEventListener(t, o);
              }),
              i();
          };
        i();
      }
      bottom() {
        document.addEventListener("theme:scroll", this.showPopupOnScrollEvent);
      }
      showPopupOnScroll() {
        window.scrollY + window.innerHeight >= document.body.clientHeight &&
          (this.popupActions.popupOpen(),
          document.removeEventListener(
            "theme:scroll",
            this.showPopupOnScrollEvent
          ));
      }
      onUnload() {
        document.removeEventListener(
          "theme:scroll",
          this.showPopupOnScrollEvent
        );
      }
      constructor(t, e, s) {
        if (
          ((this.element = e),
          (this.delay = t.getAttribute(zp)),
          (this.isSubmitted =
            -1 !== window.location.href.indexOf("accepts_marketing") ||
            -1 !== window.location.href.indexOf("customer_posted=true")),
          (this.popupActions = s),
          (this.showPopupOnScrollEvent = () => this.showPopupOnScroll()),
          ("always" === this.delay || this.isSubmitted) && this.always(),
          this.delay && this.delay.includes("delayed") && !this.isSubmitted)
        ) {
          const t = this.delay.includes("_")
            ? parseInt(this.delay.split("_")[1])
            : 10;
          this.delayed(t);
        }
        "bottom" !== this.delay || this.isSubmitted || this.bottom(),
          "idle" !== this.delay || this.isSubmitted || this.idle();
      }
    },
    nm = class {
      init() {
        -1 !== this.locationPath.indexOf(this.el.getAttribute(Vp)) ||
          window.Shopify.designMode ||
          this.el.parentNode.removeChild(this.el);
      }
      constructor(t) {
        if (
          ((this.el = t),
          (this.locationPath = location.href),
          !this.el.hasAttribute(Vp))
        )
          return !1;
        this.init();
      }
    };
  const rm = {
    onLoad() {
      im[this.id] = [];
      this.container.querySelectorAll(Hp).forEach((t) => {
        im[this.id].push(
          new (class {
            init() {
              const t = !1 !== this.cookie.read(),
                e = this.popup.classList.contains(Zp),
                s = this.popup.classList.contains(tm),
                i = !y();
              let o = !0;
              if ((((e && !i) || (s && i)) && (o = !1), !o))
                return (
                  this.a11y.removeTrapFocus(),
                  void document.dispatchEvent(
                    new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                  )
                );
              (t && !window.Shopify.designMode) ||
                (window.Shopify.designMode ||
                  window.location.pathname.endsWith("/challenge") ||
                  new om(this.popup, this.modal, this.popupActions),
                this.form &&
                  this.form.classList.contains(Qp) &&
                  this.checkForSuccess(),
                this.modal.addEventListener("theme:popup:onclose", () =>
                  this.cookie.write()
                ));
            }
            checkForSuccess() {
              this.popupActions.popupOpen(), this.cookie.write();
            }
            onBlockSelect(t) {
              this.popup.contains(t.target) &&
                (this.popupActions.popupOpen(),
                this.popup.classList.add(Gp),
                this.popup.parentNode.classList.add(Kp));
            }
            onBlockDeselect(t) {
              this.popup.contains(t.target) &&
                (this.popupActions.popupClose(),
                this.popup.classList.remove(Gp),
                this.popup.parentNode.classList.remove(Kp));
            }
            constructor(t) {
              (this.popup = t),
                (this.modal = this.popup.querySelector(Ip)),
                (this.form = this.popup.querySelector(Up)),
                (this.cookie = new rn(
                  this.popup.getAttribute(Wp),
                  "user_has_closed"
                )),
                (this.isTargeted = new nm(this.popup)),
                (this.popupActions = new Vd(this.modal, this.modal, !0, !0)),
                (this.a11y = N),
                this.init();
            }
          })(t)
        );
      });
      this.container.querySelectorAll(Bp).forEach((t) => {
        im[this.id].push(
          new (class {
            init() {
              this.showPopup && this.popupActions.popupOpen(),
                this.clickEvents();
            }
            clickEvents() {
              this.acceptButton.addEventListener("click", (t) => {
                t.preventDefault(),
                  window.Shopify.customerPrivacy.setTrackingConsent(!0, () =>
                    this.popupActions.popupClose()
                  ),
                  document.documentElement.style.setProperty(
                    "--cookie-bar-height",
                    "0px"
                  );
              }),
                document.addEventListener("trackingConsentAccepted", () => {});
            }
            onSelect() {
              this.showPopup &&
                (this.popupActions.popupOpen(),
                this.popup.classList.add(Gp),
                this.popup.parentNode.classList.add(Kp));
            }
            onDeselect() {
              this.showPopup &&
                (this.popupActions.popupClose(),
                this.popup.classList.remove(Gp),
                this.popup.parentNode.classList.remove(Kp));
            }
            constructor(t) {
              (this.popup = t),
                (this.modal = document.querySelector(Bp)),
                (this.acceptButton = this.modal.querySelector(Op)),
                (this.enable = "true" === this.modal.getAttribute(sm)),
                (this.showPopup = !1),
                (this.popupActions = new Vd(this.popup, this.popup, !1, !1)),
                window.Shopify.loadFeatures(
                  [{ name: "consent-tracking-api", version: "0.1" }],
                  (t) => {
                    if (t) throw t;
                    const e = window.Shopify.customerPrivacy.userCanBeTracked(),
                      s = window.Shopify.customerPrivacy.getTrackingConsent();
                    (this.showPopup =
                      !e && "no_interaction" === s && this.enable),
                      window.Shopify.designMode && (this.showPopup = !0),
                      this.init();
                  }
                );
            }
          })(t)
        );
      });
      this.container.querySelectorAll(Dp).forEach((t) => {
        im[this.id].push(
          new (class {
            init() {
              const t = !1 !== this.cookie.read(),
                e =
                  -1 !==
                  window.location.search.indexOf("?customer_posted=true"),
                s = [...this.holder.classList].toString().includes(em);
              e && (this.delay = 0),
                (t && !window.Shopify.designMode) ||
                  (this.show(),
                  this.form.classList.contains(Qp) && this.checkForSuccess()),
                s && this.observeCartBar();
            }
            show() {
              window.location.pathname.endsWith("/challenge") ||
                (window.Shopify.designMode
                  ? this.popupActions.popupOpen()
                  : new om(this.popup, this.holder, this.popupActions)),
                this.showForm(),
                this.inputField(),
                this.holder.addEventListener("theme:popup:onclose", () =>
                  this.cookie.write()
                );
            }
            checkForSuccess() {
              this.popupActions.popupOpen(), this.cookie.write();
            }
            observeCartBar() {
              if (((this.cartBar = document.getElementById(Fp)), !this.cartBar))
                return;
              let t = this.cartBar.classList.contains(Yp);
              document.body.classList.toggle(Jp, t),
                (this.observer = new MutationObserver((e) => {
                  for (const s of e)
                    "attributes" === s.type &&
                      ((t = s.target.classList.contains(Yp)),
                      document.body.classList.toggle(Jp, t));
                })),
                this.observer.observe(this.cartBar, {
                  attributes: !0,
                  childList: !1,
                  subtree: !1,
                });
            }
            showForm() {
              this.heading.addEventListener("click", (t) => {
                t.preventDefault(),
                  this.heading.classList.add(jp),
                  this.form.classList.remove(jp),
                  this.newsletterField.focus();
              }),
                this.heading.addEventListener("keyup", (t) => {
                  "Enter" === t.code &&
                    this.heading.dispatchEvent(new Event("click"));
                });
            }
            inputField() {
              const t = () => {
                this.resetClassTimer && clearTimeout(this.resetClassTimer),
                  "" !== this.newsletterField.value &&
                    this.holder.classList.add(Xp);
              };
              this.newsletterField.addEventListener("input", t),
                this.newsletterField.addEventListener("focus", t),
                this.newsletterField.addEventListener("focusout", () => {
                  this.resetClassTimer && clearTimeout(this.resetClassTimer),
                    (this.resetClassTimer = setTimeout(() => {
                      this.holder.classList.remove(Xp);
                    }, 2e3));
                });
            }
            onBlockSelect(t) {
              this.popup.contains(t.target) &&
                (this.popupActions.popupOpen(),
                this.popup.classList.add(Gp),
                this.popup.parentNode.classList.add(Kp));
            }
            onBlockDeselect(t) {
              this.popup.contains(t.target) &&
                (this.popupActions.popupClose(),
                this.popup.classList.remove(Gp),
                this.popup.parentNode.classList.remove(Kp));
            }
            onUnload() {
              this.observer && this.observer.disconnect();
            }
            constructor(t) {
              (this.popup = t),
                (this.holder = this.popup.querySelector($p)),
                (this.heading = this.popup.querySelector(_p)),
                (this.newsletterField = this.popup.querySelector(Np)),
                (this.cookie = new rn(
                  this.popup.getAttribute(Wp),
                  "newsletter_is_closed"
                )),
                (this.form = this.popup.querySelector(Up)),
                (this.isTargeted = new nm(this.popup)),
                (this.popupActions = new Vd(this.holder, this.holder, !1, !1)),
                (this.resetClassTimer = 0),
                this.init();
            }
          })(t)
        );
      });
      this.container.querySelectorAll(Rp).forEach((t) => {
        im[this.id].push(
          new (class {
            init() {
              (!1 !== this.cookie.read() && !window.Shopify.designMode) ||
                (window.Shopify.designMode
                  ? this.popupActions.popupOpen()
                  : new om(this.popup, this.popup, this.popupActions),
                this.popup.addEventListener("theme:popup:onclose", () =>
                  this.cookie.write()
                ));
            }
            onSelect() {
              this.popupActions.popupOpen(),
                this.popup.classList.add(Gp),
                this.popup.parentNode.classList.add(Kp);
            }
            onDeselect() {
              this.popupActions.popupClose(),
                this.popup.classList.remove(Gp),
                this.popup.parentNode.classList.remove(Kp);
            }
            constructor(t) {
              (this.popup = t),
                (this.cookie = new rn(
                  this.popup.getAttribute(Wp),
                  "user_has_closed"
                )),
                (this.isTargeted = new nm(this.popup)),
                (this.popupActions = new Vd(this.popup, this.popup, !1, !1)),
                this.init();
            }
          })(t)
        );
      });
    },
    onBlockSelect(t) {
      im[this.id].forEach((e) => {
        "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
      });
    },
    onBlockDeselect(t) {
      im[this.id].forEach((e) => {
        "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
      });
    },
    onSelect() {
      im[this.id].forEach((t) => {
        "function" == typeof t.onSelect && t.onSelect();
      });
    },
    onDeselect() {
      im[this.id].forEach((t) => {
        "function" == typeof t.onDeselect && t.onDeselect();
      });
    },
    onUnload() {
      im[this.id].forEach((t) => {
        "function" == typeof t.onUnload && t.onUnload();
      });
    },
  };
  fo("popups", [rm, vn]);
  const am = "[data-password-modal]",
    lm = "#login_form .errors";
  fo("password-template", {
    onLoad() {
      new (class {
        constructor(t) {
          (this.container = t.container),
            (this.popupActions = new Vd(
              this.container.querySelector(am),
              this.container,
              !0,
              !0
            )),
            this.container.querySelector(lm) && this.popupActions.popupOpen();
        }
      })(this);
    },
  }),
    fo("list-collections", [on, Ra]),
    fo("columns", [Ra, on]),
    fo("newsletter", vn),
    fo("before-after", [qp]);
  const cm = "[data-scroll-to]",
    hm = "[data-tooltip]",
    dm = "[data-collapsible-trigger]",
    um = "open",
    pm = "data-scroll-to",
    mm = "data-tooltip-stop-mouseenter",
    vm = {};
  const gm = {
      onLoad() {
        vm[this.id] = new (class {
          init() {
            this.scrollToButtons.forEach((t) => {
              t.addEventListener("click", () => {
                const e = this.container.querySelector(t.getAttribute(pm));
                e && "A" !== t.tagName && this.scrollToElement(e);
              });
            });
          }
          scrollToElement(t) {
            nn(t.getBoundingClientRect().top + 1);
            const e = t.nextElementSibling.matches("details")
              ? t.nextElementSibling
              : null;
            if (e) {
              const t = null == e ? void 0 : e.querySelector(dm);
              e.hasAttribute(um) ||
                null == t ||
                t.dispatchEvent(new Event("click"));
            }
            const s = document.querySelectorAll(`${hm}:not([${mm}])`);
            s.length &&
              s.forEach((t) => {
                t.setAttribute(mm, ""),
                  setTimeout(() => {
                    t.removeAttribute(mm);
                  }, 1e3);
              });
          }
          constructor(t) {
            (this.section = t),
              (this.container = t.container),
              (this.scrollToButtons = this.container.querySelectorAll(cm)),
              this.scrollToButtons.length && this.init();
          }
        })(this);
      },
    },
    fm = "[data-scroll-spy]",
    ym = "is-selected",
    bm = "data-scroll-spy",
    wm = "data-scroll-spy-mobile",
    Em = "data-scroll-spy-desktop",
    Sm = "data-scroll-trigger-point",
    Lm = {};
  const km = {
    onLoad() {
      var t;
      (Lm[this.id] = []),
        null === (t = this.container.querySelectorAll(fm)) ||
          void 0 === t ||
          t.forEach((t) => {
            const e = this.container.querySelector(t.getAttribute(bm));
            Lm[this.id].push(
              new (class {
                init() {
                  this.toggleScrollObserver(),
                    document.addEventListener(
                      "theme:resize:width",
                      this.toggleScrollObserver
                    );
                }
                toggleScrollObserver() {
                  this.isEligible()
                    ? this.initialized ||
                      (document.addEventListener(
                        "theme:scroll",
                        this.scrollCallback
                      ),
                      (this.initialized = !0))
                    : (document.removeEventListener(
                        "theme:scroll",
                        this.scrollCallback
                      ),
                      (this.initialized = !1));
                }
                isEligible() {
                  const t = y();
                  return (
                    (!t && this.anchor.hasAttribute(wm)) ||
                    (t && this.anchor.hasAttribute(Em)) ||
                    (!this.anchor.hasAttribute(Em) &&
                      !this.anchor.hasAttribute(wm))
                  );
                }
                onScroll() {
                  this.top = this.elementToSpy.getBoundingClientRect().top;
                  const t = Math.round(window.innerHeight),
                    e = Math.round(window.scrollY),
                    s = e + t,
                    i = Math.round(this.top + e),
                    o = this.elementToSpy.offsetHeight;
                  i < s &&
                    !(i + o < e) &&
                    this.triggerPointReached() &&
                    (this.anchorSiblings.forEach((t) => {
                      t.matches(this.anchorSelector) || t.classList.remove(ym);
                    }),
                    this.anchor.classList.add(ym));
                }
                triggerPointReached() {
                  let t = !1;
                  switch (this.triggerPoint) {
                    case "top":
                    default:
                      t = this.top <= 0;
                      break;
                    case "middle":
                      t = this.top <= window.innerHeight / 2;
                      break;
                    case "bottom":
                      t = this.top <= window.innerHeight;
                  }
                  return t;
                }
                onUnload() {
                  document.removeEventListener(
                    "theme:resize:width",
                    this.toggleScrollObserver
                  ),
                    document.removeEventListener(
                      "theme:scroll",
                      this.scrollCallback
                    );
                }
                constructor(t, e) {
                  (this.container = t),
                    (this.elementToSpy = e),
                    (this.anchorSelector = `[${bm}="#${this.elementToSpy.id}"]`),
                    (this.anchor = this.container.querySelector(
                      this.anchorSelector
                    )),
                    (this.anchorSiblings = this.container.querySelectorAll(
                      `[${bm}]`
                    )),
                    (this.initialized = !1),
                    this.anchor &&
                      ((this.triggerPoint = this.anchor.getAttribute(Sm)),
                      (this.scrollCallback = () => this.onScroll()),
                      (this.toggleScrollObserver =
                        this.toggleScrollObserver.bind(this)),
                      this.init());
                }
              })(this.container, e)
            );
          });
    },
    onUnload() {
      Lm[this.id].forEach((t) => {
        "function" == typeof t.onUnload && t.onUnload();
      });
    },
  };
  fo("sidebar", [gm, km]);
  const Am = "[data-hover-target]",
    Tm = "[data-collection-image]",
    Cm = "data-hover-target",
    qm = "is-visible",
    xm = "is-selected";
  let Mm = {};
  fo("collections-hover", [
    {
      onLoad() {
        Mm[this.id] = new (class {
          init() {
            this.buttons.length &&
              this.buttons.forEach((t) => {
                t.addEventListener("mouseenter", (t) => {
                  const e = t.currentTarget.getAttribute(Cm);
                  this.updateState(e);
                });
              });
          }
          updateState(t) {
            const e = this.container.querySelector(`[${Cm}="${t}"]`),
              s = this.container.querySelector(`#${t}:not(.${qm})`),
              i = this.container.querySelector(`${Am}.${xm}`),
              o = this.container.querySelector(`${Tm}.${qm}`);
            s &&
              y() &&
              (null == o || o.classList.remove(qm),
              null == i || i.classList.remove(xm),
              s.classList.add(qm),
              e.classList.add(xm));
          }
          onBlockSelect(t) {
            this.updateState(t.target.id);
          }
          constructor(t) {
            (this.container = t.container),
              (this.buttons = this.container.querySelectorAll(Am)),
              this.init();
          }
        })(this);
      },
      onBlockSelect(t) {
        Mm[this.id].onBlockSelect(t);
      },
    },
    km,
  ]);
  const Pm = "[data-featured-image]",
    Hm = "[data-featured-aside]",
    Im = "[data-featured-content]",
    Bm = "[data-featured-wrapper]",
    Om = "data-horizontal-scroll",
    Fm = "data-horizontal-scroll-reversed",
    Dm = {};
  fo("featured-product", [
    {
      onLoad() {
        Dm[this.id] = new (class {
          init() {
            this.horizontalScroll &&
              this.imagesHolder &&
              ((this.requestAnimationSticky = requestAnimationFrame(
                this.calculateHorizontalPositionEvent
              )),
              document.addEventListener("theme:scroll", this.scrollEvent)),
              this.wrapper &&
                this.contentHolder &&
                this.images.length &&
                (this.calculateHeight(),
                document.addEventListener(
                  "theme:resize:width",
                  this.calculateHeightEvent
                ));
          }
          scrollEvents() {
            this.requestAnimationSticky ||
              (this.requestAnimationSticky = requestAnimationFrame(
                this.calculateHorizontalPositionEvent
              ));
          }
          removeAnimationFrame() {
            this.requestAnimationSticky &&
              (cancelAnimationFrame(this.requestAnimationSticky),
              (this.requestAnimationSticky = null));
          }
          calculateHorizontalPosition() {
            let t = window.scrollY + this.headerHeight;
            const e = t + window.innerHeight,
              s = this.imagesHolder.offsetTop,
              i = this.imagesHolder.offsetHeight,
              o = s + i + this.headerHeight,
              n = i - (window.innerHeight - this.headerHeight),
              r = this.horizontalScrollReversed ? 1 : -1;
            let a = 0;
            (a = t >= s && e <= o ? ((t - s) / n) * 100 : t < s ? 0 : 100),
              (a *= this.images.length - 1),
              this.container.style.setProperty("--translateX", a * r + "%"),
              this.lastPercent !== a
                ? (this.requestAnimationSticky = requestAnimationFrame(
                    this.calculateHorizontalPositionEvent
                  ))
                : this.requestAnimationSticky && this.removeAnimationFrame(),
              (this.lastPercent = a);
          }
          calculateHeight() {
            let { stickyHeaderHeight: t } = c();
            this.container.style.removeProperty("--min-height"),
              this.container.style.setProperty(
                "--min-height",
                `${
                  this.wrapper.offsetHeight + this.contentHolder.offsetHeight
                }px`
              ),
              (this.headerHeight = t);
          }
          onUnload() {
            this.horizontalScroll &&
              this.imagesHolder &&
              document.removeEventListener(
                "theme:scroll",
                this.calculateHorizontalPositionEvent
              ),
              this.wrapper &&
                this.contentHolder &&
                this.images.length &&
                document.removeEventListener(
                  "theme:resize:width",
                  this.calculateHeightEvent
                );
          }
          constructor(t) {
            (this.container = t.container),
              (this.horizontalScroll = this.container.hasAttribute(Om)),
              (this.horizontalScrollReversed = this.container.hasAttribute(Fm)),
              (this.images = this.container.querySelectorAll(Pm)),
              (this.imagesHolder = this.container.querySelector(Hm)),
              (this.contentHolder = this.container.querySelector(Im)),
              (this.wrapper = this.container.querySelector(Bm)),
              (this.requestAnimationSticky = null),
              (this.lastPercent = 0),
              (this.scrollEvent = () => this.scrollEvents()),
              (this.calculateHorizontalPositionEvent = () =>
                this.calculateHorizontalPosition()),
              (this.calculateHeightEvent = () => this.calculateHeight()),
              this.init();
          }
        })(this);
      },
      onUnload(t) {
        Dm[this.id].onUnload(t);
      },
    },
  ]);
  const $m = "[data-timeline-holder]",
    _m = "[data-timeline-row]",
    Nm = "[data-timeline-row-editor]",
    Rm = "[data-timeline-button]",
    Um = "[data-header-sticky]",
    zm = "[data-header-height]",
    Wm = "is-selected",
    Vm = {};
  fo("timeline", [
    {
      onLoad() {
        Vm[this.id] = new (class {
          init() {
            this.calculateRowsHeight(),
              (this.requestAnimation = requestAnimationFrame(() =>
                this.calculatePosition()
              )),
              document.addEventListener("theme:scroll", this.scrollEvent),
              document.addEventListener("theme:resize:width", this.resizeEvent),
              this.buttons.length &&
                this.buttons.forEach((t, e) => {
                  t.addEventListener("click", (t) => {
                    t.preventDefault();
                    const s = t.currentTarget.closest(_m);
                    if (!s) return;
                    const i = Math.max(...this.rowsHeight),
                      o = this.holderHeight / this.rows.length,
                      n = this.holder.getBoundingClientRect().top,
                      r = e > 0 && i < o ? o * e + n : n,
                      a = y() ? r + 1 : s.getBoundingClientRect().top;
                    nn(a);
                  });
                });
          }
          resizeEvents() {
            (this.holderTop =
              this.holder.getBoundingClientRect().top + window.scrollY),
              (this.holderHeight = this.holder.offsetHeight),
              this.calculateRowsHeight(),
              (this.requestAnimation = requestAnimationFrame(() =>
                this.calculatePosition()
              ));
          }
          scrollEvents() {
            this.requestAnimation ||
              (this.requestAnimation = requestAnimationFrame(() =>
                this.calculatePosition()
              ));
          }
          removeAnimationFrame() {
            this.requestAnimation &&
              (cancelAnimationFrame(this.requestAnimation),
              (this.requestAnimation = null));
          }
          calculateRowsHeight() {
            if (this.rows.length) {
              this.rowsHeight = [];
              let t = 0;
              this.rows.forEach((e, s) => {
                if (
                  (this.rowsHeight.push(e.offsetHeight),
                  window.Shopify.designMode)
                ) {
                  const n = this.container.querySelectorAll(Nm);
                  var i, o;
                  n.length &&
                    ((t += e.offsetHeight),
                    null === (i = n[s]) ||
                      void 0 === i ||
                      i.style.setProperty(
                        "--row-height-min",
                        `${e.offsetHeight}px`
                      ),
                    null === (o = n[s + 1]) ||
                      void 0 === o ||
                      o.style.setProperty("--row-top-mobile", `${t}px`));
                }
              });
            }
          }
          calculatePosition() {
            let t = window.scrollY;
            const e = window.innerHeight,
              s = t + e;
            if (
              (this.removeAnimationFrame(),
              s < this.holderTop || s > this.holderTop + this.holderHeight + e)
            )
              return;
            const i = y(),
              o = this.holderHeight / this.rows.length;
            let n = this.holderTop,
              r = null;
            if (!i) {
              const s =
                document.querySelector(Um) && document.querySelector(zm)
                  ? document.querySelector(zm).getBoundingClientRect().height
                  : 0;
              t += s;
              const i = e - s,
                o = this.holderHeight - i,
                n = o > 0 ? o : this.holderHeight / 2,
                a = o > 0 ? i : this.holderHeight / 2,
                l = ((t - this.holderTop) / n) * 100;
              (r = t + (a * l) / 100),
                this.holder.style.setProperty("--percent-mobile", `${l}%`);
            }
            this.rows.forEach((t, e) => {
              if (e > 0) {
                const e = i
                  ? n + o < s
                  : r + 1 > t.getBoundingClientRect().top + window.scrollY;
                var a;
                n - o < s &&
                  i &&
                  (null === (a = t.previousElementSibling) ||
                    void 0 === a ||
                    a.style.setProperty(
                      "--percent-desktop",
                      ((s - n) / o) * 100 + "%"
                    )),
                  t.classList.toggle(Wm, e);
              }
              n += o;
            });
          }
          onUnload() {
            document.removeEventListener("theme:scroll", this.scrollEvent),
              document.removeEventListener(
                "theme:resize:width",
                this.resizeEvent
              );
          }
          constructor(t) {
            (this.container = t.container),
              (this.rows = this.container.querySelectorAll(_m)),
              (this.holder = this.container.querySelector($m)),
              this.rows.length < 2 ||
                !this.holder ||
                ((this.rowsHeight = []),
                (this.holderTop =
                  this.holder.getBoundingClientRect().top + window.scrollY),
                (this.holderHeight = this.holder.offsetHeight),
                (this.buttons = this.container.querySelectorAll(Rm)),
                (this.requestAnimation = null),
                (this.scrollEvent = () => this.scrollEvents()),
                (this.resizeEvent = () => this.resizeEvents()),
                this.init());
          }
        })(this);
      },
      onUnload(t) {
        Vm[this.id].onUnload(t);
      },
    },
  ]),
    document.addEventListener("DOMContentLoaded", function () {
      yo("*");
      const t = document.querySelector("[data-scroll-top-button]");
      t &&
        (t.addEventListener("click", () => {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }),
        document.addEventListener("theme:scroll", () => {
          t.classList.toggle("is-visible", window.scrollY > window.innerHeight);
        })),
        window.self !== window.top &&
          document.querySelector("html").classList.add("iframe"),
        "scrollBehavior" in document.documentElement.style ||
          su({ url: window.theme.assets.smoothscroll });
    }),
    window.navigator.cookieEnabled &&
      (document.documentElement.className =
        document.documentElement.className.replace(
          "supports-no-cookies",
          "supports-cookies"
        ));
})(
  themeVendor.ScrollLock,
  themeVendor.themeAddresses,
  themeVendor.themeCurrency,
  themeVendor.Rellax,
  themeVendor.Flickity,
  themeVendor.FlickityFade,
  themeVendor.themeImages
);

document.addEventListener("DOMContentLoaded", function () {
    function updateVariantRating(variantId) {
        fetch(`/products/${window.location.pathname.split('/').pop()}.js`)
            .then(response => response.json())
            .then(product => {
                let selectedVariant = product.variants.find(variant => variant.id == variantId);

                if (selectedVariant) {
                    let ratingValue = selectedVariant.metafields?.reviews?.rating?.value || "4.9";
                    let reviewCount = selectedVariant.metafields?.reviews?.count || "749";

                    // Update the rating text dynamically
                    document.getElementById("dynamic-rating-value").innerText = `${parseFloat(ratingValue).toFixed(1)}/5`;
                    document.getElementById("dynamic-review-count").innerText = `${reviewCount}+ reviews`;
                }
            });
    }

    // Detect changes in radio buttons (for size, metal, etc.)
    document.querySelectorAll(".variant-option").forEach(function (radioButton) {
        radioButton.addEventListener("change", function () {
            let selectedVariantInput = document.querySelector("input[name='id']:checked");
            if (selectedVariantInput) {
                updateVariantRating(selectedVariantInput.value);
            }
        });
    });

    // Also detect dropdown-based variant selection (if applicable)
    document.querySelectorAll("select[name='id']").forEach(function (variantSelector) {
        variantSelector.addEventListener("change", function () {
            updateVariantRating(this.value);
        });
    });
});
